// Translations for German, English, and French
export const translations = {
  de: {
    // Featured upcoming events (object keyed by event id)
    featuredEvents: {
      juniorCamp: {
        accent: "blue",
        image: "https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/9repnipw_Junior%20Padel%20Camp%20Weihnachtsferien%20-%20Print%20-%20Flyer.png",
        alt: "PAW Lions Junior Padel Camp — Weihnachtsferien 21.–24. Dezember 2026",
        badge: "Junior Camp · 21.–24. Dez.",
        title: "PAW Lions Junior Padel Camp",
        matchup: "Weihnachtsferien in der Padelarena — jeden Tag von 9:00 bis 12:00, Welcome Package & Snacks inklusive, Trainer vor Ort für alle Levels.",
        dateLabel: "Daten",
        dateValue: "21.–24. Dezember 2026",
        timeLabel: "Zeit",
        timeValue: "09:00 – 12:00",
        priceLabel: "Preis",
        priceValue: "CHF 299 · Welcome Package & Snacks inkl.",
        reserveBadge: "Jetzt anmelden",
        reserveText: "Plätze sind limitiert – melde dein Kind per E-Mail an info@padelarena.ch oder via WhatsApp an.",
        emailTo: "info@padelarena.ch",
        emailSubject: "Junior Padel Camp — Anmeldung (21.–24. Dez.)",
        emailCta: "info@padelarena.ch",
        waCta: "Anmeldung via WhatsApp",
        waText: "Hallo! Ich möchte mein Kind für das PAW Lions Junior Padel Camp (21.–24. Dezember, 9:00–12:00) anmelden."
      },
      wmOpening: {
        accent: "red",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png",
        alt: "WM Opening — Schweiz gegen Katar — live im Padelarena Wädenswil Sports Bar",
        badge: "Live im Sports Bar · 13. Juni",
        title: "WM Opening — Schweiz gegen Katar",
        matchup: "Together. Louder. Switzerland. Ein Spiel. Ein Land. Ein Moment.",
        dateLabel: "Datum",
        dateValue: "Samstag, 13. Juni",
        timeLabel: "Start",
        timeValue: "21:00",
        reserveBadge: "Reservierung erforderlich!",
        reserveText: "Begrenzte Plätze – bitte vorab anrufen, um einen Tisch zu reservieren: +41 43 833 0834.",
        waCta: "Reservierung via WhatsApp",
        waText: "Hallo! Ich möchte gerne einen Tisch für das WM Opening (Schweiz – Katar, Sa 13. Juni, 21:00) reservieren."
      },
      frauenSocial: {
        accent: "pink",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/pvm3s2px_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%284%29.png",
        alt: "Frauen Social — Padel, Community, Good Vibes — Samstag 20. Juni in der Padelarena Wädenswil",
        badge: "Nur für Frauen · 20. Juni",
        title: "Frauen Social — Ein Abend für uns",
        matchup: "Padel. Community. Good Vibes. Meldet euch als Team an!",
        dateLabel: "Datum",
        dateValue: "Samstag, 20. Juni",
        timeLabel: "Uhrzeit",
        timeValue: "16:00 – ca. 18:30",
        priceLabel: "Preis",
        priceValue: "50 CHF pro Person · inkl. Prosecco & Snacks",
        reserveBadge: "Als Team anmelden",
        reserveText: "Plätze sind limitiert – meldet euch direkt als Team an unter +41 43 833 0834 oder via WhatsApp.",
        waCta: "Anmeldung via WhatsApp",
        waText: "Hallo! Wir möchten uns für das Frauen Social am Samstag 20. Juni (16:00–18:30) als Team anmelden."
      },
      lastTime: {
        accent: "blue",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/3nv5m3bc_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%289%29.png",
        alt: "One Last Time Under The Old Roof — Abschiedsturnier in der Padelarena Wädenswil am Sonntag 28. Juni",
        badge: "Abschiedsturnier · 28. Juni",
        title: "One Last Time — Under The Old Roof",
        matchup: "Farewell to the Old Roof Tournament. Ein letztes Mal zusammen — let's make it unforgettable.",
        dateLabel: "Datum",
        dateValue: "Sonntag, 28. Juni",
        timeLabel: "Uhrzeit",
        timeValue: "15:30 – ca. 20:00",
        priceLabel: "Preis",
        priceValue: "50 CHF pro Person · inkl. Apéro & Drinks",
        reserveBadge: "Als Team anmelden",
        reserveText: "Sign up now as a team! Plätze sind limitiert – meldet euch unter +41 43 833 0834 oder via WhatsApp.",
        waCta: "Anmeldung via WhatsApp",
        waText: "Hallo! Wir möchten uns als Team für das One Last Time Abschiedsturnier am Sonntag 28. Juni (15:30–20:00) anmelden."
      }
    },
    // Navigation
    nav: {
      about: "Über Uns",
      facilities: "Anlagen",
      courts: "Plätze",
      services: "Dienstleistungen",
      pricing: "Preise",
      academy: "Academy",
      events: "Events",
      contact: "Kontakt",
      bookNow: "Jetzt Buchen"
    },
    // Hero Section
    hero: {
      title: "Willkommen bei Padelarena",
      subtitle: "Die Padel-Arena mit den besten Vibes und Community in Wädenswil",
      description: "8 Indoor-Plätze • 2 Golf-Simulatoren • Sports Bar • Top Junior Akademie",
      bookCourt: "Platz Reservieren",
      learnMore: "Mehr Erfahren"
    },
    // About Section
    about: {
      title: "Über Padelarena",
      subtitle: "Die Padel-Arena mit der besten Community der Schweiz",
      ogBadge: "Beste Vibes & Community der Schweiz",
      description: "Padelarena Wädenswil ist das erste Indoor-Padel-Center der Schweiz. Seit 2017 prägen wir den Padelsport im Land – mit 8 Indoor-Plätzen, einer führenden Junior-Akademie, zwei Golf-Simulatoren und einer Sports Bar mit 9 TVs für alle grossen TV-Momente. Nur 20 Minuten von Zürich entfernt sind wir bekannt für unsere unschlagbare Atmosphäre und der besten Community der Schweiz.",
      communityText: "Die Padelarena ist mehr als eine Anlage – sie ist eine Community. Hunderte aktive Spielerinnen und Spieler, wöchentliche Mixings, Turniere, Junior-Camps und eine Sports Bar, die nach dem Spiel zum zweiten Wohnzimmer wird. Werde Teil davon.",
      bookCourtBtn: "Platz Buchen",
      joinCommunityBtn: "Community beitreten",
      sportsBarBtn: "Sports Bar entdecken",
      feature1Title: "8 Indoor-Plätze",
      feature1Desc: "Professionelle Padel-Plätze mit optimaler Beleuchtung",
      feature2Title: "Top Junior Akademie",
      feature2Desc: "60+ Kinder mit 3 Vollzeit-Trainern",
      feature3Title: "Ganzjährig Geöffnet",
      feature3Desc: "Indoor-Anlage für Training bei jedem Wetter"
    },
    // Court Availability
    courtAvailability: {
      title: "Live Platzverfügbarkeit",
      subtitle: "Echtzeit-Status unserer 8 Indoor-Plätze",
      liveBadge: "LIVE",
      availableNow: "Jetzt frei",
      availableNext2h: "Frei in 2h",
      padelCourts: "Padel-Plätze",
      golfSims: "Golf-Sim.",
      golfSim: "Golf-Simulator",
      todayTimeline: "Heute verfügbare Zeitfenster",
      tomorrowTimeline: "Morgen verfügbar",
      courtsShort: "Plätze",
      golfShort: "Golf",
      bookSlot: "Diesen Slot Buchen",
      upTo: "Bis zu",
      fewLeft: "Wenige",
      full: "Voll",
      eveningFullNotice: "Heute Abend ist leider alles ausgebucht. Schau morgen oder buche einen früheren Slot.",
      dayFinished: "Der Spieltag ist vorbei — buche einen Platz für morgen.",
      bookTomorrow: "Für Morgen Buchen",
      free: "Frei",
      busy: "Belegt",
      indoor: "Indoor",
      outdoor: "Outdoor",
      nextFree: "Nächster freier Slot",
      bookedAllDay: "Heute ausgebucht",
      lastUpdated: "Zuletzt aktualisiert",
      errorMsg: "Platzverfügbarkeit kann momentan nicht geladen werden. Bitte versuch es direkt in der Buchungsplattform.",
      comingSoon: "Coming Soon",
      comingSoonTitle: "Bald Verfügbar!",
      comingSoonDesc: "Wir arbeiten daran, Ihnen die Live-Verfügbarkeit unserer Plätze in Echtzeit anzuzeigen. In der Zwischenzeit kannst du telefonisch buchen oder unsere Online-Buchungsplattform nutzen.",
      phoneBooking: "Telefonisch: +41 43 833 0834",
      onlineBooking: "Online Buchen",
      court: "Platz",
      available: "Verfügbar",
      occupied: "Belegt",
      maintenance: "Wartung",
      availableIn: "Verfügbar in",
      minutes: "Minuten",
      refresh: "Aktualisieren",
      bookThisCourt: "Diesen Platz Buchen"
    },
    // Facilities
    facilities: {
      title: "Unsere Anlagen",
      subtitle: "Erstklassige Einrichtungen für ein perfektes Padel-Erlebnis",
      showcaseTitle: "Erstklassige Infrastruktur",
      showcaseSubtitle: "Erlebe modernste Padel-Anlagen mit professioneller Ausstattung",
      showcaseLabel: "UNSERE ANLAGE",
      exploreCta: "Mehr erfahren",
      courts: "8 Indoor Padel-Plätze",
      courtsDesc: "Professionelle Plätze mit optimaler Beleuchtung und Klimaanlage",
      golf: "2 Golf-Simulatoren",
      golfDesc: "Hochmoderne Golf-Simulatoren für das ganze Jahr",
      bar: "Sports Bar & Lounge",
      barDesc: "9 TVs mit allen Top-Live-Sports — Champions League, Hockey, Tennis, Padel und mehr. Beste Vibes vor und nach dem Spiel.",
      lounge: "Lounge-Bereich",
      loungeDesc: "Gemütlicher Bereich zum Relaxen und Networking",
      shop: "Pro Shop",
      shopDesc: "Komplette Ausrüstung und Schlägerverleih verfügbar"
    },
    // Services
    services: {
      title: "Unsere Dienstleistungen",
      subtitle: "Professionelle Programme für alle Spielstufen",
      label: "DIENSTLEISTUNGEN",
      training: "Padel-Training",
      trainingDesc: "Einzel- und Gruppenkurse für alle Niveaus mit zertifizierten Trainern",
      academy: "Junior Akademie",
      academyDesc: "60+ Kinder trainieren mit 3 Vollzeit-Trainern",
      tournaments: "Turniere & Events",
      tournamentsDesc: "Regelmässige Turniere und spezielle Events für die Community",
      camps: "Padel-Camps",
      campsDesc: "Intensive Trainingscamps während der Schulferien"
    },
    // Trainers
    trainers: {
      title: "Unsere Trainer",
      subtitle: "Professionelles Team von zertifizierten Trainern",
      meet: "Lerne unser Team kennen",
      experience: "Erfahrung",
      specialty: "Spezialität",
      academyDirector: "Academy Direktor",
      coach: "Coach",
      cpo: "CPO - Chief Padel Officer",
      cngo: "CNGO - Chief NextGen Officer",
      academyLeadership: "Academy Leitung",
      nextGenTraining: "Junior & Erwachsene",
      professionalTraining: "Junior & Erwachsene",
      viewBio: "Bio ansehen"
    },
    // Coach Page
    coachPage: {
      back: "Zurück",
      backHome: "Zur Startseite",
      notFound: "Coach nicht gefunden",
      bookTraining: "Training anfragen",
      aboutHeading: "Über",
      highlights: "Highlights",
      languages: "Sprachen",
      otherCoaches: "Weitere Trainer",
      bioComingSoon: "Bio folgt in Kürze – wir warten auf Details vom Coach."
    },
    coachBios: {
      "fabrizio-pavez": {
        paragraphs: [
          "Begeistert von Sportwissenschaft, Biomechanik und funktioneller Bewegung im Padel. Als Academy Director entwickle ich dynamische, methodisch aufgebaute Trainingsprogramme, die Leistung optimieren und Verletzungen durch Mobilität, Stabilität und funktionelle Belastbarkeit vorbeugen.",
          "Ich habe fundierte Erfahrung in der Entwicklung sowohl aufstrebender Spieler als auch von Hochleistungsathleten – darunter Junioren, die für die Schweizer Nationalmannschaft auf europäischer Ebene selektioniert wurden. Zudem bin ich Autor meines eigenen technischen Padel-Buchs und habe spezialisierte Seminare und Workshops in verschiedenen Clubs geleitet, um diese Methodik zu teilen."
        ],
        highlights: [
          "Academy Director",
          "Spezialist für Sportwissenschaft & Biomechanik",
          "Autor eines technischen Padel-Buchs",
          "Junioren in die Schweizer Nationalmannschaft entwickelt"
        ],
        languages: ["Spanisch", "Englisch"]
      },
      "antoine-laurent": {
        paragraphs: [
          "Hi, ich bin Antoine, 29, ursprünglich aus Frankreich. Leistungssport war schon immer in meiner DNA. Dieser Antrieb nach Exzellenz hat mich 2023 zur Zertifizierung als Padel-Coach und Sportdirektor geführt, gefolgt von einer spezialisierten Ausbildung in Spanien.",
          "Nach einem Jahr im Sportmanagement und Coaching in Frankreich und einem weiteren Jahr Coaching in der Schweiz habe ich einen umfassenden und individuellen Trainingsansatz entwickelt. Auf dem Platz kombiniere ich High-Level-Rigor mit dem freundschaftlichen Padel-Spirit, damit jeder Spieler Fortschritte macht und maximalen Spass hat. Bis bald auf dem Court!"
        ],
        highlights: [
          "Zertifizierter Padel-Coach & Sportdirektor (2023)",
          "Spezialausbildung in Spanien",
          "Aus Frankreich, in der Schweiz zuhause",
          "Verbindet High-Level-Anspruch mit Padel-Spass"
        ],
        languages: ["Französisch", "Englisch", "Spanisch"]
      },
      "alejandro-nieuwenhuis": {
        paragraphs: [
          "Hi, ich bin Alex, 25, aus Valencia, Spanien. Ich bin mit Sport aufgewachsen und habe ein Sportstudium absolviert, bevor ich überhaupt wusste, in welche Richtung es gehen soll. Nach einigen Jahren Tennis bin ich zu Padel gewechselt – der Sport hat sofort geklickt, und schon nach einem Jahr habe ich in Valencia Turniere gespielt.",
          "Seit 2020 unterrichte ich parallel zu meinem Spielbetrieb, erst in Spanien und jetzt in Wädenswil. Freu mich darauf, dich auf dem Platz zu sehen – lass uns zusammen wachsen!"
        ],
        highlights: [
          "Aus Valencia, Spanien",
          "Sportstudium abgeschlossen",
          "Aktiver Turnierspieler seit 2020",
          "Erfahrener Trainer für Junioren & Erwachsene"
        ],
        languages: ["Spanisch", "Englisch"]
      }
    },
    // Per-page SEO meta (title/description/keywords) — DE
    seo: {
      sportsBar: {
        title: "Sports Bar Wädenswil – 9 TVs, Live Champions League, Eishockey & Premier Padel | Padelarena",
        description: "Die Sports Bar in Wädenswil mit 9 TVs zeigt Champions League, Schweizer Super League, Swiss National League Eishockey, Tennis Grand Slams und Premier Padel live. Pizza, Flammkuchen, Chnoblibrot, Bier vom Fass und Wein – nur 20 Min. von Zürich.",
        keywords: "Sports Bar Wädenswil, Sportbar Zürichsee, Champions League schauen Zürich, Swiss National League schauen, Live Sport Bar Wädenswil, Public Viewing Wädenswil, Pizza Wädenswil, Flammkuchen Zürichsee, Lounge Wädenswil"
      },
      events: {
        title: "Firmenevents, Familien-Aktivitäten & Geburtstage in Wädenswil | Padelarena",
        description: "Padelarena Wädenswil – die Top-Location für Firmenanlässe, Teambuildings, Wochenend-Aktivitäten für Familien mit Kindern, Padel-Turniere und Geburtstagsfeiern (Erwachsene & Kids). 8 Indoor-Plätze, Sports Bar mit 9 TVs, Catering und Golf-Simulator unter einem Dach.",
        keywords: "Firmenevent Wädenswil, Teambuilding Zürich, Familien-Aktivität Wochenende Zürich, Indoor-Aktivität mit Kindern Zürich, Geburtstag Kinder Wädenswil, Padel Turnier Schweiz, Geburtstagsfeier Wädenswil, Eventlocation Zürichsee, Kindergeburtstag Padel Zürich, Wochenende mit Kindern Zürichsee"
      },
      courts: {
        title: "8 Indoor Padel Courts in Wädenswil – Online buchen | Padelarena",
        description: "8 vollausgestattete Indoor-Padel-Plätze in Wädenswil. Ganzjährig spielbar, professionelle LED-Beleuchtung, Online-Buchung 24/7. Nur 20 Min. von Zürich.",
        keywords: "Padel Wädenswil, Padel Plätze Zürich, Indoor Padel Schweiz, Padel buchen Zürichsee, Padel Court mieten Wädenswil"
      },
      golf: {
        title: "Indoor Golf Simulator in Wädenswil – ganzjährig spielen | Padelarena",
        description: "Zwei moderne Indoor-Golf-Simulatoren in der Padelarena Wädenswil. Top-Plätze der Welt, Schläger inklusive, Einzel- und Firmenbuchungen. 20 Min. von Zürich.",
        keywords: "Golf Simulator Wädenswil, Indoor Golf Zürich, Trackman Zürichsee, Golf Halle Schweiz, Golf Indoor buchen"
      },
      proShop: {
        title: "Padel Pro Shop Wädenswil – Head, Babolat, Nox & Padlr | Padelarena",
        description: "Padel-Schläger von Head, Babolat und Nox vor dem Kauf direkt auf dem Platz testen. Plus unsere eigene Padlr Clothing-Linie. Pro Shop in der Padelarena Wädenswil.",
        keywords: "Padel Shop Wädenswil, Padel Schläger kaufen Schweiz, Head Padel Schläger, Babolat Padel, Nox Padel Schläger, Padlr Clothing"
      },
      academy: {
        title: "Padel Junior Academy Wädenswil – Padel für Kinder ab 4 Jahren | Padelarena",
        description: "Die führende Padel Junior Academy der Schweiz. 60+ aktive Kinder, 3 Vollzeit-Trainer, 4 Altersgruppen ab 4 Jahren. Kostenlose Probelektion buchbar – ideal als Wochenend-Aktivität für Familien mit Kindern. Wädenswil, 20 Min. von Zürich.",
        keywords: "Padel für Kinder Zürich, Padel Junior Academy Schweiz, Padel Probelektion Kinder, Mini Padel Wädenswil, Junior Padel Training Zürich, Kinder Sport Wädenswil, Padel Schule Zürichsee, Padel Kinder Geburtstag Zürich, Familien-Aktivität Wochenende, Indoor-Sport Kinder Wädenswil, Padelschule Zürich, Padel Kids Camp Schweiz"
      }
    },
    // Courts Page
    courtsPage: {
      label: "PADEL PLÄTZE",
      titleStart: "8 Indoor Doubles",
      titleAccent: "Plätze",
      subtitle: "Modernste Padel-Plätze, ganzjährig spielbar – direkt am Zürichsee.",
      aboutTitle: "Unsere Plätze",
      about1: "8 voll überdachte Indoor Doubles Plätze mit professioneller LED-Beleuchtung, Panorama-Glas und High-Performance-Boden. Optimal für Spiel, Training und Turniere – bei jedem Wetter.",
      about2: "Jeder Platz ist online buchbar in 60-, 90- oder 120-Minuten-Slots. Schlägerverleih für 5 CHF pro Schläger und Bälle direkt vor Ort – Hallenschuhe bitte mitbringen.",
      statCourts: "Indoor Plätze",
      statIndoor: "Überdacht",
      statHours: "Mo-Fr Stunden",
      statRacket: "Pro Schläger",
      statSlot: "Min. pro Slot",
      hoursTitle: "Öffnungszeiten",
      hoursWeekday: "Mo – Fr",
      hoursWeekend: "Sa – So",
      includedTitle: "Inklusive bei jeder Buchung",
      galleryTitle: "Blick in die Halle",
      included: [
        "Voll ausgestatteter Indoor-Platz",
        "Professionelle LED-Beleuchtung",
        "Bälle inklusive",
        "Schlägerverleih: 5 CHF pro Schläger",
        "Garderoben mit Duschen",
        "Sports Bar nach dem Spiel"
      ],
      bookCta: "Platz Reservieren",
      viewPricing: "Preise ansehen",
      faqTitle: "Häufige Fragen zum Padel in Wädenswil",
      faqs: [
        { q: "Wie kann ich einen Padel-Platz in Wädenswil buchen?", a: "Online via bookpadelarena.ch in 60-, 90- oder 120-Minuten-Slots, 24/7 verfügbar – oder ruf uns unter +41 43 833 0834 an." },
        { q: "Was kostet ein Padel-Platz in der Padelarena?", a: "Werktags vor 17:00 Uhr 58 CHF, ab 17:00 Uhr und am Wochenende 68 CHF pro Platz und Stunde. Schlägerverleih für 5 CHF, Bälle inklusive." },
        { q: "Brauche ich eigene Ausrüstung?", a: "Nein. Schläger kannst du für 5 CHF mieten, Bälle sind in der Buchung inklusive. Hallenschuhe mit weicher Sohle reichen." },
        { q: "Wie weit ist die Padelarena Wädenswil von Zürich entfernt?", a: "Etwa 20 Minuten mit dem Auto oder S-Bahn (S2) ab Zürich HB. Ideal für Spieler aus Zürich, Horgen, Thalwil, Pfäffikon und Richterswil." },
        { q: "Was sind die Öffnungszeiten?", a: "Mo–Fr von 06:00 bis 24:00 Uhr, Sa–So von 08:00 bis 20:00 Uhr." }
      ]
    },
    // Golf Page
    golfPage: {
      label: "GOLF SIMULATOR",
      titleStart: "Golf das ganze",
      titleAccent: "Jahr",
      subtitle: "Spiele auf Top-Plätzen der Welt – Indoor in Wädenswil.",
      aboutTitle: "Unsere Golf-Simulatoren",
      about1: "Unsere zwei Golf-Simulatoren bringen die schönsten Plätze der Welt zu Ihnen – egal ob bei Schnee oder Regen. Realistisches Feedback, präzise Schlaganalyse und echtes Spielgefühl.",
      about2: "Perfekt für Trainingseinheiten, Familien-Spass oder Firmen-Events. Buchen pro Stunde – Schläger inklusive.",
      featuresTitle: "Was du bekommst",
      features: [
        "2 hochmoderne Indoor-Simulatoren",
        "100+ Top-Plätze weltweit",
        "Schläger inklusive",
        "Ideal für Anfänger & Profis",
        "Auch für Firmen-Events buchbar"
      ],
      bookCta: "Golf Buchen",
      callToBookTitle: "Golf-Simulator buchen",
      callToBookText: "Die Online-Buchung für den Golf-Simulator ist gerade nicht verfügbar. Ruf uns einfach an oder schreib uns via WhatsApp – wir reservieren dir gerne einen Slot.",
      callToBookWaCta: "Buchung via WhatsApp",
      callToBookWaText: "Hallo! Ich möchte gerne den Golf-Simulator buchen.",
      galleryTitle: "Blick in den Simulator",
      faqTitle: "Häufige Fragen zum Golf-Simulator",
      faqs: [
        { q: "Wie buche ich den Golf-Simulator?", a: "Aktuell ausschliesslich telefonisch unter +41 43 833 0834 oder via WhatsApp. Die Online-Buchung ist demnächst wieder verfügbar." },
        { q: "Wie funktioniert der Golf-Simulator?", a: "Du schlägst mit echten Schlägern echte Bälle in einen High-Speed-Tracker, der deinen Schwung präzise misst und auf der Leinwand auf Top-Plätzen weltweit umsetzt." },
        { q: "Brauche ich Erfahrung?", a: "Nein. Anfänger und Profis sind willkommen. Schläger sind inklusive – du brauchst nur saubere Hallenschuhe." },
        { q: "Wie viele Personen können gleichzeitig spielen?", a: "Bis zu 4 Personen pro Simulator. Ideal für Freundes- oder Firmenrunden." },
        { q: "Kann ich den Golf-Simulator für Firmenevents buchen?", a: "Ja, wir kombinieren Golf-Simulator, Padel-Plätze und Sports Bar zu einem unvergesslichen Firmenanlass. Kontaktiere uns für ein Angebot." }
      ]
    },
    // Pro Shop Page
    proShopPage: {
      label: "PRO SHOP",
      titleStart: "Pro",
      titleAccent: "Shop",
      subtitle: "Schläger zum Testen und Kaufen, dazu unsere Padlr Clothing Linie.",
      racketsTitle: "Schläger zum Testen & Kaufen",
      racketsIntro: "Bei uns kannst du die führenden Padel-Marken vor dem Kauf direkt auf dem Platz ausprobieren. Wir führen die aktuellen Modelle der Top-Marken:",
      headDesc: "Innovative Technologie, perfekte Balance – die Wahl vieler Pro-Spieler.",
      babolatDesc: "Französische Qualität mit kraftvollen Schlägern für jedes Niveau.",
      noxDesc: "Spanische Padel-Marke mit Top-Spielern wie Agustín Tapia.",
      clothingTitle: "Padlr Clothing",
      clothingDesc: "Unsere eigene Padlr Clothing-Linie: hochwertige Padel-Bekleidung für Training und Match. Direkt im Shop erhältlich.",
      visitTitle: "Im Shop vorbeischauen",
      visitDesc: "Komm vorbei und teste Schläger auf dem Platz oder lass dich von unserem Team beraten. Ruf uns gerne vorher an, damit wir dich persönlich betreuen können.",
      contactUs: "Kontakt aufnehmen",
      faqTitle: "Häufige Fragen zum Pro Shop",
      faqs: [
        { q: "Welche Padel-Marken führt ihr?", a: "Wir führen die aktuellen Modelle von Head, Babolat und Nox – plus unsere eigene Padlr Clothing-Linie für Trainings- und Match-Bekleidung." },
        { q: "Kann ich Schläger vor dem Kauf testen?", a: "Ja. Du kannst die Schläger direkt bei einem Spiel auf unseren Plätzen ausprobieren und entscheiden, welcher zu deinem Spiel passt." },
        { q: "Bietet ihr Beratung an?", a: "Ja, unser Team berät dich gerne basierend auf deinem Spielniveau und Spielstil. Ruf kurz an, dann nehmen wir uns Zeit für dich." }
      ]
    },
    // Events Page
    eventsPage: {
      label: "EVENTS",
      titleStart: "Events &",
      titleAccent: "private Anlässe",
      subtitle: "Turniere, Mixin Nights, Firmen- und Geburtstagsanlässe – alles unter einem Dach.",
      upcomingTitle: "Kommende Events",
      pausedBadge: "Wir sind zurück",
      pausedTitle: "Mixings & Events sind zurück!",
      pausedBody: "Padelarena öffnet am 19. September wieder. Das erste Mixing findet bereits am Dienstag, 22. September statt. Turniere, Frauen-Mixings, Social Events und Public Viewings sind alle wieder am Start.",
      pausedNote: "Courts: ab 19. September • Erstes Mixing: Dienstag, 22. September 2026.",
      signupHook: "Anmeldungen für Mixings & Events laufen ab sofort über unser neues Buchungssystem — bitte jede/r registrieren:",
      signupCta: "Zu Events anmelden",
      pausedCta: "Bleib in der WhatsApp-Community",
      upcomingPlaceholder: "Aktuelle Events werden bald hier angekündigt.",
      upcomingFollow: "Folge uns auf Instagram oder tritt unserer WhatsApp Community bei, um nichts zu verpassen.",
      privateTitle: "Private & Firmen-Events",
      privateIntro: "Egal ob Geburtstag, Firmenanlass oder Vereinsturnier – wir machen euren Event unvergesslich. Plätze, Sports Bar und volle Verpflegung exklusiv für deine Gruppe.",
      corporateTitle: "Firmen-Events",
      corporateDesc: "Teambuilding, Kundenanlässe oder Mitarbeiter-Turniere mit Padel, Golf-Simulator und Catering.",
      birthdayTitle: "Geburtstagsfeiern",
      birthdayDesc: "Für Kinder, Jugendliche und Erwachsene. Spass auf dem Platz mit Pizza und Getränken in der Bar.",
      tournamentTitle: "Eigene Turniere",
      tournamentDesc: "Wir organisieren dein Vereins- oder privates Turnier – inklusive Schiedsrichter und Preisverleihung.",
      ctaTitle: "Lust auf deinen eigenen Event?",
      ctaSubtitle: "Schreib uns oder ruf an – wir gestalten deinen Anlass nach Mass.",
      requestQuote: "Anfrage senden",
      faqTitle: "Häufige Fragen zu Events",
      faqs: [
        { q: "Wie viele Personen passen für ein Firmenevent in die Padelarena?", a: "Wir bieten Platz für 8 bis 60+ Personen – mit 8 Padel-Plätzen, 2 Golf-Simulatoren, Sports Bar und Lounge können wir gleichzeitig viele Gruppen aktivieren." },
        { q: "Bietet ihr Catering an?", a: "Ja, von Snacks und Pizza bis zu massgeschneidertem Catering – passend zu deinem Anlass und Budget." },
        { q: "Kann ich ein privates Padel-Turnier organisieren?", a: "Absolut. Wir übernehmen Spielplan, Schiedsrichter und Preisverleihung. Ideal für Vereine, Firmen oder Junggesellenfeiern." },
        { q: "Was eignet sich für eine Geburtstagsfeier?", a: "Padel-Spiel oder Golf-Simulator kombiniert mit Pizza und Getränken in der Sports Bar – beliebt bei Kindern, Jugendlichen und Erwachsenen." },
        { q: "Wie reserviere ich einen Event?", a: "Schick uns eine Anfrage über das Kontaktformular oder ruf unter +41 43 833 0834 an. Wir melden uns innerhalb eines Arbeitstags." }
      ]
    },
    // Sports Bar Page
    sportsBarPage: {
      label: "SPORTS BAR & LOUNGE",
      titleStart: "Sports Bar &",
      titleAccent: "Lounge",
      subtitle: "9 TVs, alle Top-Sports live, beste Vibes – das Herz der Padelarena.",
      aboutTitle: "Treffpunkt für Sport-Fans",
      about1: "Unsere Sports Bar mit 9 TVs ist der Treffpunkt vor und nach dem Spiel. Egal ob Champions League, NHL Hockey, Tennis Grand Slam oder Padel-Turnier – bei uns läuft immer das Spiel, das du sehen willst.",
      about2: "Der angeschlossene Lounge-Bereich ist perfekt zum Entspannen, Netzwerken oder einfach um den Tag mit Freunden ausklingen zu lassen. Snacks, Getränke und gute Stimmung garantiert.",
      statTvs: "TVs",
      statOpen: "Geöffnet",
      statLive: "Sport",
      statVibes: "Vibes",
      liveTitle: "Live im TV",
      liveSports: ["Champions League", "Premier League", "Bundesliga", "Schweizer Super League", "Swiss National League (Eishockey)", "NHL Hockey", "Tennis Grand Slams", "Premier Padel", "Formel 1", "Skifahren", "Fussball-WM/EM"],
      featuresTitle: "Was dich erwartet",
      features: [
        "9 grosse TVs mit Live-Sport rund um die Uhr",
        "Pizza, Flammkuchen und Chnoblibrot frisch aus dem Ofen",
        "Bier vom Fass, eine kleine Weinkarte und Softdrinks",
        "Lounge-Bereich zum Relaxen oder Netzwerken",
        "Perfekt vor oder nach dem Match",
        "Auch ohne Padel-Buchung herzlich willkommen"
      ],
      foodTitle: "Aus der Küche & Bar",
      featuredEventTitle: "Nächstes grosses Event",
      foodItems: ["Pizza", "Flammkuchen", "Chnoblibrot", "Snacks", "Bier vom Fass", "Wein", "Softdrinks", "Kaffee"],
      ctaTitle: "Vorbeischauen oder reservieren?",
      ctaSubtitle: "Meld dich kurz – wir reservieren gerne einen Tisch für dich und deine Crew.",
      privateBtn: "Private Events",
      faqTitle: "Häufige Fragen zur Sports Bar",
      faqs: [
        { q: "Welche Sportarten werden in der Sports Bar live übertragen?", a: "Auf unseren 9 TVs zeigen wir Champions League, Premier League, Bundesliga, Schweizer Super League, Swiss National League (Eishockey), NHL Hockey, Tennis Grand Slams, Premier Padel, Formel 1, Skirennen und alle grossen internationalen Turniere live." },
        { q: "Muss ich Padel spielen, um in der Sports Bar zu sein?", a: "Nein, alle sind willkommen. Du kannst einfach kommen, ein Spiel schauen, etwas essen und trinken – auch ohne Padel-Buchung." },
        { q: "Kann ich einen Tisch reservieren?", a: "Ja. Ruf uns unter +41 43 833 0834 an, besonders bei grossen Spielen oder Gruppen ab 6 Personen empfehlen wir eine Reservation." },
        { q: "Bietet ihr Speisen an?", a: "Wir servieren Pizza, Flammkuchen, Chnoblibrot und Snacks frisch aus dem Ofen. An der Bar gibt's Bier vom Fass, eine kleine Weinkarte, Softdrinks und Kaffee." },
        { q: "Wie sind die Öffnungszeiten der Sports Bar?", a: "Mo–Fr 06:00–24:00 Uhr, Sa–So 08:00–20:00 Uhr – die Sports Bar ist während der gesamten Padelarena-Öffnungszeiten zugänglich." }
      ]
    },
    // Pricing
    pricing: {
      title: "Preise",
      subtitle: "Transparente und faire Preisgestaltung",
      courtRates: "Platzmiete",
      weekdayBefore5: "Wochentags vor 17:00",
      weekdayAfter5: "Wochentags nach 17:00",
      weekend: "Wochenende (ganzer Tag)",
      afterFiveOrWeekend: "Nach 17:00 & Wochenende",
      price50: "50 CHF",
      price58: "58 CHF",
      price64: "64 CHF",
      price60: "60 CHF",
      price68: "68 CHF",
      perHour: "pro Stunde",
      perCourt: "pro Platz",
      racketRental: "Schlägerverleih: 5 CHF",
      juniorBadge: "Junior Academy",
      juniorTitle: "Möchtest du, dass deine Kids Padel ausprobieren?",
      juniorBody: "Egal ob blutige Anfänger oder schon mit Schläger in der Hand – die führende Junior Padel Academy der Schweiz hat das passende Programm. Probetrainings, Gruppen und Camps für Kinder ab 6 Jahren bis Jugendliche, mit professionellen Coaches und Saisonstart im September.",
      juniorPriceFrom: "Probeabos ab 399 CHF · Jahres-Abos ab 1'299 CHF",
      juniorCta: "Zur Junior Academy",
      trainingTitle: "Trainer Stunde Preisliste",
      trainingSubtitle: "Preis Pro Person",
      trainingIncludes: "Training inkl. Platz / Schläger / Bälle",
      before5: "Vor 17:00",
      after5Weekend: "Nach 17:00 & Sa/So",
      hour1: "1 Stunde",
      hour15: "1.5 Stunden",
      hour2: "2 Stunden",
      players1: "1 Spieler/in",
      players2: "2 Spieler/innen",
      players3: "3 Spieler/innen",
      players4: "4 Spieler/innen",
      privateLesson: "Einzeltraining",
      privateBefore5: "Vor 17:00 (Wochentags)",
      privateAfter5: "Nach 17:00 & Wochenende",
      price100: "100 CHF",
      price120: "120 CHF",
      price140: "140 CHF",
      groupLessons: "Gruppentraining",
      groupNote: "Preis pro Person sinkt mit Teilnehmerzahl",
      note: "Online-Buchung verfügbar"
    },
    // Gallery
    gallery: {
      title: "Galerie",
      subtitle: "Entdecke unsere erstklassigen Anlagen",
      label: "GALERIE"
    },
    // Sponsors
    sponsors: {
      title: "Unsere Partner",
      subtitle: "Stolze Partner der Padelarena Community",
      label: "PARTNER"
    },
    // Contact
    contact: {
      title: "Kontakt",
      subtitle: "Nimm Kontakt mit uns auf",
      label: "KONTAKT",
      address: "Adresse",
      addressLine: "Zugerstr. 162, 8820 Wädenswil, Schweiz",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Öffnungszeiten",
      hoursWeekday: "Mo-Fr: 06:00 - 00:00",
      hoursWeekend: "Sa-So: 08:00 - 20:00",
      formTitle: "Schick uns eine Nachricht",
      name: "Name",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon (optional)",
      message: "Nachricht",
      send: "Nachricht Senden",
      success: "Vielen Dank! Wir werden uns bald bei Ihnen melden.",
      error: "Ein Fehler ist aufgetreten. Bitte versuch es erneut."
    },
    // Newsletter
    newsletter: {
      title: "Newsletter Abonnieren",
      subtitle: "Bleib auf dem Laufenden über Events und Angebote",
      placeholder: "deine E-Mail-Adresse",
      subscribe: "Abonnieren",
      success: "Erfolgreich abonniert!",
      error: "Fehler beim Abonnieren. Bitte versuch es erneut."
    },
    // Footer
    footer: {
      description: "Die Padel-Arena mit den besten Vibes und Community in der Schweiz. 8 Plätze, 2 Golf-Simulatoren und führende Junior-Akademie.",
      quickLinks: "Schnelllinks",
      followUs: "Folge Uns",
      rights: "Alle Rechte vorbehalten.",
      realEstate: "Immobilien"
    },
    // Real Estate Page
    realEstate: {
      title: "Padelarena Immobilien",
      subtitle: "Dein Partner für Immobilien in der Region",
      description: "Als Teil der Padelarena-Community bieten wir Ihnen exklusive Unterstützung bei der Suche nach deiner Traumimmobilie oder beim Verkauf deiner Immobilie. Füll das Formular aus und unser Partner-Immobilienmakler wird sich mit Ihnen in Verbindung setzen.",
      formTitle: "Interesse bekunden",
      name: "Name",
      namePlaceholder: "Ihr vollständiger Name",
      email: "E-Mail",
      emailPlaceholder: "ihre.email@beispiel.com",
      phone: "Telefon",
      phonePlaceholder: "+41 79 123 45 67",
      interest: "Interesse",
      interestBuying: "Kaufen",
      interestSelling: "Verkaufen",
      interestPlaceholder: "Wähle dein Interesse",
      propertyType: "Immobilientyp",
      propertyHouse: "Haus",
      propertyApartment: "Wohnung",
      propertyLand: "Grundstück",
      propertyPlaceholder: "Wähle den Immobilientyp",
      budget: "Budget",
      budgetPlaceholder: "Wähle dein Budget",
      budget1to2: "1 – 2 Mio. CHF",
      budget2to3: "2 – 3 Mio. CHF",
      budgetOver3: "Über 3 Mio. CHF",
      location: "Standort/Region",
      locationPlaceholder: "z.B. Wädenswil, Zürich",
      message: "Nachricht (optional)",
      messagePlaceholder: "Teil uns weitere Details mit...",
      consent: "Ich stimme zu, dass meine Daten an den Partner-Immobilienmakler weitergegeben werden, der die weitere Kommunikation übernimmt. Ich habe die Datenschutzerklärung gelesen und akzeptiert.",
      submit: "Anfrage Senden",
      success: "Vielen Dank! Unser Partner wird sich in Kürze bei Ihnen melden.",
      error: "Ein Fehler ist aufgetreten. Bitte versuch es erneut.",
      privacyNotice: "deine Daten werden vertraulich behandelt und ausschliesslich zur Kontaktaufnahme durch unseren Partner-Immobilienmakler verwendet. Die weitere Kommunikation erfolgt direkt mit dem Makler.",
      requiredFields: "Alle Felder mit * sind Pflichtfelder"
    },
    // Facility Showcase
    facilityShowcase: {
      label: "UNSERE ANLAGE",
      titleStart: "Erstklassige",
      titleAccent: "Infrastruktur",
      subtitle: "Erlebe modernste Padel-Anlagen mit professioneller Ausstattung"
    },
    // WhatsApp Community
    whatsappCommunity: {
      title: "WhatsApp Community",
      subtitle: "Bleib auf dem Laufenden über Events, Turniere und exklusive Angebote",
      joinBtn: "Jetzt Beitreten"
    },
    // WhatsApp Bot Gate
    whatsappGate: {
      title: "WhatsApp öffnen",
      body: "Ein kurzer Klick zur Bestätigung – damit unsere Community frei von Bots bleibt.",
      confirm: "Ich bin ein Mensch – WhatsApp öffnen",
      cancel: "Abbrechen"
    },
    // Academy Page
    academyPage: {
      label: "PADEL ACADEMY",
      heroTitleStart: "Academy",
      heroTitleEnd: "& Training",
      heroSubtitle: "Die führende Padel-Academy der Schweiz mit 60+ aktiven Kids und 3 professionellen Vollzeit-Trainern",
      bookViaWhatsapp: "Training Buchen via WhatsApp",
      packagesLabel: "TRAINING PACKAGES",
      packagesTitleStart: "Unsere",
      packagesTitleAccent: "Trainings",
      packagesSubtitle: "Professionelles Training für alle Levels – vom Anfänger bis zum Profi",
      popular: "Beliebt",
      bookNow: "Jetzt Buchen",
      pkg1Title: "Einzeltraining",
      pkg1Desc: "1-zu-1 Coaching für schnellen technischen & taktischen Fortschritt",
      pkg1Duration: "Stunde",
      pkg1Feat1: "Persönliches 1-zu-1 Coaching",
      pkg1Feat2: "Flexible Termine, die zu deinem Zeitplan passen",
      pkg1Feat3: "Massgeschneiderte Drills & Spielplan-Fokus",
      pkg1PriceNote: "ab",
      pkg2Title: "Anfänger Training",
      pkg2Desc: "Montag & Donnerstag",
      pkg2Duration: "Person",
      pkg2Feat1: "Max. 4 Spieler auf dem Court",
      pkg2Feat2: "Analytische & spielbasierte Methodik",
      pkg2Feat3: "Equipment inklusive",
      pkg3Title: "Junior Academy",
      pkg3Desc: "Spezielles Programm für Kinder & Jugendliche",
      pkg3Duration: "3 Monate",
      pkg3Feat1: "Analytische & spielbasierte Methodik",
      pkg3Feat2: "Freizeit- oder Wettkampf-Fokus",
      pkg3Feat3: "Top Academy Schweiz",
      pkg3PriceNote: "ab",
      adultAcademy: {
        sectionLabel: "ADULT ACADEMY",
        sectionTitleStart: "Adult",
        sectionTitleAccent: "Academy",
        sectionSubtitle: "12-Wochen-Programm für Erwachsene – auf dein Level zugeschnitten.",
        programBadge: "12-Wochen-Programm",
        feat1: "1× pro Woche, feste Gruppe, feste Zeit",
        feat2: "Programm angepasst an dein Level",
        feat3: "Minimum 3 Spieler (max. 4)",
        beforeLabel: "Vor 17:00",
        beforePrice: "799 CHF",
        beforeNote: "pro Person",
        afterLabel: "Ab 17:00",
        afterPrice: "999 CHF",
        afterNote: "pro Person",
        groupNote: "Minimale Gruppengrösse: 3 Personen, maximal 4",
        ctaButton: "Anmeldung via WhatsApp"
      },
      juniorAbos: {
        sectionLabel: "JUNIOR ACADEMY ABOS",
        sectionTitleStart: "Junior",
        sectionTitleAccent: "Abos",
        sectionSubtitle: "Saisonstart jeweils im September. Wähle das Abo, das zu deinem Kind passt.",
        season: "Saison startet im September",
        threeMonthLabel: "3-MONATS-ABO",
        threeMonthTitle: "3 Monate Probe",
        threeMonthDesc: "Perfekt, um das Junior Programm kennenzulernen.",
        threeMonthOption1: "1× pro Woche",
        threeMonthPrice1: "399 CHF",
        yearlyLabel: "JAHRES-ABO",
        yearlyTitle: "Freizeit",
        yearlyDesc: "Für Freizeitspieler – die volle Saison, bester Preis pro Lektion.",
        yearlyOption1: "1× pro Woche",
        yearlyPrice1: "1'299 CHF",
        yearlyOption2: "2× pro Woche",
        yearlyPrice2: "2'099 CHF",
        competitiveLabel: "WETTKAMPF",
        competitiveTitle: "Competitive Players",
        competitiveDesc: "Für ambitionierte Junioren mit Turnier-Ambitionen.",
        competitiveOption1: "3× pro Woche minimum",
        competitiveOption2: "On-Court + Off-Court Coaching",
        competitivePrice: "Auf Anfrage",
        competitiveCta: "Kontakt aufnehmen",
        popular: "Beliebt",
        ctaTitle: "Bereit zum Start?",
        ctaSubtitle: "Sicher dir deinen Platz für die kommende Saison. Schreib uns via WhatsApp – wir helfen dir gerne weiter.",
        ctaButton: "Anmeldung via WhatsApp"
      },
      ageGroupsLabel: "ALTERSGRUPPEN",
      ageGroupsTitleStart: "Training für",
      ageGroupsTitleAccent: "Alle",
      age1Name: "Mini Padel",
      age1Range: "6-8 Jahre",
      age1Level: "Anfänger",
      age2Name: "Kids Training",
      age2Range: "9-12 Jahre",
      age2Level: "Anfänger - Fortgeschritten",
      age3Name: "Junior Elite",
      age3Range: "13-17 Jahre",
      age3Level: "Fortgeschritten - Profi",
      age4Name: "Erwachsene",
      age4Range: "18+ Jahre",
      age4Level: "Alle Levels",
      coachesTitleStart: "3 Vollzeit",
      coachesTitleAccent: "Coaches",
      ctaTitle: "Bereit zu Starten?",
      ctaSubtitle: "Kontaktiere uns via WhatsApp und wir helfen dir, das perfekte Training zu finden",
      juniorTrial: {
        label: "GRATIS PROBELEKTION",
        juniorsOnly: "Nur für Kinder & Jugendliche (4–17 Jahre)",
        title: "Kostenlose Probelektion",
        titleAccent: "buchen",
        subtitle: "Bevor dein Kind sich für ein Training anmeldet, kann es eine gratis Probelektion bei unseren professionellen Trainern absolvieren. Füll das Formular aus – wir melden uns in Kürze.",
        scrollCta: "Probelektion buchen",
        formTitle: "Anmeldung Probelektion",
        parentSection: "Angaben Eltern",
        parentName: "Name (Elternteil)",
        parentNamePh: "Vor- und Nachname",
        parentEmail: "E-Mail",
        parentEmailPh: "ihre.email@beispiel.com",
        parentPhone: "Telefon",
        parentPhonePh: "+41 79 123 45 67",
        childSection: "Angaben Kind",
        childName: "Name des Kindes",
        childNamePh: "Vorname",
        childAge: "Alter (Jahre)",
        childAgePh: "z.B. 9",
        availabilitySection: "Verfügbarkeit",
        daysLabel: "An welchen Wochentagen ist dein Kind verfügbar?",
        daysHint: "Mehrfachauswahl möglich – Junior-Training findet nur Mo–Fr statt",
        days: { mon: "Mo", tue: "Di", wed: "Mi", thu: "Do", fri: "Fr" },
        timeLabel: "Wie früh kann dein Kind kommen?",
        timeHint: "Junior-Training findet stündlich von 14:00 bis 17:00 Uhr statt (Mo–Fr)",
        time1400: "14:00 Uhr",
        time1500: "15:00 Uhr",
        time1600: "16:00 Uhr",
        time1700: "17:00 Uhr",
        experienceSection: "Erfahrung mit Schlägersport",
        expNone: "Keine Erfahrung",
        expSome: "Etwas Erfahrung (z.B. Tennis, Squash, Badminton)",
        expPadel: "Spielt bereits Padel",
        expDetailsLabel: "Details zur Erfahrung (optional)",
        expDetailsPh: "z.B. seit 2 Jahren Tennis im Verein",
        notesLabel: "Nachricht / Notizen (optional)",
        notesPh: "Allergien, Besonderheiten, Wünsche…",
        consent: "Ich stimme zu, dass meine Daten zur Bearbeitung der Anfrage verwendet werden.",
        privacyNotice: "deine Angaben werden vertraulich behandelt und ausschliesslich zur Kontaktaufnahme bezüglich der Probelektion verwendet.",
        requiredFields: "Felder mit * sind Pflichtfelder",
        submit: "Probelektion anfragen",
        sending: "Senden",
        successTitle: "Anfrage erhalten",
        successMessage: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
        errorAge: "Diese Anmeldung ist nur für Kinder & Jugendliche von 4 bis 17 Jahren.",
        errorDays: "Bitte wähl mindestens einen Tag aus.",
        errorConsent: "Bitte stimm der Datennutzung zu.",
        errorGeneric: "Etwas ist schiefgelaufen. Bitte versuch es erneut."
      }
    },
    // Testimonials
    testimonials: {
      label: "BEWERTUNGEN",
      titleStart: "Was unsere",
      titleAccent: "Community sagt",
      basedOn: "Basierend auf",
      reviews: "Bewertungen",
      readAll: "Alle Bewertungen auf Google ansehen",
      r1Text: "Beste Padel-Halle in der Region. Tolle Atmosphäre, top Plätze und eine super Community. Komme jede Woche zum Mixin und es macht jedes Mal Spass!",
      r2Text: "Meine Kinder lieben die Junior Academy. Die Trainer Fabrizio, Antoine und Alejandro sind unglaublich engagiert. Top Niveau für Schweizer Verhältnisse.",
      r3Text: "Nur 20 Minuten von Zürich und absolut professionelle Anlage. 8 Indoor-Plätze, Sports Bar, Schlägerverleih – alles da. Klare Empfehlung.",
      r4Text: "Als Anfängerin habe ich mich von Anfang an wohl gefühlt. Geduldige Trainer, lockere Stimmung. Innerhalb weniger Wochen schon erste Fortschritte gemacht.",
      r5Text: "Die Sports Bar nach dem Spiel ist Gold wert. 12 TVs, gute Snacks und immer nette Leute. Kein Wunder, dass die Padelarena der Treffpunkt ist.",
      r6Text: "Habe schon in vielen Hallen gespielt – die Padelarena ist klar die schönste in der deutschsprachigen Schweiz. Online-Buchung funktioniert reibungslos."
    },
    closurePopup: {
      badge: "Wir sind zurück!",
      title: "Wiedereröffnung am 19. September",
      dateRange: "Dieses Wochenende – Samstag 19.9.",
      body: "Wir haben's geschafft — die Padelarena öffnet dieses Wochenende wieder ihre Türen! Buche deinen Court online. Das erste Mixing startet schon am Dienstag, 22. September — ebenfalls auf bookpadelarena.ch buchbar.",
      bookingHook: "Buche jetzt online auf bookpadelarena.ch",
      bookingCta: "Platz reservieren",
      communityHook: "Bleib auf dem Laufenden und tritt unserer WhatsApp-Community bei:",
      cta: "Der Community beitreten",
      dismiss: "Schliessen"
    },
    chat: {
      openLabel: "Chat mit unserem AI-Assistenten öffnen",
      closeLabel: "Chat schliessen",
      title: "Padelarena Assistent",
      subtitle: "Frag mich alles rund um die Padelarena",
      welcome: "Hoi! Frag mich alles über die Padelarena 👋",
      waLabel: "WhatsApp öffnen",
      waNumber: "+41 79 916 08 34",
      placeholder: "Deine Frage…",
      sendLabel: "Senden",
      errorFallback: "Sorry, gerade läuft etwas schief. Bitte schreib uns kurz auf WhatsApp: +41 79 916 0834.",
      disclaimer: "AI-Antworten können unpräzise sein. Bei wichtigen Anfragen: WhatsApp +41 79 916 0834."
    }
  },
  en: {
    // Featured upcoming events
    featuredEvents: {
      juniorCamp: {
        accent: "blue",
        image: "https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/9repnipw_Junior%20Padel%20Camp%20Weihnachtsferien%20-%20Print%20-%20Flyer.png",
        alt: "PAW Lions Junior Padel Camp — Christmas holidays, December 21–24, 2026",
        badge: "Junior Camp · Dec 21–24",
        title: "PAW Lions Junior Padel Camp",
        matchup: "Christmas holidays at Padelarena — 9:00 to 12:00 every day, welcome package & snacks included, coaches on site for all levels.",
        dateLabel: "Dates",
        dateValue: "December 21–24, 2026",
        timeLabel: "Time",
        timeValue: "09:00 – 12:00",
        priceLabel: "Price",
        priceValue: "CHF 299 · welcome package & snacks included",
        reserveBadge: "Register now",
        reserveText: "Spots are limited — register your kid by email at info@padelarena.ch or via WhatsApp.",
        emailTo: "info@padelarena.ch",
        emailSubject: "Junior Padel Camp — Registration (Dec 21–24)",
        emailCta: "info@padelarena.ch",
        waCta: "Register via WhatsApp",
        waText: "Hi! I'd like to register my kid for the PAW Lions Junior Padel Camp (Dec 21–24, 9:00–12:00)."
      },
      wmOpening: {
        accent: "red",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png",
        alt: "World Cup opening — Switzerland vs Qatar — live at Padelarena Wädenswil Sports Bar",
        badge: "Live at the Sports Bar · June 13",
        title: "World Cup Opening — Switzerland vs Qatar",
        matchup: "Together. Louder. Switzerland. One match. One country. One moment.",
        dateLabel: "Date",
        dateValue: "Saturday, June 13",
        timeLabel: "Start",
        timeValue: "21:00",
        reserveBadge: "Reservation required!",
        reserveText: "Limited seats – please call ahead to reserve a table: +41 43 833 0834.",
        waCta: "Reserve via WhatsApp",
        waText: "Hi! I'd like to reserve a table for the World Cup opening (Switzerland vs Qatar, Sat June 13, 21:00)."
      },
      frauenSocial: {
        accent: "pink",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/pvm3s2px_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%284%29.png",
        alt: "Women's Social — Padel, Community, Good Vibes — Saturday June 20 at Padelarena Wädenswil",
        badge: "Women only · June 20",
        title: "Women's Social — An evening for us",
        matchup: "Padel. Community. Good Vibes. Sign up as a team!",
        dateLabel: "Date",
        dateValue: "Saturday, June 20",
        timeLabel: "Time",
        timeValue: "16:00 – ca. 18:30",
        priceLabel: "Price",
        priceValue: "50 CHF per person · incl. prosecco & snacks",
        reserveBadge: "Sign up as a team",
        reserveText: "Seats are limited – sign up as a team via +41 43 833 0834 or WhatsApp.",
        waCta: "Sign up via WhatsApp",
        waText: "Hi! We'd like to sign up as a team for the Women's Social on Saturday June 20 (16:00–18:30)."
      },
      lastTime: {
        accent: "blue",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/3nv5m3bc_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%289%29.png",
        alt: "One Last Time Under The Old Roof — Farewell tournament at Padelarena Wädenswil on Sunday June 28",
        badge: "Farewell Tournament · June 28",
        title: "One Last Time — Under The Old Roof",
        matchup: "Farewell to the Old Roof Tournament. One last time together — let's make it unforgettable.",
        dateLabel: "Date",
        dateValue: "Sunday, June 28",
        timeLabel: "Time",
        timeValue: "15:30 – ca. 20:00",
        priceLabel: "Price",
        priceValue: "50 CHF per person · incl. apéro & drinks",
        reserveBadge: "Sign up as a team",
        reserveText: "Sign up now as a team! Spots are limited – call +41 43 833 0834 or message us on WhatsApp.",
        waCta: "Sign up via WhatsApp",
        waText: "Hi! We'd like to sign up as a team for the One Last Time Farewell Tournament on Sunday June 28 (15:30–20:00)."
      }
    },
    // Navigation
    nav: {
      about: "About",
      facilities: "Facilities",
      courts: "Courts",
      services: "Services",
      pricing: "Pricing",
      academy: "Academy",
      events: "Events",
      contact: "Contact",
      bookNow: "Book Now"
    },
    // Hero Section
    hero: {
      title: "Welcome to Padelarena",
      subtitle: "The Padel Arena with the Best Vibes and Community in Wädenswil",
      description: "8 Indoor Courts • 2 Golf Simulators • Sports Bar • Top Junior Academy",
      bookCourt: "Reserve Court",
      learnMore: "Learn More"
    },
    // About Section
    about: {
      title: "About Padelarena",
      subtitle: "The Padel Arena with the Best Community in Switzerland",
      ogBadge: "Best Vibes & Community in Switzerland",
      description: "Padelarena Wädenswil is Switzerland's first and original padel center. Since 2017 we've been shaping padel in this country – with 8 indoor courts, the country's leading junior academy, two golf simulators and a Sports Bar with 9 TVs for every big match. Just 20 minutes from Zurich, we're known for our unbeatable atmosphere and the best community in Switzerland.",
      communityText: "But Padelarena is more than a venue – it's a community. Hundreds of active players, weekly mixings, tournaments, junior camps and a Sports Bar that becomes everyone's second living room after the match. Come be part of it.",
      bookCourtBtn: "Book a Court",
      joinCommunityBtn: "Join the Community",
      sportsBarBtn: "Explore the Sports Bar",
      feature1Title: "8 Indoor Courts",
      feature1Desc: "Professional padel courts with optimal lighting",
      feature2Title: "Top Junior Academy",
      feature2Desc: "60+ kids training with 3 full-time coaches",
      feature3Title: "Year-Round Operation",
      feature3Desc: "Indoor facility for training in any weather"
    },
    // Court Availability
    courtAvailability: {
      title: "Live Court Availability",
      subtitle: "Real-time status of our 8 indoor courts",
      liveBadge: "LIVE",
      availableNow: "Free now",
      availableNext2h: "Free in 2h",
      padelCourts: "Padel courts",
      golfSims: "Golf sims",
      golfSim: "Golf Simulator",
      todayTimeline: "Time slots available today",
      tomorrowTimeline: "Tomorrow's availability",
      courtsShort: "courts",
      golfShort: "golf",
      bookSlot: "Book this slot",
      upTo: "Up to",
      fewLeft: "Few left",
      full: "Full",
      eveningFullNotice: "Tonight is fully booked. Check back tomorrow or grab an earlier slot today.",
      dayFinished: "Today's playing day is over — book a court for tomorrow.",
      bookTomorrow: "Book for Tomorrow",
      free: "Free",
      busy: "Busy",
      indoor: "Indoor",
      outdoor: "Outdoor",
      nextFree: "Next free slot",
      bookedAllDay: "Fully booked today",
      lastUpdated: "Last updated",
      errorMsg: "We can't load court availability right now. Please try directly on the booking platform.",
      comingSoon: "Coming Soon",
      comingSoonTitle: "Coming Soon!",
      comingSoonDesc: "We're working on bringing you real-time court availability. In the meantime, you can book by phone or use our online booking platform.",
      phoneBooking: "By Phone: +41 43 833 0834",
      onlineBooking: "Book Online",
      court: "Court",
      available: "Available",
      occupied: "Occupied",
      maintenance: "Maintenance",
      availableIn: "Available in",
      minutes: "minutes",
      refresh: "Refresh",
      bookThisCourt: "Book This Court"
    },
    // Facilities
    facilities: {
      title: "Our Facilities",
      subtitle: "World-class amenities for the perfect padel experience",
      showcaseTitle: "World-Class Infrastructure",
      showcaseSubtitle: "Experience state-of-the-art padel facilities with professional equipment",
      showcaseLabel: "OUR FACILITY",
      exploreCta: "Learn more",
      courts: "8 Indoor Padel Courts",
      courtsDesc: "Professional courts with optimal lighting and climate control",
      golf: "2 Golf Simulators",
      golfDesc: "State-of-the-art golf simulators for year-round play",
      bar: "Sports Bar & Lounge",
      barDesc: "9 TVs with all the top live sports — Champions League, hockey, tennis, padel and more. Best vibes before and after the match.",
      lounge: "Lounge Area",
      loungeDesc: "Comfortable space for relaxing and networking",
      shop: "Pro Shop",
      shopDesc: "Full equipment and racket rental available"
    },
    // Services
    services: {
      title: "Our Services",
      subtitle: "Professional programs for all skill levels",
      label: "SERVICES",
      training: "Padel Training",
      trainingDesc: "Individual and group lessons for all levels with certified coaches",
      academy: "Junior Academy",
      academyDesc: "60+ kids training with 3 full-time coaches",
      tournaments: "Tournaments & Events",
      tournamentsDesc: "Regular tournaments and special events for the community",
      camps: "Padel Camps",
      campsDesc: "Intensive training camps during school holidays"
    },
    // Trainers
    trainers: {
      title: "Our Coaches",
      subtitle: "Professional team of certified coaches",
      meet: "Meet our team",
      experience: "Experience",
      specialty: "Specialty",
      academyDirector: "Academy Director",
      coach: "Coach",
      cpo: "CPO - Chief Padel Officer",
      cngo: "CNGO - Chief NextGen Officer",
      academyLeadership: "Academy Leadership",
      nextGenTraining: "Juniors & Adults",
      professionalTraining: "Juniors & Adults",
      viewBio: "View bio"
    },
    // Coach Page
    coachPage: {
      back: "Back",
      backHome: "Back to Home",
      notFound: "Coach not found",
      bookTraining: "Request a training",
      aboutHeading: "About",
      highlights: "Highlights",
      languages: "Languages",
      otherCoaches: "Other coaches",
      bioComingSoon: "Bio coming soon — we're waiting on details from the coach."
    },
    coachBios: {
      "fabrizio-pavez": {
        paragraphs: [
          "Passionate about sports science, biomechanics and functional movement applied to padel. As Academy Director I structure dynamic, methodology-driven training programs focused on optimising performance and preventing injuries through mobility, stability and functional resilience.",
          "I bring solid experience developing both progressing players and high-performance athletes — including juniors selected for the Swiss National Team to compete at European level. I'm also the author of my own technical padel book and have led specialised seminars and workshops across different clubs to share this methodology."
        ],
        highlights: [
          "Academy Director",
          "Sports science & biomechanics specialist",
          "Author of a technical padel book",
          "Developed juniors into the Swiss National Team"
        ],
        languages: ["Spanish", "English"]
      },
      "antoine-laurent": {
        paragraphs: [
          "Hi, I'm Antoine — 29, originally from France. High-level sport has always been in my DNA, and that drive for excellence led me to earn my certifications as a padel coach and sports director in 2023, followed by specialised training in Spain.",
          "After a year running sports operations and coaching in France, then a year coaching in Switzerland, I've built a complete and tailored coaching approach. On court I combine high-level rigour with the friendly spirit of padel so every player progresses and has maximum fun. See you on the court!"
        ],
        highlights: [
          "Certified padel coach & sports director (2023)",
          "Specialised training in Spain",
          "French, based in Switzerland",
          "Blends high-level rigour with the fun side of padel"
        ],
        languages: ["French", "English", "Spanish"]
      },
      "alejandro-nieuwenhuis": {
        paragraphs: [
          "Hi, I'm Alex — 25, from Valencia, Spain. I grew up on sports and ended up studying for a sports degree before I'd even decided on a direction. After a few years of tennis I switched to padel and the sport clicked fast — within a year I was already competing around Valencia.",
          "Since 2020 I've been coaching alongside competing, first back in Spain and now here in Wädenswil. Hope to see you on court — let's grow together!"
        ],
        highlights: [
          "From Valencia, Spain",
          "Sports degree",
          "Competing player since 2020",
          "Experienced junior & adult coach"
        ],
        languages: ["Spanish", "English"]
      }
    },
    seo: {
      sportsBar: {
        title: "Sports Bar Wädenswil – 9 TVs, Live Champions League, Ice Hockey & Premier Padel | Padelarena",
        description: "The Sports Bar in Wädenswil with 9 TVs streams Champions League, Swiss Super League, Swiss National League ice hockey, tennis Grand Slams and Premier Padel live. Pizza, Flammkuchen, Chnoblibrot, beer on tap and wine – just 20 min from Zurich.",
        keywords: "Sports Bar Wädenswil, sports bar Lake Zurich, watch Champions League Zurich, Swiss National League viewing, live sports bar Wädenswil, public viewing Wädenswil, pizza Wädenswil, lounge Wädenswil"
      },
      events: {
        title: "Corporate Events, Family Weekends & Birthdays in Wädenswil | Padelarena",
        description: "Padelarena Wädenswil – the top venue for corporate events, team-building, family weekend activities with kids, padel tournaments and birthday parties (adults & kids). 8 indoor courts, sports bar with 9 TVs, catering and golf simulator under one roof.",
        keywords: "corporate event Wädenswil, team building Zurich, family weekend activity Zurich, indoor activity with kids Zurich, kids birthday Wädenswil, padel tournament Switzerland, birthday party Wädenswil, event venue Lake Zurich, kids padel party Zurich, weekend with kids Lake Zurich"
      },
      courts: {
        title: "8 Indoor Padel Courts in Wädenswil – Book Online | Padelarena",
        description: "8 fully-equipped indoor padel courts in Wädenswil. Year-round play, professional LED lighting, online booking 24/7. Just 20 min from Zurich.",
        keywords: "padel Wädenswil, padel courts Zurich, indoor padel Switzerland, book padel Lake Zurich, padel court rental Wädenswil"
      },
      golf: {
        title: "Indoor Golf Simulator in Wädenswil – year-round play | Padelarena",
        description: "Two state-of-the-art indoor golf simulators at Padelarena Wädenswil. Top courses worldwide, clubs included, individual and corporate bookings. 20 min from Zurich.",
        keywords: "golf simulator Wädenswil, indoor golf Zurich, Trackman Lake Zurich, indoor golf Switzerland, book indoor golf"
      },
      proShop: {
        title: "Padel Pro Shop Wädenswil – Head, Babolat, Nox & Padlr | Padelarena",
        description: "Try Head, Babolat and Nox padel rackets on court before you buy. Plus our own Padlr clothing line. Pro Shop at Padelarena Wädenswil.",
        keywords: "padel shop Wädenswil, buy padel rackets Switzerland, Head padel rackets, Babolat padel, Nox padel rackets, Padlr clothing"
      },
      academy: {
        title: "Padel Junior Academy Wädenswil – Padel for kids from age 4 | Padelarena",
        description: "Switzerland's leading padel junior academy. 60+ active kids, 3 full-time coaches, 4 age groups from age 4. Free trial lesson on request — perfect weekend activity for families with kids. Wädenswil, 20 min from Zurich.",
        keywords: "padel for kids Zurich, junior padel academy Switzerland, padel trial lesson kids, mini padel Wädenswil, junior padel training Zurich, kids sport Wädenswil, padel school Lake Zurich, kids birthday padel Zurich, family weekend activity Zurich, indoor sport for kids Wädenswil, padel kids camp Switzerland"
      }
    },
    courtsPage: {
      label: "PADEL COURTS",
      titleStart: "8 Indoor Doubles",
      titleAccent: "Courts",
      subtitle: "State-of-the-art padel courts, playable year-round – right by Lake Zurich.",
      aboutTitle: "Our Courts",
      about1: "8 fully covered indoor doubles courts with professional LED lighting, panoramic glass and a high-performance surface. Perfect for casual games, training and tournaments – in any weather.",
      about2: "Every court is bookable online in 60-, 90- or 120-minute slots. Racket rental for 5 CHF per racket and balls available on-site – please bring clean indoor shoes.",
      statCourts: "Indoor courts",
      statIndoor: "Covered",
      statHours: "Mo-Fri hours",
      statRacket: "Per racket",
      statSlot: "min per slot",
      hoursTitle: "Opening hours",
      hoursWeekday: "Mon – Fri",
      hoursWeekend: "Sat – Sun",
      includedTitle: "Included with every booking",
      galleryTitle: "Inside the arena",
      included: [
        "Fully equipped indoor court",
        "Professional LED lighting",
        "Balls included",
        "Racket rental: 5 CHF per racket",
        "Locker rooms with showers",
        "Sports Bar after the game"
      ],
      bookCta: "Book a Court",
      viewPricing: "See pricing",
      faqTitle: "Padel in Wädenswil – FAQ",
      faqs: [
        { q: "How do I book a padel court in Wädenswil?", a: "Online via bookpadelarena.ch in 60-, 90- or 120-minute slots, available 24/7 – or call us on +41 43 833 0834." },
        { q: "What does a padel court cost at Padelarena?", a: "Weekdays before 5pm: 58 CHF/hour. After 5pm and weekends: 68 CHF/hour. Racket rental: 5 CHF. Balls included." },
        { q: "Do I need my own equipment?", a: "No. Rackets are available for 5 CHF, balls are included with every booking. Clean indoor shoes are enough." },
        { q: "How far is Padelarena Wädenswil from Zurich?", a: "About 20 minutes by car or S-Bahn (S2) from Zurich main station. Easy reach for players from Zurich, Horgen, Thalwil, Pfäffikon and Richterswil." },
        { q: "What are your opening hours?", a: "Mon–Fri 06:00–24:00, Sat–Sun 08:00–20:00." }
      ]
    },
    golfPage: {
      label: "GOLF SIMULATOR",
      titleStart: "Golf all year",
      titleAccent: "round",
      subtitle: "Play the world's top courses – indoors in Wädenswil.",
      aboutTitle: "Our Golf Simulators",
      about1: "Our two golf simulators bring the world's most beautiful courses to you – snow, rain, or shine. Realistic feedback, accurate shot analysis, and a true game feel.",
      about2: "Perfect for training, family fun, or corporate events. Book by the hour – clubs included.",
      featuresTitle: "What you get",
      features: [
        "2 state-of-the-art indoor simulators",
        "100+ top courses worldwide",
        "Clubs included",
        "Great for beginners & pros",
        "Bookable for corporate events"
      ],
      bookCta: "Book Golf",
      callToBookTitle: "Book the golf simulator",
      callToBookText: "Online booking for the golf simulator is currently unavailable. Just give us a call or send us a WhatsApp message – we'll happily reserve a slot for you.",
      callToBookWaCta: "Book via WhatsApp",
      callToBookWaText: "Hi! I'd like to book the golf simulator.",
      galleryTitle: "Inside the simulator",
      faqTitle: "Golf simulator – FAQ",
      faqs: [
        { q: "How do I book the golf simulator?", a: "By phone (+41 43 833 0834) or WhatsApp only for now. Online booking will be back soon." },
        { q: "How does the golf simulator work?", a: "You hit real balls with real clubs into a high-speed tracker that measures your swing precisely and renders it on the screen across world-class courses." },
        { q: "Do I need experience?", a: "No. Beginners and pros are equally welcome. Clubs are included – just bring clean indoor shoes." },
        { q: "How many people can play at once?", a: "Up to 4 per simulator. Great for friend groups or company outings." },
        { q: "Can I book the golf simulator for corporate events?", a: "Yes – we combine golf simulator, padel courts and Sports Bar into a memorable corporate event. Contact us for a quote." }
      ]
    },
    proShopPage: {
      label: "PRO SHOP",
      titleStart: "Pro",
      titleAccent: "Shop",
      subtitle: "Try and buy rackets on-site, plus our Padlr clothing line.",
      racketsTitle: "Try & buy rackets",
      racketsIntro: "Try the leading padel brands on the court before you buy. We carry the latest models from the top brands:",
      headDesc: "Innovative tech, perfect balance – the choice of many pro players.",
      babolatDesc: "French quality with powerful rackets for every level.",
      noxDesc: "Spanish padel brand with top players like Agustín Tapia.",
      clothingTitle: "Padlr Clothing",
      clothingDesc: "Our own Padlr clothing line: high-quality padel apparel for training and matches. Available in-store.",
      visitTitle: "Stop by the shop",
      visitDesc: "Drop in to test rackets on the court or get expert advice from our team. Give us a call beforehand so we can take care of you personally.",
      contactUs: "Get in touch",
      faqTitle: "Pro Shop – FAQ",
      faqs: [
        { q: "Which padel brands do you carry?", a: "We stock the latest models from Head, Babolat and Nox – plus our own Padlr clothing line for training and match wear." },
        { q: "Can I test rackets before buying?", a: "Yes – try them in a real match on our courts and choose the one that fits your game." },
        { q: "Do you offer advice?", a: "Yes – our team helps you pick the right racket based on your level and playing style. Give us a quick call so we can dedicate time to you." }
      ]
    },
    eventsPage: {
      label: "EVENTS",
      titleStart: "Events &",
      titleAccent: "private bookings",
      subtitle: "Tournaments, mixin nights, corporate and birthday events – all under one roof.",
      upcomingTitle: "Upcoming events",
      pausedBadge: "We're back",
      pausedTitle: "Mixings & events are back!",
      pausedBody: "Padelarena reopens on September 19. The first mixing is already on Tuesday, September 22. Tournaments, women's mixings, social events and public viewings are all back on.",
      pausedNote: "Courts: from September 19 • First mixing: Tuesday, September 22, 2026.",
      signupHook: "Sign-ups for mixings & events now run through our new booking system — everyone must register:",
      signupCta: "Register for events",
      pausedCta: "Stay in the WhatsApp community",
      upcomingPlaceholder: "Upcoming events will be announced here soon.",
      upcomingFollow: "Follow us on Instagram or join our WhatsApp community to stay in the loop.",
      privateTitle: "Private & corporate events",
      privateIntro: "Whether it's a birthday, corporate retreat or club tournament – we make your event unforgettable. Courts, Sports Bar and full catering exclusively for your group.",
      corporateTitle: "Corporate events",
      corporateDesc: "Team building, client receptions or staff tournaments with padel, golf simulator and catering.",
      birthdayTitle: "Birthday parties",
      birthdayDesc: "For kids, teens and adults. Fun on the court with pizza and drinks at the bar.",
      tournamentTitle: "Custom tournaments",
      tournamentDesc: "We organise your club or private tournament – including referees and prize-giving.",
      ctaTitle: "Ready to plan your event?",
      ctaSubtitle: "Send us a message or give us a call – we'll tailor it to your needs.",
      requestQuote: "Request a quote",
      faqTitle: "Events – FAQ",
      faqs: [
        { q: "How many people can attend a corporate event at Padelarena?", a: "We host groups from 8 to 60+. With 8 padel courts, 2 golf simulators, Sports Bar and Lounge we can run multiple activities in parallel." },
        { q: "Do you offer catering?", a: "Yes – from snacks and pizza to bespoke catering tailored to your occasion and budget." },
        { q: "Can I organise a private padel tournament?", a: "Absolutely. We handle scheduling, referees and prize-giving. Perfect for clubs, companies or stag/hen parties." },
        { q: "What works for a birthday party?", a: "Padel matches or the golf simulator combined with pizza and drinks at the Sports Bar – popular with kids, teens and adults alike." },
        { q: "How do I book an event?", a: "Send a request via our contact form or call +41 43 833 0834. We respond within one business day." }
      ]
    },
    sportsBarPage: {
      label: "SPORTS BAR & LOUNGE",
      titleStart: "Sports Bar &",
      titleAccent: "Lounge",
      subtitle: "9 TVs, all the top live sports, the best vibes – the heart of Padelarena.",
      aboutTitle: "The hangout for sports fans",
      about1: "Our Sports Bar with 9 TVs is the meeting point before and after the match. Whether it's Champions League, NHL hockey, a tennis Grand Slam or a padel tournament – the game you want to watch is always on.",
      about2: "The connected lounge area is perfect for chilling out, networking or simply ending the day with friends. Snacks, drinks and great vibes guaranteed.",
      statTvs: "TVs",
      statOpen: "Open",
      statLive: "Sports",
      statVibes: "Vibes",
      liveTitle: "Live on TV",
      liveSports: ["Champions League", "Premier League", "Bundesliga", "Swiss Super League", "Swiss National League (Ice Hockey)", "NHL Hockey", "Tennis Grand Slams", "Premier Padel", "Formula 1", "Ski Racing", "Football World Cup/Euros"],
      featuresTitle: "What to expect",
      features: [
        "9 big TVs with live sports around the clock",
        "Pizza, Flammkuchen and Chnoblibrot (Swiss garlic bread) fresh from the oven",
        "Beer on tap, a curated wine list and soft drinks",
        "Lounge area for chilling or networking",
        "Perfect before or after your match",
        "All welcome — even without a padel booking"
      ],
      foodTitle: "From the kitchen & bar",
      featuredEventTitle: "Next big event",
      foodItems: ["Pizza", "Flammkuchen", "Chnoblibrot", "Snacks", "Beer on tap", "Wine", "Soft drinks", "Coffee"],
      ctaTitle: "Stop by or reserve a table?",
      ctaSubtitle: "Drop us a line — we'll happily reserve a table for you and your crew.",
      privateBtn: "Private events",
      faqTitle: "Sports Bar – FAQ",
      faqs: [
        { q: "Which sports do you stream live in the Sports Bar?", a: "On our 9 TVs we show Champions League, Premier League, Bundesliga, Swiss Super League, Swiss National League (ice hockey), NHL hockey, tennis Grand Slams, Premier Padel, Formula 1, ski racing and all major international tournaments." },
        { q: "Do I need to play padel to come to the Sports Bar?", a: "No, everyone is welcome. You can drop in, watch a match, eat and drink – with or without a padel booking." },
        { q: "Can I reserve a table?", a: "Yes – call +41 43 833 0834. For big games or groups of 6+ we strongly recommend a reservation." },
        { q: "Do you serve food?", a: "Yes — pizza, Flammkuchen, Chnoblibrot (Swiss garlic bread) and snacks fresh from the oven. At the bar: beer on tap, a curated wine list, soft drinks and coffee." },
        { q: "When is the Sports Bar open?", a: "Mon–Fri 06:00–24:00, Sat–Sun 08:00–20:00 – the Sports Bar is open during all Padelarena hours." }
      ]
    },
    // Pricing
    pricing: {
      title: "Pricing",
      subtitle: "Transparent and fair pricing",
      courtRates: "Court Rental",
      weekdayBefore5: "Weekdays before 5pm",
      weekdayAfter5: "Weekdays after 5pm",
      weekend: "Weekends (all day)",
      afterFiveOrWeekend: "After 5pm & Weekends",
      price50: "50 CHF",
      price58: "58 CHF",
      price64: "64 CHF",
      price60: "60 CHF",
      price68: "68 CHF",
      perHour: "per hour",
      perCourt: "per court",
      racketRental: "Racket Rental: 5 CHF",
      juniorBadge: "Junior Academy",
      juniorTitle: "Want your kids to try padel?",
      juniorBody: "Whether complete beginners or already swinging a racket — Switzerland's leading Junior Padel Academy has the right program. Trial sessions, group classes and camps for kids from age 6 up to teens, with professional coaches and a new season every September.",
      juniorPriceFrom: "Trial passes from 399 CHF · Yearly memberships from 1'299 CHF",
      juniorCta: "Discover the Junior Academy",
      trainingTitle: "Trainer Hour Price List",
      trainingSubtitle: "Price Per Person",
      trainingIncludes: "Training incl. Court / Racket / Balls",
      before5: "Before 5pm",
      after5Weekend: "After 5pm & Sat/Sun",
      hour1: "1 Hour",
      hour15: "1.5 Hours",
      hour2: "2 Hours",
      players1: "1 Player",
      players2: "2 Players",
      players3: "3 Players",
      players4: "4 Players",
      privateLesson: "Private Lesson",
      privateBefore5: "Before 5pm (Weekdays)",
      privateAfter5: "After 5pm & Weekends",
      price100: "100 CHF",
      price120: "120 CHF",
      price140: "140 CHF",
      groupLessons: "Group Training",
      groupNote: "Price per person decreases with group size",
      note: "Online booking available"
    },
    // Gallery
    gallery: {
      title: "Gallery",
      subtitle: "Explore our world-class facilities",
      label: "GALLERY"
    },
    // Sponsors
    sponsors: {
      title: "Our Partners",
      subtitle: "Proud partners of the Padelarena community",
      label: "PARTNERS"
    },
    // Contact
    contact: {
      title: "Contact",
      subtitle: "Get in touch with us",
      label: "CONTACT",
      address: "Address",
      addressLine: "Zugerstr. 162, 8820 Wädenswil, Switzerland",
      phone: "Phone",
      email: "Email",
      hours: "Opening Hours",
      hoursWeekday: "Mon-Fri: 6am - Midnight",
      hoursWeekend: "Sat-Sun: 8am - 8pm",
      formTitle: "Send Us a Message",
      name: "Name",
      emailLabel: "Email",
      phoneLabel: "Phone (optional)",
      message: "Message",
      send: "Send Message",
      success: "Thank you! We'll get back to you soon.",
      error: "An error occurred. Please try again."
    },
    // Newsletter
    newsletter: {
      title: "Subscribe to Newsletter",
      subtitle: "Stay updated on events and offers",
      placeholder: "Your email address",
      subscribe: "Subscribe",
      success: "Successfully subscribed!",
      error: "Error subscribing. Please try again."
    },
    // Footer
    footer: {
      description: "The padel arena with the best vibes and community in Switzerland. 8 courts, 2 golf simulators, and leading junior academy.",
      quickLinks: "Quick Links",
      followUs: "Follow Us",
      rights: "All rights reserved.",
      realEstate: "Real Estate"
    },
    // Real Estate Page
    realEstate: {
      title: "Padelarena Real Estate",
      subtitle: "Your Partner for Real Estate in the Region",
      description: "As part of the Padelarena community, we offer you exclusive support in finding your dream property or selling your home. Fill out the form and our partner real estate agent will contact you.",
      formTitle: "Express Your Interest",
      name: "Name",
      namePlaceholder: "Your full name",
      email: "Email",
      emailPlaceholder: "your.email@example.com",
      phone: "Phone",
      phonePlaceholder: "+41 79 123 45 67",
      interest: "Interest",
      interestBuying: "Buying",
      interestSelling: "Selling",
      interestPlaceholder: "Select your interest",
      propertyType: "Property Type",
      propertyHouse: "House",
      propertyApartment: "Apartment",
      propertyLand: "Land",
      propertyPlaceholder: "Select property type",
      budget: "Budget",
      budgetPlaceholder: "Select your budget",
      budget1to2: "1 – 2 M CHF",
      budget2to3: "2 – 3 M CHF",
      budgetOver3: "Over 3 M CHF",
      location: "Location/Region",
      locationPlaceholder: "e.g. Wädenswil, Zurich",
      message: "Message (optional)",
      messagePlaceholder: "Share more details with us...",
      consent: "I agree that my data will be shared with the partner real estate agent who will handle further communication. I have read and accepted the privacy policy.",
      submit: "Submit Inquiry",
      success: "Thank you! Our partner will contact you shortly.",
      error: "An error occurred. Please try again.",
      privacyNotice: "Your data will be treated confidentially and used exclusively for contact by our partner real estate agent. Further communication will be directly with the agent.",
      requiredFields: "All fields marked with * are required"
    },
    // Facility Showcase
    facilityShowcase: {
      label: "OUR FACILITY",
      titleStart: "World-Class",
      titleAccent: "Infrastructure",
      subtitle: "Experience state-of-the-art padel facilities with professional equipment"
    },
    // WhatsApp Community
    whatsappCommunity: {
      title: "WhatsApp Community",
      subtitle: "Stay up to date on events, tournaments, and exclusive offers",
      joinBtn: "Join Now"
    },
    // WhatsApp Bot Gate
    whatsappGate: {
      title: "Open WhatsApp",
      body: "Quick confirmation step — keeps our community bot-free.",
      confirm: "I'm a human — Open WhatsApp",
      cancel: "Cancel"
    },
    // Academy Page
    academyPage: {
      label: "PADEL ACADEMY",
      heroTitleStart: "Academy",
      heroTitleEnd: "& Training",
      heroSubtitle: "Switzerland's leading Padel Academy with 60+ active kids and 3 professional full-time coaches",
      bookViaWhatsapp: "Book Training via WhatsApp",
      packagesLabel: "TRAINING PACKAGES",
      packagesTitleStart: "Our",
      packagesTitleAccent: "Trainings",
      packagesSubtitle: "Professional training for all levels – from beginner to pro",
      popular: "Popular",
      bookNow: "Book Now",
      pkg1Title: "Private Training",
      pkg1Desc: "1 on 1 coaching for fast technical & tactical progress",
      pkg1Duration: "hour",
      pkg1Feat1: "Personalized 1 on 1 instructions",
      pkg1Feat2: "Flexible scheduling to fit your schedule",
      pkg1Feat3: "Customized drill and gameplan focus",
      pkg1PriceNote: "from",
      pkg2Title: "Beginner Training",
      pkg2Desc: "Mondays and Thursdays",
      pkg2Duration: "person",
      pkg2Feat1: "Max 4 players on the court",
      pkg2Feat2: "Analytical and game-based methodology",
      pkg2Feat3: "Equipment included",
      pkg3Title: "Junior Academy",
      pkg3Desc: "Special program for children & teens",
      pkg3Duration: "3 months",
      pkg3Feat1: "Analytical & game-based methodology",
      pkg3Feat2: "Recreational or competitive focus",
      pkg3Feat3: "Top academy in Switzerland",
      pkg3PriceNote: "from",
      adultAcademy: {
        sectionLabel: "ADULT ACADEMY",
        sectionTitleStart: "Adult",
        sectionTitleAccent: "Academy",
        sectionSubtitle: "12-week program for adults — tailored to your level.",
        programBadge: "12-week program",
        feat1: "1× per week, fixed group, fixed time",
        feat2: "Program customized to your level",
        feat3: "Minimum 3 players (up to 4)",
        beforeLabel: "Before 17:00",
        beforePrice: "799 CHF",
        beforeNote: "per person",
        afterLabel: "After 17:00",
        afterPrice: "999 CHF",
        afterNote: "per person",
        groupNote: "Minimum group of 3 players, up to 4",
        ctaButton: "Sign up via WhatsApp"
      },
      juniorAbos: {
        sectionLabel: "JUNIOR ACADEMY MEMBERSHIPS",
        sectionTitleStart: "Junior",
        sectionTitleAccent: "Memberships",
        sectionSubtitle: "Season always starts in September. Choose the membership that fits your child.",
        season: "Season starts in September",
        threeMonthLabel: "3-MONTH PASS",
        threeMonthTitle: "3-Month Trial",
        threeMonthDesc: "Perfect to get a real feel for the Junior Academy.",
        threeMonthOption1: "1× per week",
        threeMonthPrice1: "399 CHF",
        yearlyLabel: "YEARLY PASS",
        yearlyTitle: "Recreational",
        yearlyDesc: "For recreational players — full season, best price per lesson.",
        yearlyOption1: "1× per week",
        yearlyPrice1: "1'299 CHF",
        yearlyOption2: "2× per week",
        yearlyPrice2: "2'099 CHF",
        competitiveLabel: "COMPETITIVE",
        competitiveTitle: "Competitive Players",
        competitiveDesc: "For ambitious juniors chasing tournament goals.",
        competitiveOption1: "3× per week minimum",
        competitiveOption2: "On-court + off-court coaching",
        competitivePrice: "On request",
        competitiveCta: "Get in touch",
        popular: "Popular",
        ctaTitle: "Ready to start?",
        ctaSubtitle: "Secure your spot for the upcoming season. Drop us a WhatsApp — we'll guide you through it.",
        ctaButton: "Sign up via WhatsApp"
      },
      ageGroupsLabel: "AGE GROUPS",
      ageGroupsTitleStart: "Training for",
      ageGroupsTitleAccent: "Everyone",
      age1Name: "Mini Padel",
      age1Range: "6-8 years",
      age1Level: "Beginner",
      age2Name: "Kids Training",
      age2Range: "9-12 years",
      age2Level: "Beginner - Advanced",
      age3Name: "Junior Elite",
      age3Range: "13-17 years",
      age3Level: "Advanced - Pro",
      age4Name: "Adults",
      age4Range: "18+ years",
      age4Level: "All Levels",
      coachesTitleStart: "3 Full-time",
      coachesTitleAccent: "Coaches",
      ctaTitle: "Ready to Start?",
      ctaSubtitle: "Contact us via WhatsApp and we'll help you find the perfect training",
      juniorTrial: {
        label: "FREE TRIAL LESSON",
        juniorsOnly: "For kids & teenagers only (ages 4–17)",
        title: "Book a Free",
        titleAccent: "Trial Lesson",
        subtitle: "Before signing up for our junior training, your child can try a free lesson with our professional coaches. Fill in the form — we'll be in touch shortly.",
        scrollCta: "Book Trial Lesson",
        formTitle: "Trial Lesson Sign-Up",
        parentSection: "Parent details",
        parentName: "Parent name",
        parentNamePh: "First and last name",
        parentEmail: "Email",
        parentEmailPh: "your.email@example.com",
        parentPhone: "Phone",
        parentPhonePh: "+41 79 123 45 67",
        childSection: "Child details",
        childName: "Child's name",
        childNamePh: "First name",
        childAge: "Age (years)",
        childAgePh: "e.g. 9",
        availabilitySection: "Availability",
        daysLabel: "Which weekdays is your child available?",
        daysHint: "Select all that apply — junior training runs Mon–Fri only",
        days: { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri" },
        timeLabel: "How early can your child arrive?",
        timeHint: "Junior training runs hourly from 14:00 to 17:00 (Mon–Fri)",
        time1400: "14:00",
        time1500: "15:00",
        time1600: "16:00",
        time1700: "17:00",
        experienceSection: "Racket-sport experience",
        expNone: "No experience",
        expSome: "Some experience (tennis, squash, badminton…)",
        expPadel: "Already plays padel",
        expDetailsLabel: "Experience details (optional)",
        expDetailsPh: "e.g. 2 years of tennis at a local club",
        notesLabel: "Message / notes (optional)",
        notesPh: "Allergies, special needs, requests…",
        consent: "I agree that my data may be used to process this request.",
        privacyNotice: "Your information is treated confidentially and used only to contact you about the trial lesson.",
        requiredFields: "Fields marked with * are required",
        submit: "Request Trial Lesson",
        sending: "Sending",
        successTitle: "Request received",
        successMessage: "Thank you! We'll be in touch shortly.",
        errorAge: "This sign-up is only for kids & teenagers aged 4 to 17.",
        errorDays: "Please select at least one day.",
        errorConsent: "Please agree to the data usage.",
        errorGeneric: "Something went wrong. Please try again."
      }
    },
    // Testimonials
    testimonials: {
      label: "REVIEWS",
      titleStart: "What our",
      titleAccent: "community says",
      basedOn: "Based on",
      reviews: "reviews",
      readAll: "Read all reviews on Google",
      r1Text: "Best padel hall in the region. Great atmosphere, top courts and a superb community. I come every week for the mixin and it's always a blast!",
      r2Text: "My kids love the Junior Academy. Coaches Fabrizio, Antoine and Alejandro are incredibly dedicated. Top level for Swiss standards.",
      r3Text: "Only 20 minutes from Zurich and absolutely professional facility. 8 indoor courts, sports bar, racket rental – everything you need. Highly recommended.",
      r4Text: "As a beginner I felt welcome from day one. Patient coaches, relaxed vibe. Made real progress within just a few weeks.",
      r5Text: "The sports bar after the game is gold. 12 TVs, good snacks and always friendly people. No wonder Padelarena is the meeting point.",
      r6Text: "I've played at many clubs — Padelarena is clearly the nicest in German-speaking Switzerland. Online booking works flawlessly."
    },
    closurePopup: {
      badge: "We're back!",
      title: "Reopening September 19",
      dateRange: "This weekend — Saturday 19.9.",
      body: "We made it — Padelarena reopens this weekend! Book your court online. The first mixing is already on Tuesday, September 22 — also bookable via bookpadelarena.ch.",
      bookingHook: "Book online now at bookpadelarena.ch",
      bookingCta: "Reserve a court",
      communityHook: "Stay in the loop — join our WhatsApp community:",
      cta: "Join the Community",
      dismiss: "Close"
    },
    chat: {
      openLabel: "Open chat with our AI assistant",
      closeLabel: "Close chat",
      title: "Padelarena Assistant",
      subtitle: "Ask me anything about Padelarena",
      welcome: "Hi! Ask me anything about Padelarena 👋",
      waLabel: "Open WhatsApp",
      waNumber: "+41 79 916 08 34",
      placeholder: "Type your question…",
      sendLabel: "Send",
      errorFallback: "Sorry, something's off right now. Please drop us a WhatsApp: +41 79 916 0834.",
      disclaimer: "AI answers may be inaccurate. For anything important: WhatsApp +41 79 916 0834."
    }
  },
  it: {
// Featured upcoming events
    featuredEvents: {
      juniorCamp: {
        accent: "blue",
        image: "https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/9repnipw_Junior%20Padel%20Camp%20Weihnachtsferien%20-%20Print%20-%20Flyer.png",
        alt: "PAW Lions Junior Padel Camp — vacanze di Natale, 21–24 dicembre 2026",
        badge: "Junior Camp · 21–24 dic.",
        title: "PAW Lions Junior Padel Camp",
        matchup: "Vacanze di Natale a Padelarena — ogni giorno dalle 9:00 alle 12:00, welcome package e snack inclusi, coach in campo per tutti i livelli.",
        dateLabel: "Date",
        dateValue: "21–24 dicembre 2026",
        timeLabel: "Orario",
        timeValue: "09:00 – 12:00",
        priceLabel: "Prezzo",
        priceValue: "CHF 299 · welcome package e snack inclusi",
        reserveBadge: "Iscriviti ora",
        reserveText: "Posti limitati — iscrivi il tuo bambino via email a info@padelarena.ch o via WhatsApp.",
        emailTo: "info@padelarena.ch",
        emailSubject: "Junior Padel Camp — Iscrizione (21–24 dic.)",
        emailCta: "info@padelarena.ch",
        waCta: "Iscrizione via WhatsApp",
        waText: "Ciao! Vorrei iscrivere mio figlio al PAW Lions Junior Padel Camp (21–24 dicembre, 9:00–12:00)."
      },
      wmOpening: {
        accent: "red",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png",
        alt: "Apertura Mondiali — Svizzera vs Qatar — dal vivo al Sports Bar di Padelarena Wädenswil",
        badge: "Dal vivo al Sports Bar · 13 giugno",
        title: "Apertura Mondiali — Svizzera vs Qatar",
        matchup: "Insieme. Più forte. Svizzera. Una partita. Un paese. Un momento.",
        dateLabel: "Data",
        dateValue: "Sabato 13 giugno",
        timeLabel: "Inizio",
        timeValue: "21:00",
        reserveBadge: "Prenotazione obbligatoria!",
        reserveText: "Posti limitati – chiamaci in anticipo per riservare un tavolo: +41 43 833 0834.",
        waCta: "Prenota via WhatsApp",
        waText: "Ciao! Vorrei prenotare un tavolo per l'apertura dei Mondiali (Svizzera vs Qatar, sab 13 giugno, 21:00)."
      },
      frauenSocial: {
        accent: "pink",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/pvm3s2px_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%284%29.png",
        alt: "Women's Social — Padel, Community, Good Vibes — Sabato 20 giugno da Padelarena Wädenswil",
        badge: "Solo donne · 20 giugno",
        title: "Women's Social — Una serata per noi",
        matchup: "Padel. Community. Good Vibes. Iscrivetevi in squadra!",
        dateLabel: "Data",
        dateValue: "Sabato 20 giugno",
        timeLabel: "Orario",
        timeValue: "16:00 – ca. 18:30",
        priceLabel: "Prezzo",
        priceValue: "50 CHF a persona · incl. prosecco e snack",
        reserveBadge: "Iscrivetevi in squadra",
        reserveText: "I posti sono limitati – iscrivetevi in squadra via +41 43 833 0834 o WhatsApp.",
        waCta: "Iscriviti via WhatsApp",
        waText: "Ciao! Vorremmo iscriverci in squadra per il Women's Social di sabato 20 giugno (16:00–18:30)."
      },
      lastTime: {
        accent: "blue",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/3nv5m3bc_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%289%29.png",
        alt: "One Last Time Under The Old Roof — Torneo d'addio a Padelarena Wädenswil domenica 28 giugno",
        badge: "Torneo d'addio · 28 giugno",
        title: "One Last Time — Under The Old Roof",
        matchup: "Torneo d'addio al vecchio tetto. Un'ultima volta insieme — rendiamola indimenticabile.",
        dateLabel: "Data",
        dateValue: "Domenica 28 giugno",
        timeLabel: "Orario",
        timeValue: "15:30 – ca. 20:00",
        priceLabel: "Prezzo",
        priceValue: "50 CHF a persona · incl. apéro e drink",
        reserveBadge: "Iscrivetevi in squadra",
        reserveText: "Iscrivetevi subito in squadra! I posti sono limitati – chiama +41 43 833 0834 o scrivici su WhatsApp.",
        waCta: "Iscriviti via WhatsApp",
        waText: "Ciao! Vorremmo iscriverci in squadra per il torneo d'addio One Last Time di domenica 28 giugno (15:30–20:00)."
      }
    },
    // Navigation
    nav: {
      about: "Chi siamo",
      facilities: "Struttura",
      courts: "Campi",
      services: "Servizi",
      pricing: "Prezzi",
      academy: "Academy",
      events: "Eventi",
      contact: "Contatti",
      bookNow: "Prenota ora"
    },
    // Hero Section
    hero: {
      title: "Benvenuto a Padelarena",
      subtitle: "L'arena di padel con le migliori vibes e community di Wädenswil",
      description: "8 campi indoor • 2 simulatori di golf • Sports Bar • Top Junior Academy",
      bookCourt: "Prenota un campo",
      learnMore: "Scopri di più"
    },
    // About Section
    about: {
      title: "Chi siamo — Padelarena",
      subtitle: "L'arena di padel con la migliore community della Svizzera",
      ogBadge: "Le migliori vibes e community della Svizzera",
      description: "Padelarena Wädenswil è il primo e originale centro di padel in Svizzera. Dal 2017 diamo forma al padel in questo paese – con 8 campi indoor, la principale junior academy del paese, due simulatori di golf e uno Sports Bar con 9 TV per ogni grande partita. A soli 20 minuti da Zurigo, siamo conosciuti per l'atmosfera imbattibile e la migliore community della Svizzera.",
      communityText: "Ma Padelarena è più di un semplice luogo – è una community. Centinaia di giocatori attivi, mixing settimanali, torneo, camp junior e uno Sports Bar che diventa il secondo salotto di tutti dopo la partita. Vieni a farne parte.",
      bookCourtBtn: "Prenota un campo",
      joinCommunityBtn: "Unisciti alla community",
      sportsBarBtn: "Scopri il Sports Bar",
      feature1Title: "8 campi indoor",
      feature1Desc: "Campi da padel professionali con illuminazione ottimale",
      feature2Title: "Top Junior Academy",
      feature2Desc: "60+ bambini in allenamento con 3 coach a tempo pieno",
      feature3Title: "Attivi tutto l'anno",
      feature3Desc: "Struttura indoor per allenarti con qualsiasi condizione meteo"
    },
    // Court Availability
    courtAvailability: {
      title: "Disponibilità campi in tempo reale",
      subtitle: "Stato in tempo reale dei nostri 8 campi indoor",
      liveBadge: "LIVE",
      availableNow: "Libero ora",
      availableNext2h: "Libero in 2h",
      padelCourts: "Campi da padel",
      golfSims: "Simulatori golf",
      golfSim: "Simulatore di Golf",
      todayTimeline: "Slot disponibili oggi",
      tomorrowTimeline: "Disponibilità di domani",
      courtsShort: "campi",
      golfShort: "golf",
      bookSlot: "Prenota questo slot",
      upTo: "Fino a",
      fewLeft: "Pochi rimasti",
      full: "Completo",
      eveningFullNotice: "Stasera è tutto prenotato. Riprova domani o prendi uno slot più presto oggi.",
      dayFinished: "La giornata di gioco di oggi è terminata — prenota un campo per domani.",
      bookTomorrow: "Prenota per domani",
      free: "Libero",
      busy: "Occupato",
      indoor: "Indoor",
      outdoor: "Outdoor",
      nextFree: "Prossimo slot libero",
      bookedAllDay: "Tutto prenotato oggi",
      lastUpdated: "Ultimo aggiornamento",
      errorMsg: "Al momento non possiamo caricare la disponibilità dei campi. Provaci direttamente sulla piattaforma di prenotazione.",
      comingSoon: "In arrivo",
      comingSoonTitle: "Presto disponibile!",
      comingSoonDesc: "Stiamo lavorando per offrirti la disponibilità dei campi in tempo reale. Nel frattempo, puoi prenotare per telefono o usare la nostra piattaforma di prenotazione online.",
      phoneBooking: "Per telefono: +41 43 833 0834",
      onlineBooking: "Prenota online",
      court: "Campo",
      available: "Disponibile",
      occupied: "Occupato",
      maintenance: "Manutenzione",
      availableIn: "Disponibile in",
      minutes: "minuti",
      refresh: "Aggiorna",
      bookThisCourt: "Prenota questo campo"
    },
    // Facilities
    facilities: {
      title: "La nostra struttura",
      subtitle: "Servizi di livello mondiale per la perfetta esperienza di padel",
      showcaseTitle: "Infrastruttura di livello mondiale",
      showcaseSubtitle: "Vivi una struttura di padel di ultima generazione con attrezzatura professionale",
      showcaseLabel: "LA NOSTRA STRUTTURA",
      exploreCta: "Scopri di più",
      courts: "8 campi da padel indoor",
      courtsDesc: "Campi professionali con illuminazione ottimale e climatizzazione",
      golf: "2 simulatori di golf",
      golfDesc: "Simulatori di golf di ultima generazione per giocare tutto l'anno",
      bar: "Sports Bar & Lounge",
      barDesc: "9 TV con tutto lo sport dal vivo — Champions League, hockey, tennis, padel e altro. Le migliori vibes prima e dopo la partita.",
      lounge: "Area Lounge",
      loungeDesc: "Spazio confortevole per relax e networking",
      shop: "Pro Shop",
      shopDesc: "Attrezzatura completa e noleggio racchette disponibile"
    },
    // Services
    services: {
      title: "I nostri servizi",
      subtitle: "Programmi professionali per tutti i livelli",
      label: "SERVIZI",
      training: "Allenamento di padel",
      trainingDesc: "Lezioni individuali e di gruppo per tutti i livelli con coach certificati",
      academy: "Junior Academy",
      academyDesc: "60+ bambini in allenamento con 3 coach a tempo pieno",
      tournaments: "Torneo & Eventi",
      tournamentsDesc: "Torneo regolari ed eventi speciali per la community",
      camps: "Padel Camp",
      campsDesc: "Camp di allenamento intensivo durante le vacanze scolastiche"
    },
    // Trainers
    trainers: {
      title: "I nostri coach",
      subtitle: "Team professionale di coach certificati",
      meet: "Conosci il nostro team",
      experience: "Esperienza",
      specialty: "Specialità",
      academyDirector: "Direttore dell'Academy",
      coach: "Coach",
      cpo: "CPO - Chief Padel Officer",
      cngo: "CNGO - Chief NextGen Officer",
      academyLeadership: "Direzione Academy",
      nextGenTraining: "Junior e adulti",
      professionalTraining: "Junior e adulti",
      viewBio: "Vedi biografia"
    },
// Coach Page
    coachPage: {
      back: "Indietro",
      backHome: "Torna alla Home",
      notFound: "Coach non trovato",
      bookTraining: "Richiedi un allenamento",
      aboutHeading: "Chi è",
      highlights: "In evidenza",
      languages: "Lingue",
      otherCoaches: "Altri coach",
      bioComingSoon: "Bio in arrivo — siamo in attesa dei dettagli dal coach."
    },
    coachBios: {
      "fabrizio-pavez": {
        paragraphs: [
          "Appassionato di scienze dello sport, biomeccanica e movimento funzionale applicato al padel. Come Academy Director strutturo programmi di allenamento dinamici e basati sulla metodologia, pensati per ottimizzare la performance e prevenire gli infortuni attraverso mobilità, stabilità e resilienza funzionale.",
          "Ho una solida esperienza nello sviluppo sia di giocatori in crescita sia di atleti di alto livello — inclusi juniores selezionati per la Nazionale Svizzera che hanno gareggiato a livello europeo. Sono anche autore di un libro tecnico sul padel e ho condotto seminari e workshop specializzati in diversi club per condividere questa metodologia."
        ],
        highlights: [
          "Academy Director",
          "Specialista in scienze dello sport & biomeccanica",
          "Autore di un libro tecnico sul padel",
          "Ha portato juniores nella Nazionale Svizzera"
        ],
        languages: ["Spagnolo", "Inglese"]
      },
      "antoine-laurent": {
        paragraphs: [
          "Ciao, sono Antoine, 29 anni, originario della Francia. Lo sport di alto livello è sempre stato nel mio DNA. Questa ricerca costante dell'eccellenza mi ha portato nel 2023 a ottenere le mie certificazioni di coach di padel e direttore sportivo, seguite da una formazione specialistica in Spagna.",
          "Dopo un anno a gestire le operazioni sportive e fare coaching in Francia, e un altro anno di coaching in Svizzera, ho sviluppato un approccio completo e su misura. In campo unisco il rigore dell'alto livello allo spirito amichevole del padel per far progredire ogni giocatore e garantirgli il massimo divertimento. Ci vediamo in campo!"
        ],
        highlights: [
          "Coach di padel & direttore sportivo certificato (2023)",
          "Formazione specialistica in Spagna",
          "Francese, con base in Svizzera",
          "Unisce rigore e divertimento del padel"
        ],
        languages: ["Francese", "Inglese", "Spagnolo"]
      },
      "alejandro-nieuwenhuis": {
        paragraphs: [
          "Ciao, sono Alex, 25 anni, di Valencia, Spagna. Sono cresciuto facendo sport e ho finito per laurearmi in scienze dello sport prima ancora di sapere dove volessi arrivare. Dopo qualche anno di tennis sono passato al padel e il feeling è stato immediato — nel giro di un anno giocavo già tornei a Valencia.",
          "Dal 2020 insegno in parallelo alle competizioni, prima in Spagna e ora a Wädenswil. Non vedo l'ora di vederti in campo — cresciamo insieme!"
        ],
        highlights: [
          "Da Valencia, Spagna",
          "Laurea in scienze dello sport",
          "Giocatore di competizione dal 2020",
          "Coach esperto per juniores & adulti"
        ],
        languages: ["Spagnolo", "Inglese"]
      }
    },
    seo: {
      sportsBar: {
        title: "Sports Bar Wädenswil – 9 TV, Champions League dal vivo, hockey su ghiaccio & Premier Padel | Padelarena",
        description: "Il Sports Bar di Wädenswil con 9 TV trasmette in diretta Champions League, Swiss Super League, hockey su ghiaccio della Swiss National League, tornei del Grande Slam di tennis e Premier Padel. Pizza, Flammkuchen, Chnoblibrot, birra alla spina e vino – a soli 20 minuti da Zürich.",
        keywords: "Sports Bar Wädenswil, sports bar Zürichsee, guardare Champions League Zürich, visione Swiss National League, sports bar live Wädenswil, public viewing Wädenswil, pizza Wädenswil, lounge Wädenswil"
      },
      events: {
        title: "Eventi aziendali, weekend in famiglia e compleanni a Wädenswil | Padelarena",
        description: "Padelarena Wädenswil – il luogo ideale per eventi aziendali, team-building, attività per weekend in famiglia con bambini, tornei di padel e feste di compleanno (adulti e bambini). 8 campi indoor, sports bar con 9 TV, catering e simulatore di golf tutto sotto lo stesso tetto.",
        keywords: "evento aziendale Wädenswil, team building Zürich, attività weekend in famiglia Zürich, attività indoor con bambini Zürich, compleanno bambini Wädenswil, torneo padel Svizzera, festa di compleanno Wädenswil, location eventi Zürichsee, festa padel bambini Zürich, weekend con bambini Zürichsee"
      },
      courts: {
        title: "8 campi da padel indoor a Wädenswil – Prenota online | Padelarena",
        description: "8 campi da padel indoor completamente equipaggiati a Wädenswil. Gioco tutto l'anno, illuminazione LED professionale, prenotazione online 24/7. A soli 20 minuti da Zürich.",
        keywords: "padel Wädenswil, campi da padel Zürich, padel indoor Svizzera, prenota padel Zürichsee, noleggio campo padel Wädenswil"
      },
      golf: {
        title: "Simulatore di golf indoor a Wädenswil – gioca tutto l'anno | Padelarena",
        description: "Due simulatori di golf indoor di ultima generazione al Padelarena Wädenswil. I migliori campi del mondo, mazze incluse, prenotazioni individuali e aziendali. 20 minuti da Zürich.",
        keywords: "simulatore golf Wädenswil, golf indoor Zürich, Trackman Zürichsee, golf indoor Svizzera, prenota golf indoor"
      },
      proShop: {
        title: "Pro Shop padel Wädenswil – Head, Babolat, Nox & Padlr | Padelarena",
        description: "Prova le racchette da padel Head, Babolat e Nox in campo prima di acquistarle. Più la nostra linea di abbigliamento Padlr. Pro Shop al Padelarena Wädenswil.",
        keywords: "negozio padel Wädenswil, comprare racchette padel Svizzera, racchette padel Head, Babolat padel, racchette padel Nox, abbigliamento Padlr"
      },
      academy: {
        title: "Padel Junior Academy Wädenswil – Padel per bambini dai 4 anni | Padelarena",
        description: "La padel junior academy leader in Svizzera. Oltre 60 bambini attivi, 3 coach a tempo pieno, 4 fasce d'età dai 4 anni. Lezione di prova gratuita su richiesta — l'attività perfetta per il weekend per famiglie con bambini. Wädenswil, 20 minuti da Zürich.",
        keywords: "padel per bambini Zürich, junior padel academy Svizzera, lezione di prova padel bambini, mini padel Wädenswil, allenamento padel junior Zürich, sport per bambini Wädenswil, scuola di padel Zürichsee, compleanno padel bambini Zürich, attività weekend in famiglia Zürich, sport indoor per bambini Wädenswil, campo padel bambini Svizzera"
      }
    },
    courtsPage: {
      label: "CAMPI DA PADEL",
      titleStart: "8 campi doppio",
      titleAccent: "indoor",
      subtitle: "Campi da padel di ultima generazione, giocabili tutto l'anno – direttamente sul Zürichsee.",
      aboutTitle: "I nostri campi",
      about1: "8 campi doppio indoor completamente coperti con illuminazione LED professionale, vetrate panoramiche e una superficie ad alte prestazioni. Perfetti per partite tra amici, allenamenti e tornei – con qualsiasi tempo.",
      about2: "Ogni campo è prenotabile online in slot da 60, 90 o 120 minuti. Noleggio racchette a 5 CHF a racchetta e palline disponibili in loco – porta scarpe da interno pulite.",
      statCourts: "Campi indoor",
      statIndoor: "Coperti",
      statHours: "Orari lun-ven",
      statRacket: "Per racchetta",
      statSlot: "min per slot",
      hoursTitle: "Orari di apertura",
      hoursWeekday: "Lun – Ven",
      hoursWeekend: "Sab – Dom",
      includedTitle: "Incluso in ogni prenotazione",
      galleryTitle: "Dentro l'arena",
      included: [
        "Campo indoor completamente equipaggiato",
        "Illuminazione LED professionale",
        "Palline incluse",
        "Noleggio racchette: 5 CHF a racchetta",
        "Spogliatoi con docce",
        "Sports Bar dopo la partita"
      ],
      bookCta: "Prenota un campo",
      viewPricing: "Vedi i prezzi",
      faqTitle: "Padel a Wädenswil – FAQ",
      faqs: [
        { q: "Come prenoto un campo da padel a Wädenswil?", a: "Online su bookpadelarena.ch in slot da 60, 90 o 120 minuti, disponibile 24/7 – oppure chiamaci al +41 43 833 0834." },
        { q: "Quanto costa un campo da padel al Padelarena?", a: "Nei giorni feriali prima delle 17:00: 58 CHF/ora. Dopo le 17:00 e nel weekend: 68 CHF/ora. Noleggio racchetta: 5 CHF. Palline incluse." },
        { q: "Devo avere la mia attrezzatura?", a: "No. Le racchette sono disponibili a 5 CHF, le palline sono incluse in ogni prenotazione. Bastano scarpe da interno pulite." },
        { q: "Quanto distante è Padelarena Wädenswil da Zürich?", a: "Circa 20 minuti in auto o con l'S-Bahn (S2) dalla stazione centrale di Zürich. Facile da raggiungere per chi arriva da Zürich, Horgen, Thalwil, Pfäffikon e Richterswil." },
        { q: "Quali sono i vostri orari di apertura?", a: "Lun–Ven 06:00–24:00, Sab–Dom 08:00–20:00." }
      ]
    },
    golfPage: {
      label: "SIMULATORE DI GOLF",
      titleStart: "Golf tutto",
      titleAccent: "l'anno",
      subtitle: "Gioca sui migliori campi del mondo – al chiuso a Wädenswil.",
      aboutTitle: "I nostri simulatori di golf",
      about1: "I nostri due simulatori di golf portano fino a te i campi più belli del mondo – che nevichi, piova o splenda il sole. Feedback realistico, analisi precisa del colpo e una vera sensazione di gioco.",
      about2: "Perfetti per allenamento, divertimento in famiglia o eventi aziendali. Prenota a ore – mazze incluse.",
      featuresTitle: "Cosa ottieni",
      features: [
        "2 simulatori indoor di ultima generazione",
        "Oltre 100 campi di alto livello nel mondo",
        "Mazze incluse",
        "Ideale per principianti e pro",
        "Prenotabile per eventi aziendali"
      ],
      bookCta: "Prenota golf",
      callToBookTitle: "Prenota il simulatore di golf",
      callToBookText: "La prenotazione online per il simulatore di golf non è al momento disponibile. Chiamaci o scrivici su WhatsApp – ti riserviamo volentieri uno slot.",
      callToBookWaCta: "Prenota via WhatsApp",
      callToBookWaText: "Ciao! Vorrei prenotare il simulatore di golf.",
      galleryTitle: "Dentro il simulatore",
      faqTitle: "Simulatore di golf – FAQ",
      faqs: [
        { q: "Come prenoto il simulatore di golf?", a: "Per ora solo per telefono (+41 43 833 0834) o WhatsApp. La prenotazione online tornerà presto disponibile." },
        { q: "Come funziona il simulatore di golf?", a: "Colpisci palline vere con mazze vere in un tracker ad alta velocità che misura con precisione il tuo swing e lo riproduce sullo schermo su campi di livello mondiale." },
        { q: "Serve esperienza?", a: "No. Principianti e pro sono benvenuti allo stesso modo. Le mazze sono incluse – basta portare scarpe da interno pulite." },
        { q: "Quante persone possono giocare insieme?", a: "Fino a 4 per simulatore. Ideale per gruppi di amici o uscite aziendali." },
        { q: "Posso prenotare il simulatore di golf per eventi aziendali?", a: "Sì – combiniamo simulatore di golf, campi da padel e Sports Bar per creare un evento aziendale memorabile. Contattaci per un'offerta." }
      ]
    },
    proShopPage: {
      label: "PRO SHOP",
      titleStart: "Pro",
      titleAccent: "Shop",
      subtitle: "Prova e acquista racchette sul posto, più la nostra linea di abbigliamento Padlr.",
      racketsTitle: "Prova & acquista racchette",
      racketsIntro: "Prova in campo i marchi di padel leader prima di acquistare. Abbiamo i modelli più recenti dei migliori brand:",
      headDesc: "Tecnologia innovativa, equilibrio perfetto – la scelta di molti giocatori pro.",
      babolatDesc: "Qualità francese con racchette potenti per ogni livello.",
      noxDesc: "Marchio spagnolo di padel con top player come Agustín Tapia.",
      clothingTitle: "Abbigliamento Padlr",
      clothingDesc: "La nostra linea di abbigliamento Padlr: capi da padel di alta qualità per allenamenti e partite. Disponibile in negozio.",
      visitTitle: "Passa dal negozio",
      visitDesc: "Vieni a provare le racchette in campo o a farti consigliare dal nostro team. Chiamaci prima così possiamo dedicarti tutta la nostra attenzione.",
      contactUs: "Contattaci",
      faqTitle: "Pro Shop – FAQ",
      faqs: [
        { q: "Quali marchi di padel avete?", a: "Abbiamo i modelli più recenti di Head, Babolat e Nox – più la nostra linea di abbigliamento Padlr per allenamenti e partite." },
        { q: "Posso provare le racchette prima di acquistarle?", a: "Sì – provale in una vera partita sui nostri campi e scegli quella che si adatta al tuo gioco." },
        { q: "Offrite consulenza?", a: "Sì – il nostro team ti aiuta a scegliere la racchetta giusta in base al tuo livello e stile di gioco. Chiamaci un attimo così possiamo dedicarti del tempo." }
      ]
    },
    eventsPage: {
      label: "EVENTI",
      titleStart: "Eventi &",
      titleAccent: "prenotazioni private",
      subtitle: "Tornei, serate mixing, eventi aziendali e di compleanno – tutto sotto lo stesso tetto.",
      upcomingTitle: "Prossimi eventi",
      pausedBadge: "Siamo tornati",
      pausedTitle: "Mixing ed eventi sono tornati!",
      pausedBody: "Padelarena riapre il 19 settembre. Il primo mixing è già martedì 22 settembre. Tornei, mixing femminili, eventi social e public viewing sono di nuovo tutti in programma.",
      pausedNote: "Campi: dal 19 settembre • Primo mixing: martedì 22 settembre 2026.",
      signupHook: "Le iscrizioni per mixing ed eventi passano dal nostro nuovo sistema di prenotazione — tutti devono registrarsi:",
      signupCta: "Iscriviti agli eventi",
      pausedCta: "Resta nella community WhatsApp",
      upcomingPlaceholder: "I prossimi eventi verranno annunciati presto qui.",
      upcomingFollow: "Seguici su Instagram o entra nella nostra community WhatsApp per restare aggiornato.",
      privateTitle: "Eventi privati & aziendali",
      privateIntro: "Che sia un compleanno, un ritiro aziendale o un torneo di club – rendiamo il tuo evento indimenticabile. Campi, Sports Bar e catering completo in esclusiva per il tuo gruppo.",
      corporateTitle: "Eventi aziendali",
      corporateDesc: "Team building, incontri con i clienti o torneo per il personale con padel, simulatore di golf e catering.",
      birthdayTitle: "Feste di compleanno",
      birthdayDesc: "Per bambini, adolescenti e adulti. Divertimento in campo con pizza e drink al bar.",
      tournamentTitle: "Torneo su misura",
      tournamentDesc: "Organizziamo il torneo del tuo club o privato – incluso arbitri e premiazione.",
      ctaTitle: "Pronto a pianificare il tuo evento?",
      ctaSubtitle: "Scrivici o chiamaci – lo adattiamo alle tue esigenze.",
      requestQuote: "Richiedi un'offerta",
      faqTitle: "Eventi – FAQ",
      faqs: [
        { q: "Quante persone possono partecipare a un evento aziendale al Padelarena?", a: "Ospitiamo gruppi da 8 a più di 60 persone. Con 8 campi da padel, 2 simulatori di golf, Sports Bar e Lounge possiamo far svolgere più attività in parallelo." },
        { q: "Offrite catering?", a: "Sì – dagli snack e pizza fino a un catering su misura in base all'occasione e al budget." },
        { q: "Posso organizzare un torneo di padel privato?", a: "Assolutamente. Ci occupiamo di programmazione, arbitri e premiazione. Perfetto per club, aziende o addii al celibato/nubilato." },
        { q: "Cosa consigliate per una festa di compleanno?", a: "Partite di padel o il simulatore di golf combinati con pizza e drink al Sports Bar – amato da bambini, adolescenti e adulti." },
        { q: "Come prenoto un evento?", a: "Invia una richiesta tramite il nostro modulo di contatto o chiama il +41 43 833 0834. Rispondiamo entro un giorno lavorativo." }
      ]
    },
    sportsBarPage: {
      label: "SPORTS BAR & LOUNGE",
      titleStart: "Sports Bar &",
      titleAccent: "Lounge",
      subtitle: "9 TV, tutti i migliori sport in diretta, l'atmosfera migliore – il cuore del Padelarena.",
      aboutTitle: "Il ritrovo per gli sportivi",
      about1: "Il nostro Sports Bar con 9 TV è il punto d'incontro prima e dopo la partita. Che sia Champions League, hockey NHL, un Grande Slam di tennis o un torneo di padel – la partita che vuoi guardare è sempre in onda.",
      about2: "L'area lounge collegata è perfetta per rilassarsi, fare networking o semplicemente concludere la giornata con gli amici. Snack, drink e ottima atmosfera garantiti.",
      statTvs: "TV",
      statOpen: "Aperto",
      statLive: "Sport",
      statVibes: "Atmosfera",
liveTitle: "Live in TV",
      liveSports: ["Champions League", "Premier League", "Bundesliga", "Swiss Super League", "Swiss National League (hockey su ghiaccio)", "NHL Hockey", "Grande Slam di tennis", "Premier Padel", "Formula 1", "Sci alpino", "Coppa del Mondo/Europei di calcio"],
      featuresTitle: "Cosa ti aspetta",
      features: [
        "9 grandi TV con sport live a ogni ora",
        "Pizza, Flammkuchen e Chnoblibrot (pane all'aglio svizzero) appena sfornati",
        "Birra alla spina, una carta dei vini curata e bibite",
        "Zona lounge per rilassarti o fare networking",
        "Perfetto prima o dopo la tua partita",
        "Tutti benvenuti — anche senza prenotazione padel"
      ],
      foodTitle: "Dalla cucina & dal bar",
      featuredEventTitle: "Prossimo grande evento",
      foodItems: ["Pizza", "Flammkuchen", "Chnoblibrot", "Snack", "Birra alla spina", "Vino", "Bibite", "Caffè"],
      ctaTitle: "Vuoi passare o prenotare un tavolo?",
      ctaSubtitle: "Scrivici — ti prenotiamo volentieri un tavolo per te e il tuo gruppo.",
      privateBtn: "Eventi privati",
      faqTitle: "Sports Bar – FAQ",
      faqs: [
        { q: "Quali sport trasmettete live nello Sports Bar?", a: "Sui nostri 9 TV mostriamo Champions League, Premier League, Bundesliga, Swiss Super League, Swiss National League (hockey su ghiaccio), NHL Hockey, i Grande Slam di tennis, Premier Padel, Formula 1, sci alpino e tutti i principali tornei internazionali." },
        { q: "Devo giocare a padel per venire allo Sports Bar?", a: "No, tutti sono benvenuti. Puoi passare, guardare una partita, mangiare e bere – con o senza prenotazione padel." },
        { q: "Posso prenotare un tavolo?", a: "Sì – chiama il +41 43 833 0834. Per grandi partite o gruppi di 6+ persone consigliamo vivamente di prenotare." },
        { q: "Servite da mangiare?", a: "Sì — pizza, Flammkuchen, Chnoblibrot (pane all'aglio svizzero) e snack appena sfornati. Al bar: birra alla spina, una carta dei vini curata, bibite e caffè." },
        { q: "Quando è aperto lo Sports Bar?", a: "Lun–Ven 06:00–24:00, Sab–Dom 08:00–20:00 – lo Sports Bar è aperto durante tutti gli orari della Padelarena." }
      ]
    },
    // Pricing
    pricing: {
      title: "Prezzi",
      subtitle: "Prezzi trasparenti ed equi",
      courtRates: "Affitto Campo",
      weekdayBefore5: "Giorni feriali prima delle 17",
      weekdayAfter5: "Giorni feriali dopo le 17",
      weekend: "Weekend (tutto il giorno)",
      afterFiveOrWeekend: "Dopo le 17 & Weekend",
      price50: "50 CHF",
      price58: "58 CHF",
      price64: "64 CHF",
      price60: "60 CHF",
      price68: "68 CHF",
      perHour: "all'ora",
      perCourt: "per campo",
      racketRental: "Noleggio Racchetta: 5 CHF",
      juniorBadge: "Junior Academy",
      juniorTitle: "Vuoi che i tuoi figli provino il padel?",
      juniorBody: "Che siano completi principianti o già in grado di maneggiare una racchetta — la Junior Padel Academy leader in Svizzera ha il programma giusto. Sessioni di prova, lezioni di gruppo e camp per bambini dai 6 anni fino agli adolescenti, con coach professionisti e una nuova stagione ogni settembre.",
      juniorPriceFrom: "Pass di prova da 399 CHF · Abbonamenti annuali da 1'299 CHF",
      juniorCta: "Scopri la Junior Academy",
      trainingTitle: "Listino Prezzi Ora Allenatore",
      trainingSubtitle: "Prezzo A Persona",
      trainingIncludes: "Allenamento incl. Campo / Racchetta / Palline",
      before5: "Prima delle 17",
      after5Weekend: "Dopo le 17 & Sab/Dom",
      hour1: "1 Ora",
      hour15: "1,5 Ore",
      hour2: "2 Ore",
      players1: "1 Giocatore",
      players2: "2 Giocatori",
      players3: "3 Giocatori",
      players4: "4 Giocatori",
      privateLesson: "Lezione Privata",
      privateBefore5: "Prima delle 17 (Giorni feriali)",
      privateAfter5: "Dopo le 17 & Weekend",
      price100: "100 CHF",
      price120: "120 CHF",
      price140: "140 CHF",
      groupLessons: "Allenamento di Gruppo",
      groupNote: "Il prezzo a persona diminuisce con la dimensione del gruppo",
      note: "Prenotazione online disponibile"
    },
    // Gallery
    gallery: {
      title: "Galleria",
      subtitle: "Scopri le nostre strutture di livello mondiale",
      label: "GALLERIA"
    },
    // Sponsors
    sponsors: {
      title: "I Nostri Partner",
      subtitle: "Fieri partner della community Padelarena",
      label: "PARTNER"
    },
    // Contact
    contact: {
      title: "Contatto",
      subtitle: "Mettiti in contatto con noi",
      label: "CONTATTO",
      address: "Indirizzo",
      addressLine: "Zugerstr. 162, 8820 Wädenswil, Svizzera",
      phone: "Telefono",
      email: "Email",
      hours: "Orari di Apertura",
      hoursWeekday: "Lun-Ven: 6:00 - Mezzanotte",
      hoursWeekend: "Sab-Dom: 8:00 - 20:00",
      formTitle: "Inviaci un Messaggio",
      name: "Nome",
      emailLabel: "Email",
      phoneLabel: "Telefono (opzionale)",
      message: "Messaggio",
      send: "Invia Messaggio",
      success: "Grazie! Ti risponderemo al più presto.",
      error: "Si è verificato un errore. Riprova."
    },
    // Newsletter
    newsletter: {
      title: "Iscriviti alla Newsletter",
      subtitle: "Resta aggiornato su eventi e offerte",
      placeholder: "Il tuo indirizzo email",
      subscribe: "Iscriviti",
      success: "Iscrizione avvenuta con successo!",
      error: "Errore durante l'iscrizione. Riprova."
    },
    // Footer
    footer: {
      description: "L'arena padel con il miglior vibe e la miglior community in Svizzera. 8 campi, 2 simulatori di golf e la Junior Academy leader.",
      quickLinks: "Link Rapidi",
      followUs: "Seguici",
      rights: "Tutti i diritti riservati.",
      realEstate: "Immobiliare"
    },
    // Real Estate Page
    realEstate: {
      title: "Padelarena Real Estate",
      subtitle: "Il Tuo Partner per l'Immobiliare nella Regione",
      description: "Come parte della community Padelarena, ti offriamo un supporto esclusivo nella ricerca della tua proprietà dei sogni o nella vendita della tua casa. Compila il modulo e il nostro agente immobiliare partner ti contatterà.",
      formTitle: "Esprimi il Tuo Interesse",
      name: "Nome",
      namePlaceholder: "Il tuo nome completo",
      email: "Email",
      emailPlaceholder: "tua.email@esempio.com",
      phone: "Telefono",
      phonePlaceholder: "+41 79 123 45 67",
      interest: "Interesse",
      interestBuying: "Acquisto",
      interestSelling: "Vendita",
      interestPlaceholder: "Seleziona il tuo interesse",
      propertyType: "Tipo di Proprietà",
      propertyHouse: "Casa",
      propertyApartment: "Appartamento",
      propertyLand: "Terreno",
      propertyPlaceholder: "Seleziona il tipo di proprietà",
      budget: "Budget",
      budgetPlaceholder: "Seleziona il tuo budget",
      budget1to2: "1 – 2 Mio CHF",
      budget2to3: "2 – 3 Mio CHF",
      budgetOver3: "Oltre 3 Mio CHF",
      location: "Località/Regione",
      locationPlaceholder: "es. Wädenswil, Zurigo",
      message: "Messaggio (opzionale)",
      messagePlaceholder: "Condividi con noi maggiori dettagli...",
      consent: "Acconsento a che i miei dati vengano condivisi con l'agente immobiliare partner, che si occuperà della comunicazione successiva. Ho letto e accettato l'informativa sulla privacy.",
      submit: "Invia Richiesta",
      success: "Grazie! Il nostro partner ti contatterà a breve.",
      error: "Si è verificato un errore. Riprova.",
      privacyNotice: "I tuoi dati saranno trattati in modo confidenziale e utilizzati esclusivamente per il contatto da parte del nostro agente immobiliare partner. La comunicazione successiva avverrà direttamente con l'agente.",
      requiredFields: "Tutti i campi contrassegnati con * sono obbligatori"
    },
    // Facility Showcase
    facilityShowcase: {
      label: "LA NOSTRA STRUTTURA",
      titleStart: "Infrastruttura",
      titleAccent: "di Livello Mondiale",
      subtitle: "Vivi strutture padel all'avanguardia con attrezzatura professionale"
    },
    // WhatsApp Community
    whatsappCommunity: {
      title: "Community WhatsApp",
      subtitle: "Resta aggiornato su eventi, tornei e offerte esclusive",
      joinBtn: "Iscriviti Ora"
    },
    // WhatsApp Bot Gate
    whatsappGate: {
      title: "Apri WhatsApp",
      body: "Un rapido passaggio di conferma — mantiene la nostra community libera da bot.",
      confirm: "Sono umano — Apri WhatsApp",
      cancel: "Annulla"
    },
    // Academy Page
    academyPage: {
      label: "PADEL ACADEMY",
      heroTitleStart: "Academy",
      heroTitleEnd: "& Allenamento",
      heroSubtitle: "La Padel Academy leader in Svizzera con oltre 60 bambini attivi e 3 coach professionisti a tempo pieno",
      bookViaWhatsapp: "Prenota Allenamento via WhatsApp",
packagesLabel: "PACCHETTI DI ALLENAMENTO",
      packagesTitleStart: "I nostri",
      packagesTitleAccent: "Allenamenti",
      packagesSubtitle: "Allenamento professionale per tutti i livelli – dal principiante al pro",
      popular: "Popolare",
      bookNow: "Prenota Ora",
      pkg1Title: "Allenamento Privato",
      pkg1Desc: "Coaching 1 a 1 per progressi tecnici e tattici veloci",
      pkg1Duration: "ora",
      pkg1Feat1: "Istruzioni personalizzate 1 a 1",
      pkg1Feat2: "Orari flessibili adatti al tuo programma",
      pkg1Feat3: "Focus su esercizi e piano di gioco personalizzati",
      pkg1PriceNote: "da",
      pkg2Title: "Allenamento per Principianti",
      pkg2Desc: "Lunedì e giovedì",
      pkg2Duration: "persona",
      pkg2Feat1: "Massimo 4 giocatori in campo",
      pkg2Feat2: "Metodologia analitica e basata sul gioco",
      pkg2Feat3: "Attrezzatura incluso",
      pkg3Title: "Junior Academy",
      pkg3Desc: "Programma speciale per bambini e teenager",
      pkg3Duration: "3 mesi",
      pkg3Feat1: "Metodologia analitica e basata sul gioco",
      pkg3Feat2: "Focus ricreativo o agonistico",
      pkg3Feat3: "Miglior accademia in Svizzera",
      pkg3PriceNote: "da",
      adultAcademy: {
        sectionLabel: "ADULT ACADEMY",
        sectionTitleStart: "Adult",
        sectionTitleAccent: "Academy",
        sectionSubtitle: "Programma di 12 settimane per adulti — su misura per il tuo livello.",
        programBadge: "Programma di 12 settimane",
        feat1: "1× a settimana, gruppo fisso, orario fisso",
        feat2: "Programma personalizzato in base al tuo livello",
        feat3: "Minimo 3 giocatori (fino a 4)",
        beforeLabel: "Prima delle 17:00",
        beforePrice: "799 CHF",
        beforeNote: "a persona",
        afterLabel: "Dopo le 17:00",
        afterPrice: "999 CHF",
        afterNote: "a persona",
        groupNote: "Gruppo minimo di 3 giocatori, fino a 4",
        ctaButton: "Iscriviti via WhatsApp"
      },
      juniorAbos: {
        sectionLabel: "ABBONAMENTI JUNIOR ACADEMY",
        sectionTitleStart: "Abbonamenti",
        sectionTitleAccent: "Junior",
        sectionSubtitle: "La stagione inizia sempre a settembre. Scegli l'abbonamento più adatto a tuo figlio.",
        season: "La stagione inizia a settembre",
        threeMonthLabel: "PASS 3 MESI",
        threeMonthTitle: "Prova di 3 Mesi",
        threeMonthDesc: "Perfetto per farsi un'idea reale della Junior Academy.",
        threeMonthOption1: "1× a settimana",
        threeMonthPrice1: "399 CHF",
        yearlyLabel: "PASS ANNUALE",
        yearlyTitle: "Ricreativo",
        yearlyDesc: "Per giocatori ricreativi — stagione completa, miglior prezzo per lezione.",
        yearlyOption1: "1× a settimana",
        yearlyPrice1: "1'299 CHF",
        yearlyOption2: "2× a settimana",
        yearlyPrice2: "2'099 CHF",
        competitiveLabel: "AGONISTICO",
        competitiveTitle: "Giocatori Agonisti",
        competitiveDesc: "Per junior ambiziosi che puntano a obiettivi nei torneo.",
        competitiveOption1: "Minimo 3× a settimana",
        competitiveOption2: "Coaching in campo + fuori campo",
        competitivePrice: "Su richiesta",
        competitiveCta: "Contattaci",
        popular: "Popolare",
        ctaTitle: "Pronto per iniziare?",
        ctaSubtitle: "Assicurati il tuo posto per la prossima stagione. Scrivici su WhatsApp — ti guideremo passo dopo passo.",
        ctaButton: "Iscriviti via WhatsApp"
      },
      ageGroupsLabel: "FASCE D'ETÀ",
      ageGroupsTitleStart: "Allenamento per",
      ageGroupsTitleAccent: "Tutti",
      age1Name: "Mini Padel",
      age1Range: "6-8 anni",
      age1Level: "Principiante",
      age2Name: "Allenamento Kids",
      age2Range: "9-12 anni",
      age2Level: "Principiante - Avanzato",
      age3Name: "Junior Elite",
      age3Range: "13-17 anni",
      age3Level: "Avanzato - Pro",
      age4Name: "Adulti",
      age4Range: "18+ anni",
      age4Level: "Tutti i Livelli",
      coachesTitleStart: "3 Coach",
      coachesTitleAccent: "a tempo pieno",
      ctaTitle: "Pronto per Iniziare?",
      ctaSubtitle: "Contattaci via WhatsApp e ti aiuteremo a trovare l'allenamento perfetto",
      juniorTrial: {
        label: "LEZIONE DI PROVA GRATUITA",
        juniorsOnly: "Solo per bambini e teenager (4–17 anni)",
        title: "Prenota una",
        titleAccent: "Lezione di Prova Gratuita",
        subtitle: "Prima di iscriversi al nostro allenamento junior, tuo figlio può provare una lezione gratuita con i nostri coach professionisti. Compila il modulo — ti contatteremo a breve.",
        scrollCta: "Prenota Lezione di Prova",
        formTitle: "Iscrizione Lezione di Prova",
        parentSection: "Dati del genitore",
        parentName: "Nome del genitore",
        parentNamePh: "Nome e cognome",
        parentEmail: "Email",
        parentEmailPh: "your.email@example.com",
        parentPhone: "Telefono",
        parentPhonePh: "+41 79 123 45 67",
        childSection: "Dati del bambino/a",
        childName: "Nome del bambino/a",
        childNamePh: "Nome",
        childAge: "Età (anni)",
        childAgePh: "es. 9",
        availabilitySection: "Disponibilità",
        daysLabel: "In quali giorni della settimana tuo figlio è disponibile?",
        daysHint: "Seleziona tutti quelli applicabili — l'allenamento junior si svolge solo dal lunedì al venerdì",
        days: { mon: "Lun", tue: "Mar", wed: "Mer", thu: "Gio", fri: "Ven" },
        timeLabel: "A che ora prima può arrivare tuo figlio?",
        timeHint: "L'allenamento junior si svolge ogni ora dalle 14:00 alle 17:00 (Lun–Ven)",
        time1400: "14:00",
        time1500: "15:00",
        time1600: "16:00",
        time1700: "17:00",
        experienceSection: "Esperienza con sport di racchetta",
        expNone: "Nessuna esperienza",
        expSome: "Qualche esperienza (tennis, squash, badminton…)",
        expPadel: "Gioca già a padel",
        expDetailsLabel: "Dettagli sull'esperienza (opzionale)",
        expDetailsPh: "es. 2 anni di tennis in un club locale",
        notesLabel: "Messaggio / note (opzionale)",
        notesPh: "Allergie, esigenze particolari, richieste…",
        consent: "Accetto che i miei dati vengano utilizzati per elaborare questa richiesta.",
        privacyNotice: "Le tue informazioni sono trattate in modo confidenziale e utilizzate solo per contattarti riguardo alla lezione di prova.",
        requiredFields: "I campi contrassegnati con * sono obbligatori",
        submit: "Richiedi Lezione di Prova",
        sending: "Invio in corso",
        successTitle: "Richiesta ricevuta",
        successMessage: "Grazie! Ti contatteremo a breve.",
        errorAge: "Questa iscrizione è riservata a bambini e teenager tra 4 e 17 anni.",
        errorDays: "Seleziona almeno un giorno.",
        errorConsent: "Devi accettare l'utilizzo dei dati.",
        errorGeneric: "Qualcosa è andato storto. Per favore riprova."
      }
    },
    // Testimonials
    testimonials: {
      label: "RECENSIONI",
      titleStart: "Cosa dice la nostra",
      titleAccent: "community",
      basedOn: "Basato su",
      reviews: "recensioni",
      readAll: "Leggi tutte le recensioni su Google",
      r1Text: "La migliore hall di padel della regione. Atmosfera fantastica, campi al top e una community eccezionale. Vengo ogni settimana per il mixin ed è sempre uno spasso!",
      r2Text: "I miei figli adorano la Junior Academy. I coach Fabrizio, Antoine e Alejandro sono incredibilmente dedicati. Livello top per gli standard svizzeri.",
      r3Text: "Solo 20 minuti da Zurigo e struttura assolutamente professionale. 8 campi indoor, sports bar, noleggio racchette – tutto ciò di cui hai bisogno. Altamente raccomandato.",
      r4Text: "Come principiante mi sono sentito benvenuto dal primo giorno. Coach pazienti, atmosfera rilassata. Ho fatto progressi reali in poche settimane.",
      r5Text: "Il sports bar dopo la partita è oro. 12 TV, snack buoni e sempre persone gentili. Non c'è da meravigliarsi che Padelarena sia il punto d'incontro.",
      r6Text: "Ho giocato in molti club — Padelarena è chiaramente il più bello della Svizzera tedesca. La prenotazione online funziona perfettamente."
    },
    closurePopup: {
      badge: "Siamo tornati!",
      title: "Riapertura il 19 settembre",
      dateRange: "Questo weekend — sabato 19.9.",
      body: "Ce l'abbiamo fatta — Padelarena riapre questo weekend! Prenota il tuo campo online. Il primo mixing è già martedì 22 settembre — anche lui prenotabile su bookpadelarena.ch.",
      bookingHook: "Prenota online su bookpadelarena.ch",
      bookingCta: "Prenota un campo",
      communityHook: "Resta aggiornato — unisciti alla nostra community WhatsApp:",
      cta: "Unisciti alla Community",
      dismiss: "Chiudi"
    },
    chat: {
      openLabel: "Apri chat con il nostro assistente AI",
      closeLabel: "Chiudi chat",
      title: "Assistente Padelarena",
      subtitle: "Chiedimi qualsiasi cosa su Padelarena",
      welcome: "Ciao! Chiedimi qualsiasi cosa su Padelarena 👋",
      waLabel: "Apri WhatsApp",
      waNumber: "+41 79 916 08 34",
      placeholder: "Scrivi la tua domanda…",
      sendLabel: "Invia",
      errorFallback: "Scusa, al momento c'è qualche problema. Scrivici su WhatsApp: +41 79 916 0834.",
      disclaimer: "Le risposte dell'AI potrebbero essere imprecise. Per qualsiasi cosa importante: WhatsApp +41 79 916 0834."
    }
  },
  fr: {
    // Événements à venir
    featuredEvents: {
      juniorCamp: {
        accent: "blue",
        image: "https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/9repnipw_Junior%20Padel%20Camp%20Weihnachtsferien%20-%20Print%20-%20Flyer.png",
        alt: "PAW Lions Junior Padel Camp — vacances de Noël, 21–24 décembre 2026",
        badge: "Junior Camp · 21–24 déc.",
        title: "PAW Lions Junior Padel Camp",
        matchup: "Vacances de Noël à la Padelarena — tous les jours de 9h à 12h, welcome package et snacks inclus, coachs sur place pour tous les niveaux.",
        dateLabel: "Dates",
        dateValue: "21–24 décembre 2026",
        timeLabel: "Horaire",
        timeValue: "09h00 – 12h00",
        priceLabel: "Prix",
        priceValue: "CHF 299 · welcome package et snacks inclus",
        reserveBadge: "Inscris-toi maintenant",
        reserveText: "Places limitées — inscris ton enfant par e-mail à info@padelarena.ch ou via WhatsApp.",
        emailTo: "info@padelarena.ch",
        emailSubject: "Junior Padel Camp — Inscription (21–24 déc.)",
        emailCta: "info@padelarena.ch",
        waCta: "Inscription via WhatsApp",
        waText: "Salut ! J'aimerais inscrire mon enfant au PAW Lions Junior Padel Camp (21–24 décembre, 9h–12h)."
      },
      wmOpening: {
        accent: "red",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png",
        alt: "Ouverture Coupe du Monde — Suisse vs Qatar — en direct au Sports Bar Padelarena",
        badge: "En direct au Sports Bar · 13 juin",
        title: "Ouverture Coupe du Monde — Suisse vs Qatar",
        matchup: "Together. Louder. Switzerland. Un match. Un pays. Un moment.",
        dateLabel: "Date",
        dateValue: "Samedi 13 juin",
        timeLabel: "Début",
        timeValue: "21:00",
        reserveBadge: "Réservation obligatoire !",
        reserveText: "Places limitées — merci d'appeler à l'avance pour réserver une table : +41 43 833 0834.",
        waCta: "Réserver via WhatsApp",
        waText: "Bonjour ! Je souhaite réserver une table pour l'ouverture de la Coupe du Monde (Suisse vs Qatar, sam. 13 juin, 21h00)."
      },
      frauenSocial: {
        accent: "pink",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/pvm3s2px_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%284%29.png",
        alt: "Women's Social — Padel, Communauté, Good Vibes — samedi 20 juin à la Padelarena",
        badge: "Réservé aux femmes · 20 juin",
        title: "Women's Social — Une soirée entre nous",
        matchup: "Padel. Communauté. Good Vibes. Inscris-toi en équipe !",
        dateLabel: "Date",
        dateValue: "Samedi 20 juin",
        timeLabel: "Heure",
        timeValue: "16h00 – env. 18h30",
        priceLabel: "Prix",
        priceValue: "50 CHF par personne · prosecco & snacks inclus",
        reserveBadge: "Inscription en équipe",
        reserveText: "Places limitées — inscrivez-vous en équipe au +41 43 833 0834 ou via WhatsApp.",
        waCta: "S'inscrire via WhatsApp",
        waText: "Bonjour ! Nous souhaitons nous inscrire en équipe pour le Women's Social du samedi 20 juin (16h00–18h30)."
      },
      lastTime: {
        accent: "blue",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/3nv5m3bc_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%289%29.png",
        alt: "One Last Time Under The Old Roof — Tournoi d'adieu à la Padelarena Wädenswil dimanche 28 juin",
        badge: "Tournoi d'adieu · 28 juin",
        title: "One Last Time — Under The Old Roof",
        matchup: "Tournoi d'adieu à l'ancien toit. Une dernière fois ensemble — let's make it unforgettable.",
        dateLabel: "Date",
        dateValue: "Dimanche 28 juin",
        timeLabel: "Heure",
        timeValue: "15h30 – env. 20h00",
        priceLabel: "Prix",
        priceValue: "50 CHF par personne · apéro & boissons inclus",
        reserveBadge: "Inscrivez-vous en équipe",
        reserveText: "Sign up now as a team ! Places limitées – appelez le +41 43 833 0834 ou écrivez-nous sur WhatsApp.",
        waCta: "Inscription via WhatsApp",
        waText: "Bonjour ! Nous souhaitons nous inscrire en équipe pour le tournoi d'adieu One Last Time du dimanche 28 juin (15h30–20h00)."
      }
    },
    // Navigation
    nav: {
      about: "À Propos",
      facilities: "Installations",
      courts: "Terrains",
      services: "Services",
      pricing: "Tarifs",
      academy: "Académie",
      events: "Événements",
      contact: "Contact",
      bookNow: "Réserver"
    },
    // Hero Section
    hero: {
      title: "Bienvenue à Padelarena",
      subtitle: "L'Arène de Padel avec les Meilleures Vibes et Communauté à Wädenswil",
      description: "8 Terrains Indoor • 2 Simulateurs de Golf • Bar Sportif • Académie Junior",
      bookCourt: "Réserver un Terrain",
      learnMore: "En Savoir Plus"
    },
    // About Section
    about: {
      title: "À Propos de Padelarena",
      subtitle: "L'Arène de Padel avec la Meilleure Communauté de Suisse",
      ogBadge: "Meilleures vibes & communauté de Suisse",
      description: "Padelarena Wädenswil est le tout premier centre de padel de Suisse. Depuis 2017, nous façonnons le padel dans le pays — avec 8 terrains indoor, l'académie junior leader, deux simulateurs de golf et un Sports Bar à 9 TVs pour tous les grands matchs. À seulement 20 minutes de Zurich, nous sommes reconnus pour notre ambiance inégalée et la meilleure communauté de Suisse.",
      communityText: "Mais Padelarena, c'est plus qu'un club — c'est une communauté. Des centaines de joueurs et joueuses actifs, des mixings hebdomadaires, des tournois, des camps junior et un Sports Bar qui devient un deuxième salon après le match. Rejoignez-nous.",
      bookCourtBtn: "Réserver un terrain",
      joinCommunityBtn: "Rejoindre la communauté",
      sportsBarBtn: "Découvrir le Sports Bar",
      feature1Title: "8 Terrains Indoor",
      feature1Desc: "Terrains de padel professionnels avec éclairage optimal",
      feature2Title: "Académie Junior",
      feature2Desc: "60+ enfants avec 3 entraîneurs à temps plein",
      feature3Title: "Ouvert Toute l'Année",
      feature3Desc: "Installation indoor pour s'entraîner par tous les temps"
    },
    // Court Availability
    courtAvailability: {
      title: "Disponibilité des Terrains en Direct",
      subtitle: "État en temps réel de nos 8 terrains indoor",
      liveBadge: "LIVE",
      availableNow: "Libres maintenant",
      availableNext2h: "Libres dans 2h",
      padelCourts: "Terrains de padel",
      golfSims: "Sim. de golf",
      golfSim: "Simulateur de golf",
      todayTimeline: "Créneaux disponibles aujourd'hui",
      tomorrowTimeline: "Disponibilité demain",
      courtsShort: "terrains",
      golfShort: "golf",
      bookSlot: "Réserver ce créneau",
      upTo: "Jusqu'à",
      fewLeft: "Peu",
      full: "Complet",
      eveningFullNotice: "La soirée est complète. Revenez demain ou réservez un créneau plus tôt aujourd'hui.",
      dayFinished: "La journée est terminée — réservez un terrain pour demain.",
      bookTomorrow: "Réserver pour Demain",
      free: "Libre",
      busy: "Occupé",
      indoor: "Indoor",
      outdoor: "Outdoor",
      nextFree: "Prochain créneau libre",
      bookedAllDay: "Complet aujourd'hui",
      lastUpdated: "Dernière mise à jour",
      errorMsg: "Impossible de charger la disponibilité des terrains. Essaie directement sur la plateforme de réservation.",
      comingSoon: "Bientôt Disponible",
      comingSoonTitle: "Bientôt Disponible!",
      comingSoonDesc: "Nous travaillons pour t'offrir la disponibilité des terrains en temps réel. En attendant, tu peux réserver par téléphone ou via notre plateforme de réservation en ligne.",
      phoneBooking: "Par Téléphone: +41 43 833 0834",
      onlineBooking: "Réserver en Ligne",
      court: "Terrain",
      available: "Disponible",
      occupied: "Occupé",
      maintenance: "Maintenance",
      availableIn: "Disponible dans",
      minutes: "minutes",
      refresh: "Actualiser",
      bookThisCourt: "Réserver ce Terrain"
    },
    // Facilities
    facilities: {
      title: "Nos Installations",
      subtitle: "Des équipements de classe mondiale pour une expérience de padel parfaite",
      showcaseTitle: "Infrastructure de Classe Mondiale",
      showcaseSubtitle: "Découvre des installations de padel à la pointe de la technologie avec un équipement professionnel",
      showcaseLabel: "NOTRE INSTALLATION",
      exploreCta: "En savoir plus",
      courts: "8 Terrains de Padel Indoor",
      courtsDesc: "Terrains professionnels avec éclairage optimal et climatisation",
      golf: "2 Simulateurs de Golf",
      golfDesc: "Simulateurs de golf de pointe pour jouer toute l'année",
      bar: "Sports Bar & Lounge",
      barDesc: "9 TVs avec tous les meilleurs sports en direct — Champions League, hockey, tennis, padel et plus. Les meilleures vibes avant et après le match.",
      lounge: "Espace Lounge",
      loungeDesc: "Espace confortable pour se détendre et réseauter",
      shop: "Pro Shop",
      shopDesc: "Équipement complet et location de raquettes disponibles"
    },
    // Services
    services: {
      title: "Nos Services",
      subtitle: "Programmes professionnels pour tous les niveaux",
      label: "SERVICES",
      training: "Entraînement de Padel",
      trainingDesc: "Cours individuels et en groupe pour tous les niveaux avec des entraîneurs certifiés",
      academy: "Académie Junior",
      academyDesc: "60+ enfants avec 3 entraîneurs à temps plein",
      tournaments: "Tournois & Événements",
      tournamentsDesc: "Tournois réguliers et événements spéciaux pour la communauté",
      camps: "Camps de Padel",
      campsDesc: "Camps d'entraînement intensifs pendant les vacances scolaires"
    },
    // Trainers
    trainers: {
      title: "Nos Entraîneurs",
      subtitle: "Équipe professionnelle d'entraîneurs certifiés",
      meet: "Rencontrez notre équipe",
      experience: "Expérience",
      specialty: "Spécialité",
      academyDirector: "Directeur de l'Académie",
      coach: "Entraîneur",
      cpo: "CPO - Chief Padel Officer",
      cngo: "CNGO - Chief NextGen Officer",
      academyLeadership: "Direction de l'Académie",
      nextGenTraining: "Juniors & Adultes",
      professionalTraining: "Juniors & Adultes",
      viewBio: "Voir bio"
    },
    // Coach Page
    coachPage: {
      back: "Retour",
      backHome: "Accueil",
      notFound: "Coach introuvable",
      bookTraining: "Demander un entraînement",
      aboutHeading: "À propos",
      highlights: "Points forts",
      languages: "Langues",
      otherCoaches: "Autres coachs",
      bioComingSoon: "Bio bientôt disponible — nous attendons les détails du coach."
    },
    coachBios: {
      "fabrizio-pavez": {
        paragraphs: [
          "Passionné par les sciences du sport, la biomécanique et le mouvement fonctionnel appliqués au padel. En tant que directeur de l'académie, je structure des programmes d'entraînement dynamiques et axés sur la méthodologie, visant à optimiser la performance et prévenir les blessures grâce à la mobilité, la stabilité et la résilience fonctionnelle.",
          "J'ai une solide expérience dans le développement de joueurs en progression comme d'athlètes de haut niveau — y compris des juniors sélectionnés en équipe nationale suisse pour les compétitions européennes. Je suis également l'auteur de mon propre livre technique sur le padel et j'ai animé des séminaires et ateliers spécialisés dans différents clubs pour partager cette méthodologie."
        ],
        highlights: [
          "Directeur de l'académie",
          "Spécialiste sciences du sport & biomécanique",
          "Auteur d'un livre technique sur le padel",
          "A formé des juniors sélectionnés en équipe nationale suisse"
        ],
        languages: ["Espagnol", "Anglais"]
      },
      "antoine-laurent": {
        paragraphs: [
          "Salut, moi c'est Antoine, 29 ans, originaire de France. Le sport de haut niveau a toujours fait partie de mon ADN. Cette quête d'excellence m'a conduit à obtenir mes certifications d'entraîneur de padel et de directeur sportif en 2023, suivies d'une formation spécialisée en Espagne.",
          "Après un an à gérer les opérations sportives et à coacher en France, puis un an de coaching en Suisse, j'ai développé une approche complète et sur mesure. Sur le court, je combine la rigueur du haut niveau avec l'esprit convivial du padel pour faire progresser chaque joueur tout en lui garantissant un max de fun. À très vite sur le court !"
        ],
        highlights: [
          "Coach de padel & directeur sportif certifié (2023)",
          "Formation spécialisée en Espagne",
          "Français, basé en Suisse",
          "Allie rigueur haut niveau et plaisir du padel"
        ],
        languages: ["Français", "Anglais", "Espagnol"]
      },
      "alejandro-nieuwenhuis": {
        paragraphs: [
          "Salut, moi c'est Alex, 25 ans, de Valence en Espagne. J'ai toujours baigné dans le sport et j'ai fini par faire des études de sport sans encore savoir où j'allais. Après quelques années de tennis, je suis passé au padel et ça a tout de suite accroché — en un an, je jouais déjà des compétitions autour de Valence.",
          "Depuis 2020, je donne des cours en parallèle de mes compétitions, d'abord en Espagne puis maintenant à Wädenswil. Hâte de te retrouver sur le court — on grandit ensemble !"
        ],
        highlights: [
          "De Valence, Espagne",
          "Diplômé en sciences du sport",
          "Joueur de compétition depuis 2020",
          "Coach expérimenté juniors & adultes"
        ],
        languages: ["Espagnol", "Anglais"]
      }
    },
    seo: {
      sportsBar: {
        title: "Sports Bar Wädenswil – 9 TVs, Champions League, Hockey & Premier Padel en direct | Padelarena",
        description: "Le Sports Bar à Wädenswil avec 9 TVs diffuse Champions League, Swiss Super League, Swiss National League hockey, Grands Chelems de tennis et Premier Padel en direct. Pizza, Flammkuchen, Chnoblibrot, bière pression et vin – à 20 min de Zurich.",
        keywords: "Sports Bar Wädenswil, bar sportif lac de Zurich, regarder Champions League Zurich, Swiss National League diffusion, public viewing Wädenswil, pizza Wädenswil, lounge Wädenswil"
      },
      events: {
        title: "Événements d'entreprise, week-ends en famille & anniversaires à Wädenswil | Padelarena",
        description: "Padelarena Wädenswil – le lieu idéal pour événements d'entreprise, team building, activité de week-end en famille avec enfants, tournois de padel et anniversaires (adultes & enfants). 8 terrains indoor, sports bar avec 9 TVs, restauration et simulateur de golf sous un même toit.",
        keywords: "événement entreprise Wädenswil, team building Zurich, activité week-end en famille Zurich, activité indoor avec enfants Zurich, anniversaire enfants Wädenswil, tournoi padel Suisse, anniversaire Wädenswil, lieu événement lac de Zurich, padel enfants Zurich, week-end avec enfants Zurich"
      },
      courts: {
        title: "8 Terrains de Padel Indoor à Wädenswil – Réservation en ligne | Padelarena",
        description: "8 terrains de padel indoor entièrement équipés à Wädenswil. Jouez toute l'année, éclairage LED professionnel, réservation en ligne 24h/24. À 20 min de Zurich.",
        keywords: "padel Wädenswil, terrains de padel Zurich, padel indoor Suisse, réserver padel lac de Zurich, location terrain padel"
      },
      golf: {
        title: "Simulateur de Golf Indoor à Wädenswil – jeu toute l'année | Padelarena",
        description: "Deux simulateurs de golf indoor à la pointe à la Padelarena Wädenswil. Meilleurs parcours du monde, clubs inclus, réservations individuelles et entreprise. À 20 min de Zurich.",
        keywords: "simulateur golf Wädenswil, golf indoor Zurich, golf simulator lac de Zurich, golf indoor Suisse"
      },
      proShop: {
        title: "Pro Shop Padel Wädenswil – Head, Babolat, Nox & Padlr | Padelarena",
        description: "Essaie les raquettes de padel Head, Babolat et Nox sur le terrain avant d'acheter. Plus notre ligne Padlr Clothing. Pro Shop à la Padelarena Wädenswil.",
        keywords: "shop padel Wädenswil, acheter raquette padel Suisse, raquettes Head padel, Babolat padel, Nox padel, Padlr clothing"
      },
      academy: {
        title: "Padel Junior Academy Wädenswil – Padel pour enfants dès 4 ans | Padelarena",
        description: "L'académie junior de padel leader en Suisse. 60+ enfants actifs, 3 coachs à plein temps, 4 groupes d'âge dès 4 ans. Cours d'essai gratuit sur demande — l'activité de week-end idéale pour les familles avec enfants. Wädenswil, à 20 min de Zurich.",
        keywords: "padel pour enfants Zurich, académie junior padel Suisse, cours d'essai padel enfants, mini padel Wädenswil, entraînement padel junior Zurich, sport enfants Wädenswil, école de padel lac de Zurich, anniversaire enfants padel Zurich, activité week-end famille Zurich, sport indoor enfants Wädenswil, camp padel enfants Suisse"
      }
    },
    courtsPage: {
      label: "TERRAINS DE PADEL",
      titleStart: "8 Terrains Indoor",
      titleAccent: "de Padel",
      subtitle: "Des terrains de padel à la pointe, jouables toute l'année – au bord du lac de Zurich.",
      aboutTitle: "Nos Terrains",
      about1: "8 terrains indoor entièrement couverts avec éclairage LED professionnel, vitrage panoramique et surface haute performance. Parfaits pour les matchs, l'entraînement et les tournois – par tous les temps.",
      about2: "Chaque terrain est réservable en ligne par créneaux de 60, 90 ou 120 minutes. Location de raquette 5 CHF par raquette et balles sur place – merci d'apporter des chaussures indoor propres.",
      statCourts: "Terrains indoor",
      statIndoor: "Couverts",
      statHours: "Heures lun-ven",
      statRacket: "Par raquette",
      statSlot: "min par créneau",
      hoursTitle: "Horaires d'ouverture",
      hoursWeekday: "Lun – Ven",
      hoursWeekend: "Sam – Dim",
      includedTitle: "Inclus à chaque réservation",
      galleryTitle: "À l'intérieur de l'arène",
      included: [
        "Terrain indoor entièrement équipé",
        "Éclairage LED professionnel",
        "Balles incluses",
        "Location de raquette : 5 CHF par raquette",
        "Vestiaires avec douches",
        "Sports Bar après le match"
      ],
      bookCta: "Réserver un terrain",
      viewPricing: "Voir les tarifs",
      faqTitle: "Padel à Wädenswil – FAQ",
      faqs: [
        { q: "Comment réserver un terrain de padel à Wädenswil ?", a: "En ligne sur bookpadelarena.ch par créneaux de 60, 90 ou 120 minutes, 24h/24 – ou appelle-nous au +41 43 833 0834." },
        { q: "Combien coûte un terrain de padel à la Padelarena ?", a: "En semaine avant 17h : 58 CHF/h. Après 17h et le week-end : 68 CHF/h. Location de raquette : 5 CHF. Balles incluses." },
        { q: "Faut-il son propre matériel ?", a: "Non. Location de raquette pour 5 CHF, balles incluses. Des chaussures indoor propres suffisent." },
        { q: "À quelle distance de Zurich se trouve la Padelarena ?", a: "Environ 20 minutes en voiture ou en S-Bahn (S2) depuis la gare de Zurich. Idéal pour les joueurs de Zurich, Horgen, Thalwil, Pfäffikon et Richterswil." },
        { q: "Quels sont les horaires d'ouverture ?", a: "Lun–Ven 06:00–24:00, Sam–Dim 08:00–20:00." }
      ]
    },
    golfPage: {
      label: "SIMULATEUR DE GOLF",
      titleStart: "Du golf toute",
      titleAccent: "l'année",
      subtitle: "Jouez les plus beaux parcours du monde – en intérieur à Wädenswil.",
      aboutTitle: "Nos simulateurs",
      about1: "Nos deux simulateurs de golf t'emmènent sur les plus beaux parcours du monde – peu importe la météo. Retour réaliste, analyse précise des coups et vraie sensation de jeu.",
      about2: "Idéal pour l'entraînement, le fun en famille ou les événements d'entreprise. Réservation à l'heure – clubs inclus.",
      featuresTitle: "Ce que vous obtenez",
      features: [
        "2 simulateurs indoor de pointe",
        "100+ parcours à travers le monde",
        "Clubs inclus",
        "Pour débutants et pros",
        "Réservable pour des événements d'entreprise"
      ],
      bookCta: "Réserver le Golf",
      callToBookTitle: "Réserver le simulateur de golf",
      callToBookText: "La réservation en ligne pour le simulateur de golf n'est momentanément pas disponible. Appelle-nous ou envoie-nous un WhatsApp – on te réserve un créneau avec plaisir.",
      callToBookWaCta: "Réserver via WhatsApp",
      callToBookWaText: "Bonjour ! Je souhaite réserver le simulateur de golf.",
      galleryTitle: "À l'intérieur du simulateur",
      faqTitle: "Simulateur de golf – FAQ",
      faqs: [
        { q: "Comment réserver le simulateur de golf ?", a: "Pour l'instant uniquement par téléphone (+41 43 833 0834) ou via WhatsApp. La réservation en ligne sera bientôt de retour." },
        { q: "Comment fonctionne le simulateur de golf ?", a: "Tu frappes de vraies balles avec de vrais clubs dans un tracker high-speed qui mesure ton swing avec précision et le rend à l'écran sur des parcours mondialement reconnus." },
        { q: "Faut-il de l'expérience ?", a: "Non. Débutants et pros sont les bienvenus. Les clubs sont inclus – il suffit d'avoir des chaussures indoor propres." },
        { q: "Combien de personnes peuvent jouer en même temps ?", a: "Jusqu'à 4 par simulateur. Idéal pour des groupes d'amis ou d'entreprise." },
        { q: "Le simulateur peut-il être réservé pour un événement d'entreprise ?", a: "Oui – nous combinons simulateur de golf, terrains de padel et Sports Bar pour un événement d'entreprise mémorable. Contactez-nous pour un devis." }
      ]
    },
    proShopPage: {
      label: "PRO SHOP",
      titleStart: "Pro",
      titleAccent: "Shop",
      subtitle: "Testez et achetez des raquettes sur place, plus notre ligne de vêtements Padlr.",
      racketsTitle: "Essayer & acheter des raquettes",
      racketsIntro: "Essaie les meilleures marques de padel directement sur le terrain avant d'acheter. Nous proposons les derniers modèles des grandes marques :",
      headDesc: "Technologie innovante, équilibre parfait – le choix de nombreux pros.",
      babolatDesc: "Qualité française avec des raquettes puissantes pour tous les niveaux.",
      noxDesc: "Marque espagnole avec des joueurs top comme Agustín Tapia.",
      clothingTitle: "Padlr Clothing",
      clothingDesc: "Notre propre ligne Padlr : vêtements de padel haut de gamme pour l'entraînement et les matchs. Disponible en boutique.",
      visitTitle: "Passez à la boutique",
      visitDesc: "Viens essayer des raquettes sur le terrain ou demandez conseil à notre équipe. Appelle-nous avant pour qu'on s'occupe de toi personnellement.",
      contactUs: "Nous contacter",
      faqTitle: "Pro Shop – FAQ",
      faqs: [
        { q: "Quelles marques de padel proposez-vous ?", a: "Nous avons les modèles récents Head, Babolat et Nox – plus notre propre ligne Padlr Clothing pour l'entraînement et les matchs." },
        { q: "Puis-je essayer les raquettes avant d'acheter ?", a: "Oui – essaie-les en match sur nos terrains et choisis celle qui te correspond." },
        { q: "Proposez-vous des conseils ?", a: "Oui – notre équipe t'aide à choisir la raquette adaptée à ton niveau et à ton style. Appelle-nous pour qu'on prenne le temps." }
      ]
    },
    eventsPage: {
      label: "ÉVÉNEMENTS",
      titleStart: "Événements &",
      titleAccent: "réservations privées",
      subtitle: "Tournois, soirées mixin, événements d'entreprise et anniversaires – tout sous un même toit.",
      upcomingTitle: "Événements à venir",
      pausedBadge: "On est de retour",
      pausedTitle: "Les mixings et événements sont de retour !",
      pausedBody: "La Padelarena rouvre le 19 septembre. Le premier mixing a lieu dès mardi 22 septembre. Tournois, mixings femmes, événements sociaux et public viewings, tout est reparti.",
      pausedNote: "Courts : dès le 19 septembre • Premier mixing : mardi 22 septembre 2026.",
      signupHook: "Les inscriptions aux mixings & événements passent par notre nouveau système — tout le monde doit s'inscrire :",
      signupCta: "S'inscrire aux événements",
      pausedCta: "Reste dans la communauté WhatsApp",
      upcomingPlaceholder: "Les prochains événements seront annoncés ici très bientôt.",
      upcomingFollow: "Suis-nous sur Instagram ou rejoignez notre communauté WhatsApp pour ne rien manquer.",
      privateTitle: "Événements privés & entreprise",
      privateIntro: "Anniversaire, événement d'entreprise ou tournoi de club – nous rendons ton événement inoubliable. Terrains, Sports Bar et restauration exclusivement pour ton groupe.",
      corporateTitle: "Événements d'entreprise",
      corporateDesc: "Team building, soirées clients ou tournois pour les employés avec padel, simulateur de golf et restauration.",
      birthdayTitle: "Anniversaires",
      birthdayDesc: "Pour enfants, ados et adultes. Du fun sur le terrain avec pizza et boissons au bar.",
      tournamentTitle: "Tournois sur mesure",
      tournamentDesc: "Nous organisons votre tournoi de club ou privé – arbitres et remise des prix inclus.",
      ctaTitle: "Prêt à organiser ton événement ?",
      ctaSubtitle: "Envoie-nous un message ou appelez-nous – nous le concevons sur mesure.",
      requestQuote: "Demander un devis",
      faqTitle: "Événements – FAQ",
      faqs: [
        { q: "Combien de personnes pour un événement d'entreprise à la Padelarena ?", a: "De 8 à 60+ personnes. Avec 8 terrains de padel, 2 simulateurs de golf, Sports Bar et Lounge, plusieurs groupes peuvent jouer en parallèle." },
        { q: "Proposez-vous un service traiteur ?", a: "Oui – des snacks et pizzas jusqu'au catering sur mesure adapté à ton occasion et ton budget." },
        { q: "Puis-je organiser un tournoi de padel privé ?", a: "Absolument. Nous prenons en charge planning, arbitres et remise des prix. Idéal pour clubs, entreprises ou enterrements de vie de garçon/jeune fille." },
        { q: "Quoi pour un anniversaire ?", a: "Padel ou simulateur de golf combiné à pizza et boissons au Sports Bar – populaire chez les enfants, ados et adultes." },
        { q: "Comment réserver un événement ?", a: "Envoie ta demande via le formulaire de contact ou appelle le +41 43 833 0834. Réponse sous 1 jour ouvré." }
      ]
    },
    sportsBarPage: {
      label: "SPORTS BAR & LOUNGE",
      titleStart: "Sports Bar &",
      titleAccent: "Lounge",
      subtitle: "9 TVs, tous les meilleurs sports en direct, la meilleure ambiance – le cœur de la Padelarena.",
      aboutTitle: "Le rendez-vous des fans de sport",
      about1: "Notre Sports Bar avec 9 TVs est le point de rencontre avant et après le match. Champions League, hockey NHL, Grand Chelem de tennis ou tournoi de padel – le match que tu veux voir est toujours diffusé.",
      about2: "L'espace lounge attenant est parfait pour se détendre, faire du réseautage ou simplement clôturer la journée entre amis. Snacks, boissons et bonne ambiance garantis.",
      statTvs: "TVs",
      statOpen: "Ouvert",
      statLive: "Sports",
      statVibes: "Ambiance",
      liveTitle: "En direct à la TV",
      liveSports: ["Champions League", "Premier League", "Bundesliga", "Swiss Super League", "Swiss National League (hockey sur glace)", "Hockey NHL", "Grands Chelems Tennis", "Premier Padel", "Formule 1", "Ski", "Coupe du Monde / Euro"],
      featuresTitle: "Ce que tu trouveras",
      features: [
        "9 grands TVs avec du sport en direct toute la journée",
        "Pizza, Flammkuchen et Chnoblibrot (pain à l'ail suisse) sortis du four",
        "Bière pression, une carte de vins choisie et boissons sans alcool",
        "Espace lounge pour se détendre ou réseauter",
        "Parfait avant ou après ton match",
        "Tous bienvenus — même sans réservation de padel"
      ],
      foodTitle: "Côté cuisine & bar",
      featuredEventTitle: "Prochain grand événement",
      foodItems: ["Pizza", "Flammkuchen", "Chnoblibrot", "Snacks", "Bière pression", "Vin", "Sans alcool", "Café"],
      ctaTitle: "Passer ou réserver une table ?",
      ctaSubtitle: "Contacte-nous — nous réservons volontiers une table pour toi et tes amis.",
      privateBtn: "Événements privés",
      faqTitle: "Sports Bar – FAQ",
      faqs: [
        { q: "Quels sports diffusez-vous en direct au Sports Bar ?", a: "Sur nos 9 TVs : Champions League, Premier League, Bundesliga, Swiss Super League, Swiss National League (hockey sur glace), hockey NHL, Grands Chelems de tennis, Premier Padel, Formule 1, ski et tous les grands tournois internationaux en direct." },
        { q: "Faut-il jouer au padel pour venir au Sports Bar ?", a: "Non, tout le monde est bienvenu. Vous pouvez venir regarder un match, manger et boire – avec ou sans réservation de padel." },
        { q: "Puis-je réserver une table ?", a: "Oui – appelez-nous au +41 43 833 0834. Pour les grands matchs ou les groupes de 6+ personnes, nous recommandons fortement la réservation." },
        { q: "Servez-vous à manger ?", a: "Oui — pizza, Flammkuchen, Chnoblibrot (pain à l'ail suisse) et snacks frais sortis du four. Au bar : bière pression, carte de vins choisie, boissons sans alcool et café." },
        { q: "Quels sont les horaires du Sports Bar ?", a: "Lun–Ven 06:00–24:00, Sam–Dim 08:00–20:00 – ouvert pendant tous les horaires de la Padelarena." }
      ]
    },
    // Pricing
    pricing: {
      title: "Tarifs",
      subtitle: "Tarification transparente et équitable",
      courtRates: "Location de Terrain",
      weekdayBefore5: "Semaine avant 17h",
      weekdayAfter5: "Semaine après 17h",
      weekend: "Week-end (toute la journée)",
      afterFiveOrWeekend: "Après 17h & week-end",
      price50: "50 CHF",
      price58: "58 CHF",
      price64: "64 CHF",
      price60: "60 CHF",
      price68: "68 CHF",
      perHour: "par heure",
      perCourt: "par terrain",
      racketRental: "Location de Raquette: 5 CHF",
      juniorBadge: "Junior Academy",
      juniorTitle: "Tu veux que tes enfants essaient le padel ?",
      juniorBody: "Que ce soit de purs débutants ou déjà la raquette en main — la principale Junior Padel Academy de Suisse a le bon programme. Séances d'essai, cours en groupe et camps pour enfants dès 6 ans jusqu'aux ados, avec des coachs professionnels et une nouvelle saison chaque septembre.",
      juniorPriceFrom: "Abos d'essai dès 399 CHF · Abos annuels dès 1'299 CHF",
      juniorCta: "Découvrir la Junior Academy",
      trainingTitle: "Tarifs Heure Entraîneur",
      trainingSubtitle: "Prix Par Personne",
      trainingIncludes: "Entraînement incl. Terrain / Raquette / Balles",
      before5: "Avant 17h",
      after5Weekend: "Après 17h & Sam/Dim",
      hour1: "1 Heure",
      hour15: "1,5 Heures",
      hour2: "2 Heures",
      players1: "1 Joueur/se",
      players2: "2 Joueurs/ses",
      players3: "3 Joueurs/ses",
      players4: "4 Joueurs/ses",
      privateLesson: "Cours Particulier",
      privateBefore5: "Avant 17h (Semaine)",
      privateAfter5: "Après 17h & Week-end",
      price100: "100 CHF",
      price120: "120 CHF",
      price140: "140 CHF",
      groupLessons: "Cours en Groupe",
      groupNote: "Le prix par personne diminue avec le nombre de participants",
      note: "Réservation en ligne disponible"
    },
    // Gallery
    gallery: {
      title: "Galerie",
      subtitle: "Découvre nos installations de classe mondiale",
      label: "GALERIE"
    },
    // Sponsors
    sponsors: {
      title: "Nos Partenaires",
      subtitle: "Fiers partenaires de la communauté Padelarena",
      label: "PARTENAIRES"
    },
    // Contact
    contact: {
      title: "Contact",
      subtitle: "Contactez-nous",
      label: "CONTACT",
      address: "Adresse",
      addressLine: "Zugerstr. 162, 8820 Wädenswil, Suisse",
      phone: "Téléphone",
      email: "E-mail",
      hours: "Heures d'Ouverture",
      hoursWeekday: "Lun-Ven: 06:00 - 00:00",
      hoursWeekend: "Sam-Dim: 08:00 - 20:00",
      formTitle: "Envoie-nous un Message",
      name: "Nom",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone (optionnel)",
      message: "Message",
      send: "Envoyer le Message",
      success: "Merci! Nous te répondrons bientôt.",
      error: "Une erreur s'est produite. Veuillez réessayer."
    },
    // Newsletter
    newsletter: {
      title: "S'abonner à la Newsletter",
      subtitle: "Restez informé des événements et offres",
      placeholder: "Votre adresse e-mail",
      subscribe: "S'abonner",
      success: "Abonnement réussi!",
      error: "Erreur lors de l'abonnement. Veuillez réessayer."
    },
    // Footer
    footer: {
      description: "L'arène de padel avec les meilleures vibes et communauté en Suisse. 8 terrains, 2 simulateurs de golf et académie junior leader.",
      quickLinks: "Liens Rapides",
      followUs: "Suis-Nous",
      rights: "Tous droits réservés.",
      realEstate: "Immobilier"
    },
    // Real Estate Page
    realEstate: {
      title: "Padelarena Immobilier",
      subtitle: "Votre Partenaire Immobilier dans la Région",
      description: "En tant que membre de la communauté Padelarena, nous t'offrons un soutien exclusif pour trouver la propriété de tes rêves ou vendre ton bien. Remplis le formulaire et notre agent immobilier partenaire te contactera.",
      formTitle: "Exprimer Votre Intérêt",
      name: "Nom",
      namePlaceholder: "Votre nom complet",
      email: "Email",
      emailPlaceholder: "votre.email@exemple.com",
      phone: "Téléphone",
      phonePlaceholder: "+41 79 123 45 67",
      interest: "Intérêt",
      interestBuying: "Acheter",
      interestSelling: "Vendre",
      interestPlaceholder: "Sélectionne ton intérêt",
      propertyType: "Type de Propriété",
      propertyHouse: "Maison",
      propertyApartment: "Appartement",
      propertyLand: "Terrain",
      propertyPlaceholder: "Sélectionnez le type",
      budget: "Budget",
      budgetPlaceholder: "Sélectionnez votre budget",
      budget1to2: "1 – 2 M CHF",
      budget2to3: "2 – 3 M CHF",
      budgetOver3: "Plus de 3 M CHF",
      location: "Emplacement/Région",
      locationPlaceholder: "ex. Wädenswil, Zurich",
      message: "Message (optionnel)",
      messagePlaceholder: "Partagez plus de détails...",
      consent: "J'accepte que mes données soient partagées avec l'agent immobilier partenaire qui gérera la communication ultérieure. J'ai lu et accepté la politique de confidentialité.",
      submit: "Envoyer la Demande",
      success: "Merci! Notre partenaire te contactera bientôt.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      privacyNotice: "Vos données seront traitées de manière confidentielle et utilisées exclusivement pour le contact par notre agent immobilier partenaire. La communication ultérieure se fera directement avec l'agent.",
      requiredFields: "Tous les champs marqués d'un * sont obligatoires"
    },
    // Facility Showcase
    facilityShowcase: {
      label: "NOTRE INSTALLATION",
      titleStart: "Infrastructure",
      titleAccent: "de Classe Mondiale",
      subtitle: "Découvre des installations de padel à la pointe de la technologie avec un équipement professionnel"
    },
    // WhatsApp Community
    whatsappCommunity: {
      title: "Communauté WhatsApp",
      subtitle: "Restez informé des événements, tournois et offres exclusives",
      joinBtn: "Rejoindre Maintenant"
    },
    // WhatsApp Bot Gate
    whatsappGate: {
      title: "Ouvrir WhatsApp",
      body: "Une confirmation rapide pour garder notre communauté sans bots.",
      confirm: "Je suis humain – Ouvrir WhatsApp",
      cancel: "Annuler"
    },
    // Academy Page
    academyPage: {
      label: "PADEL ACADEMY",
      heroTitleStart: "Académie",
      heroTitleEnd: "& Entraînement",
      heroSubtitle: "L'académie de padel leader en Suisse avec 60+ enfants actifs et 3 entraîneurs professionnels à temps plein",
      bookViaWhatsapp: "Réserver via WhatsApp",
      packagesLabel: "FORFAITS D'ENTRAÎNEMENT",
      packagesTitleStart: "Nos",
      packagesTitleAccent: "Entraînements",
      packagesSubtitle: "Entraînement professionnel pour tous les niveaux – du débutant au pro",
      popular: "Populaire",
      bookNow: "Réserver",
      pkg1Title: "Cours Particulier",
      pkg1Desc: "Coaching 1 contre 1 pour progresser vite techniquement & tactiquement",
      pkg1Duration: "heure",
      pkg1Feat1: "Instructions personnalisées 1 contre 1",
      pkg1Feat2: "Horaires flexibles selon ton emploi du temps",
      pkg1Feat3: "Exercices et plan de jeu sur mesure",
      pkg1PriceNote: "à partir de",
      pkg2Title: "Entraînement Débutants",
      pkg2Desc: "Lundi et jeudi",
      pkg2Duration: "personne",
      pkg2Feat1: "Max. 4 joueurs sur le court",
      pkg2Feat2: "Méthodologie analytique & basée sur le jeu",
      pkg2Feat3: "Équipement inclus",
      pkg3Title: "Académie Junior",
      pkg3Desc: "Programme spécial pour enfants et adolescents",
      pkg3Duration: "3 mois",
      pkg3Feat1: "Méthodologie analytique & basée sur le jeu",
      pkg3Feat2: "Focus loisir ou compétition",
      pkg3Feat3: "Meilleure académie de Suisse",
      pkg3PriceNote: "à partir de",
      adultAcademy: {
        sectionLabel: "ADULT ACADEMY",
        sectionTitleStart: "Adult",
        sectionTitleAccent: "Academy",
        sectionSubtitle: "Programme de 12 semaines pour adultes — adapté à ton niveau.",
        programBadge: "Programme 12 semaines",
        feat1: "1× par semaine, groupe fixe, horaire fixe",
        feat2: "Programme adapté à ton niveau",
        feat3: "Minimum 3 joueurs (jusqu'à 4)",
        beforeLabel: "Avant 17:00",
        beforePrice: "799 CHF",
        beforeNote: "par personne",
        afterLabel: "Après 17:00",
        afterPrice: "999 CHF",
        afterNote: "par personne",
        groupNote: "Groupe minimum de 3 joueurs, jusqu'à 4",
        ctaButton: "Inscription via WhatsApp"
      },
      juniorAbos: {
        sectionLabel: "ABONNEMENTS JUNIOR ACADEMY",
        sectionTitleStart: "Abos",
        sectionTitleAccent: "Junior",
        sectionSubtitle: "La saison commence toujours en septembre. Choisis l'abonnement qui convient à ton enfant.",
        season: "Début de saison en septembre",
        threeMonthLabel: "ABO 3 MOIS",
        threeMonthTitle: "Découverte 3 mois",
        threeMonthDesc: "Parfait pour bien découvrir la Junior Academy.",
        threeMonthOption1: "1× par semaine",
        threeMonthPrice1: "399 CHF",
        yearlyLabel: "ABO ANNUEL",
        yearlyTitle: "Loisir",
        yearlyDesc: "Pour les joueurs loisir — la saison complète au meilleur prix par leçon.",
        yearlyOption1: "1× par semaine",
        yearlyPrice1: "1'299 CHF",
        yearlyOption2: "2× par semaine",
        yearlyPrice2: "2'099 CHF",
        competitiveLabel: "COMPÉTITION",
        competitiveTitle: "Joueurs de compétition",
        competitiveDesc: "Pour les juniors ambitieux visant la compétition.",
        competitiveOption1: "3× par semaine minimum",
        competitiveOption2: "Coaching on-court + off-court",
        competitivePrice: "Sur demande",
        competitiveCta: "Contacte-nous",
        popular: "Populaire",
        ctaTitle: "Prêt à commencer ?",
        ctaSubtitle: "Réserve ta place pour la prochaine saison. Écris-nous sur WhatsApp – on te guide.",
        ctaButton: "Inscription via WhatsApp"
      },
      ageGroupsLabel: "GROUPES D'ÂGE",
      ageGroupsTitleStart: "Entraînement pour",
      ageGroupsTitleAccent: "Tous",
      age1Name: "Mini Padel",
      age1Range: "6-8 ans",
      age1Level: "Débutant",
      age2Name: "Cours Enfants",
      age2Range: "9-12 ans",
      age2Level: "Débutant - Avancé",
      age3Name: "Junior Élite",
      age3Range: "13-17 ans",
      age3Level: "Avancé - Pro",
      age4Name: "Adultes",
      age4Range: "18+ ans",
      age4Level: "Tous niveaux",
      coachesTitleStart: "3 Coaches",
      coachesTitleAccent: "à Temps Plein",
      ctaTitle: "Prêt à Commencer?",
      ctaSubtitle: "Contacte-nous via WhatsApp et nous t'aiderons à trouver l'entraînement idéal",
      juniorTrial: {
        label: "COURS D'ESSAI GRATUIT",
        juniorsOnly: "Réservé aux enfants & ados (4 à 17 ans)",
        title: "Réserve un cours",
        titleAccent: "d'essai gratuit",
        subtitle: "Avant l'inscription à l'académie, ton enfant peut faire un cours d'essai gratuit avec nos coachs. Remplis le formulaire — nous te recontactons rapidement.",
        scrollCta: "Réserver un cours d'essai",
        formTitle: "Inscription cours d'essai",
        parentSection: "Coordonnées du parent",
        parentName: "Nom du parent",
        parentNamePh: "Prénom et nom",
        parentEmail: "E-mail",
        parentEmailPh: "votre.email@exemple.com",
        parentPhone: "Téléphone",
        parentPhonePh: "+41 79 123 45 67",
        childSection: "Informations sur l'enfant",
        childName: "Nom de l'enfant",
        childNamePh: "Prénom",
        childAge: "Âge (années)",
        childAgePh: "ex. 9",
        availabilitySection: "Disponibilités",
        daysLabel: "Quels jours de la semaine ton enfant est-il disponible?",
        daysHint: "Sélection multiple — l'entraînement junior a lieu uniquement du lundi au vendredi",
        days: { mon: "Lun", tue: "Mar", wed: "Mer", thu: "Jeu", fri: "Ven" },
        timeLabel: "À quelle heure ton enfant peut-il arriver?",
        timeHint: "L'entraînement junior a lieu chaque heure pleine de 14h00 à 17h00 (Lun–Ven)",
        time1400: "14h00",
        time1500: "15h00",
        time1600: "16h00",
        time1700: "17h00",
        experienceSection: "Expérience en sport de raquette",
        expNone: "Aucune expérience",
        expSome: "Un peu d'expérience (tennis, squash, badminton…)",
        expPadel: "Joue déjà au padel",
        expDetailsLabel: "Détails sur l'expérience (optionnel)",
        expDetailsPh: "ex. 2 ans de tennis en club",
        notesLabel: "Message / notes (optionnel)",
        notesPh: "Allergies, particularités, souhaits…",
        consent: "J'accepte que mes données soient utilisées pour traiter cette demande.",
        privacyNotice: "Tes informations sont traitées confidentiellement et utilisées uniquement pour te contacter au sujet du cours d'essai.",
        requiredFields: "Les champs marqués d'un * sont obligatoires",
        submit: "Demander le cours d'essai",
        sending: "Envoi",
        successTitle: "Demande reçue",
        successMessage: "Merci! Nous te recontacterons rapidement.",
        errorAge: "Cette inscription est réservée aux enfants & ados de 4 à 17 ans.",
        errorDays: "Veuillez sélectionner au moins un jour.",
        errorConsent: "Veuillez accepter l'utilisation des données.",
        errorGeneric: "Une erreur s'est produite. Veuillez réessayer."
      }
    },
    // Testimonials
    testimonials: {
      label: "AVIS",
      titleStart: "Ce que dit notre",
      titleAccent: "communauté",
      basedOn: "Basé sur",
      reviews: "avis",
      readAll: "Lire tous les avis sur Google",
      r1Text: "Meilleure salle de padel de la région. Super ambiance, terrains au top et une communauté géniale. Je viens chaque semaine pour le mixin et c'est toujours un plaisir!",
      r2Text: "Mes enfants adorent la Junior Academy. Les coachs Fabrizio, Antoine et Alejandro sont incroyablement engagés. Niveau top pour la Suisse.",
      r3Text: "Seulement 20 minutes de Zurich et installation absolument professionnelle. 8 terrains indoor, sports bar, location de raquettes — tout y est. Vivement recommandé.",
      r4Text: "Débutante, je me suis sentie bien dès le premier jour. Coachs patients, ambiance détendue. J'ai vraiment progressé en quelques semaines.",
      r5Text: "Le sports bar après le match vaut de l'or. 12 TVs, bons snacks et toujours du monde sympa. Pas étonnant que la Padelarena soit le point de rencontre.",
      r6Text: "J'ai joué dans beaucoup de clubs — la Padelarena est clairement le plus beau de Suisse alémanique. La réservation en ligne fonctionne parfaitement."
    },
    closurePopup: {
      badge: "On est de retour !",
      title: "Réouverture le 19 septembre",
      dateRange: "Ce week-end — samedi 19.9.",
      body: "On y est — la Padelarena rouvre ce week-end ! Réserve ton court en ligne. Le premier mixing a lieu dès mardi 22 septembre — également réservable sur bookpadelarena.ch.",
      bookingHook: "Réserve en ligne sur bookpadelarena.ch",
      bookingCta: "Réserver un court",
      communityHook: "Reste informé — rejoins notre communauté WhatsApp :",
      cta: "Rejoindre la communauté",
      dismiss: "Fermer"
    },
    chat: {
      openLabel: "Ouvrir le chat avec notre assistant IA",
      closeLabel: "Fermer le chat",
      title: "Assistant Padelarena",
      subtitle: "Pose-moi tes questions sur la Padelarena",
      welcome: "Salut ! Pose-moi tes questions sur la Padelarena 👋",
      waLabel: "Ouvrir WhatsApp",
      waNumber: "+41 79 916 08 34",
      placeholder: "Ta question…",
      sendLabel: "Envoyer",
      errorFallback: "Désolé, il y a un souci. Écris-nous sur WhatsApp : +41 79 916 0834.",
      disclaimer: "Les réponses IA peuvent être imprécises. Pour l'important : WhatsApp +41 79 916 0834."
    }
  },
  es: {
    // Próximos eventos destacados
    featuredEvents: {
      juniorCamp: {
        accent: "blue",
        image: "https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/9repnipw_Junior%20Padel%20Camp%20Weihnachtsferien%20-%20Print%20-%20Flyer.png",
        alt: "PAW Lions Junior Padel Camp — vacaciones de Navidad, 21–24 de diciembre 2026",
        badge: "Junior Camp · 21–24 dic.",
        title: "PAW Lions Junior Padel Camp",
        matchup: "Vacaciones de Navidad en Padelarena — cada día de 9:00 a 12:00, welcome package y snacks incluidos, entrenadores en pista para todos los niveles.",
        dateLabel: "Fechas",
        dateValue: "21–24 de diciembre de 2026",
        timeLabel: "Horario",
        timeValue: "09:00 – 12:00",
        priceLabel: "Precio",
        priceValue: "CHF 299 · welcome package y snacks incluidos",
        reserveBadge: "Apúntate ya",
        reserveText: "Plazas limitadas — apunta a tu peque por email a info@padelarena.ch o por WhatsApp.",
        emailTo: "info@padelarena.ch",
        emailSubject: "Junior Padel Camp — Inscripción (21–24 dic.)",
        emailCta: "info@padelarena.ch",
        waCta: "Inscripción por WhatsApp",
        waText: "¡Hola! Me gustaría apuntar a mi peque al PAW Lions Junior Padel Camp (21–24 de diciembre, 9:00–12:00)."
      },
      wmOpening: {
        accent: "red",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/ocjnzsxf_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%285%29.png",
        alt: "Apertura del Mundial — Suiza vs Qatar — en directo en el Sports Bar Padelarena",
        badge: "En directo en el Sports Bar · 13 jun",
        title: "Apertura del Mundial — Suiza vs Qatar",
        matchup: "Together. Louder. Switzerland. Un partido. Un país. Un momento.",
        dateLabel: "Fecha",
        dateValue: "Sábado 13 de junio",
        timeLabel: "Inicio",
        timeValue: "21:00",
        reserveBadge: "¡Reserva obligatoria!",
        reserveText: "Plazas limitadas — llama para reservar mesa: +41 43 833 0834.",
        waCta: "Reservar por WhatsApp",
        waText: "¡Hola! Quiero reservar una mesa para la apertura del Mundial (Suiza vs Qatar, sáb 13 jun, 21:00)."
      },
      frauenSocial: {
        accent: "pink",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/pvm3s2px_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%284%29.png",
        alt: "Women's Social — Padel, Comunidad, Good Vibes — sábado 20 de junio en la Padelarena",
        badge: "Solo mujeres · 20 jun",
        title: "Women's Social — Una tarde para nosotras",
        matchup: "Pádel. Comunidad. Good Vibes. ¡Apúntate en equipo!",
        dateLabel: "Fecha",
        dateValue: "Sábado 20 de junio",
        timeLabel: "Hora",
        timeValue: "16:00 – aprox. 18:30",
        priceLabel: "Precio",
        priceValue: "50 CHF por persona · prosecco y snacks incluidos",
        reserveBadge: "Apúntate en equipo",
        reserveText: "Plazas limitadas — apúntate en equipo al +41 43 833 0834 o por WhatsApp.",
        waCta: "Apuntarse por WhatsApp",
        waText: "¡Hola! Queremos apuntarnos en equipo al Women's Social del sábado 20 de junio (16:00–18:30)."
      },
      lastTime: {
        accent: "blue",
        image: "https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/3nv5m3bc_Green%20Colorful%20Travel%20Hiking%20Adventure%20Booking%20Flyer%20%289%29.png",
        alt: "One Last Time Under The Old Roof — Torneo de despedida en Padelarena Wädenswil el domingo 28 de junio",
        badge: "Torneo de despedida · 28 de junio",
        title: "One Last Time — Under The Old Roof",
        matchup: "Torneo de despedida al antiguo techo. Una última vez juntos — let's make it unforgettable.",
        dateLabel: "Fecha",
        dateValue: "Domingo, 28 de junio",
        timeLabel: "Hora",
        timeValue: "15:30 – aprox. 20:00",
        priceLabel: "Precio",
        priceValue: "50 CHF por persona · aperitivo y bebidas incluidos",
        reserveBadge: "Apúntate como equipo",
        reserveText: "¡Sign up now as a team! Plazas limitadas – llama al +41 43 833 0834 o escríbenos por WhatsApp.",
        waCta: "Inscripción por WhatsApp",
        waText: "¡Hola! Queremos apuntarnos en equipo al torneo de despedida One Last Time del domingo 28 de junio (15:30–20:00)."
      }
    },
    // Navigation
    nav: {
      about: "Acerca de",
      facilities: "Instalaciones",
      courts: "Pistas",
      services: "Servicios",
      pricing: "Precios",
      academy: "Academia",
      events: "Eventos",
      contact: "Contacto",
      bookNow: "Reservar Ahora"
    },
    // Hero Section
    hero: {
      title: "Bienvenido a Padelarena",
      subtitle: "La Arena de Pádel con las Mejores Vibes y Comunidad en Wädenswil",
      description: "8 Pistas Indoor • 2 Simuladores de Golf • Bar Deportivo • Academia Junior",
      bookCourt: "Reservar Pista",
      learnMore: "Saber Más"
    },
    // About Section
    about: {
      title: "Acerca de Padelarena",
      subtitle: "La Arena de Pádel con la Mejor Comunidad de Suiza",
      ogBadge: "Las mejores vibes y comunidad de Suiza",
      description: "Padelarena Wädenswil es el primer y original centro de pádel de Suiza. Desde 2017 marcamos el ritmo del pádel en el país — con 8 pistas indoor, la academia junior líder, dos simuladores de golf y un Sports Bar con 9 TVs para todos los grandes partidos. A solo 20 minutos de Zúrich, somos conocidos por nuestro ambiente inigualable y la mejor comunidad de Suiza.",
      communityText: "Pero Padelarena es mucho más que un club — es una comunidad. Cientos de jugadores activos, mixings semanales, torneos, campus junior y un Sports Bar que se convierte en el segundo salón de todos después del partido. Únete a nosotros.",
      bookCourtBtn: "Reservar pista",
      joinCommunityBtn: "Unirse a la comunidad",
      sportsBarBtn: "Descubrir el Sports Bar",
      feature1Title: "8 Pistas Indoor",
      feature1Desc: "Pistas profesionales de pádel con iluminación óptima",
      feature2Title: "Academia Junior Top",
      feature2Desc: "La academia junior líder en Suiza con 60+ niños",
      feature3Title: "Abierto Todo el Año",
      feature3Desc: "Instalación indoor para entrenar con cualquier clima"
    },
    // Court Availability
    courtAvailability: {
      title: "Disponibilidad de Pistas en Vivo",
      subtitle: "Estado en tiempo real de nuestras 8 pistas indoor",
      liveBadge: "LIVE",
      availableNow: "Libres ahora",
      availableNext2h: "Libres en 2h",
      padelCourts: "Pistas de pádel",
      golfSims: "Sim. de golf",
      golfSim: "Simulador de golf",
      todayTimeline: "Huecos disponibles hoy",
      tomorrowTimeline: "Disponibilidad mañana",
      courtsShort: "pistas",
      golfShort: "golf",
      bookSlot: "Reservar este hueco",
      upTo: "Hasta",
      fewLeft: "Pocos",
      full: "Lleno",
      eveningFullNotice: "La noche está completa. Vuelve mañana o reserva un horario más temprano hoy.",
      dayFinished: "El día ha terminado — reserva una pista para mañana.",
      bookTomorrow: "Reservar para Mañana",
      free: "Libre",
      busy: "Ocupada",
      indoor: "Indoor",
      outdoor: "Outdoor",
      nextFree: "Próximo hueco libre",
      bookedAllDay: "Completo hoy",
      lastUpdated: "Última actualización",
      errorMsg: "No se puede cargar la disponibilidad ahora. Intenta directamente en la plataforma de reservas.",
      court: "Pista",
      available: "Disponible",
      occupied: "Ocupada",
      maintenance: "Mantenimiento",
      availableIn: "Disponible en",
      minutes: "minutos",
      refresh: "Actualizar",
      bookThisCourt: "Reservar Esta Pista",
      comingSoon: "Próximamente",
      comingSoonTitle: "¡Próximamente!",
      comingSoonDesc: "Estamos trabajando para ofrecerte la disponibilidad de pistas en tiempo real. Mientras tanto, puedes reservar por teléfono o usar nuestra plataforma de reserva en línea.",
      phoneBooking: "Por Teléfono: +41 43 833 0834",
      onlineBooking: "Reservar Online"
    },
    // Facilities
    facilities: {
      title: "Nuestras Instalaciones",
      subtitle: "Instalaciones de clase mundial para la experiencia perfecta de pádel",
      showcaseTitle: "Infraestructura de Clase Mundial",
      showcaseSubtitle: "Descubra instalaciones de pádel de última generación con equipamiento profesional",
      showcaseLabel: "NUESTRA INSTALACIÓN",
      exploreCta: "Descubrir",
      courts: "8 Pistas de Pádel Indoor",
      courtsDesc: "Pistas profesionales con iluminación óptima y climatización",
      golf: "2 Simuladores de Golf",
      golfDesc: "Simuladores de golf de última generación para jugar todo el año",
      bar: "Sports Bar & Lounge",
      barDesc: "9 TVs con todos los mejores deportes en directo — Champions League, hockey, tenis, pádel y más. Las mejores vibras antes y después del partido.",
      lounge: "Área Lounge",
      loungeDesc: "Espacio cómodo para relajarse y hacer networking",
      shop: "Tienda Pro",
      shopDesc: "Equipamiento completo y alquiler de raquetas disponible"
    },
    // Services
    services: {
      title: "Nuestros Servicios",
      subtitle: "Programas profesionales para todos los niveles",
      label: "SERVICIOS",
      training: "Entrenamiento de Pádel",
      trainingDesc: "Clases individuales y grupales para todos los niveles con entrenadores certificados",
      academy: "Academia Junior",
      academyDesc: "60+ niños entrenando con 3 entrenadores a tiempo completo",
      tournaments: "Torneos y Eventos",
      tournamentsDesc: "Torneos regulares y eventos especiales para la comunidad",
      camps: "Campamentos de Pádel",
      campsDesc: "Campamentos de entrenamiento intensivo durante las vacaciones escolares"
    },
    // Trainers
    trainers: {
      title: "Nuestros Entrenadores",
      subtitle: "Equipo profesional de entrenadores certificados",
      meet: "Conoce a nuestro equipo",
      experience: "Experiencia",
      specialty: "Especialidad",
      academyDirector: "Director de Academia",
      coach: "Entrenador",
      cpo: "CPO - Chief Padel Officer",
      cngo: "CNGO - Chief NextGen Officer",
      academyLeadership: "Liderazgo de Academia",
      nextGenTraining: "Junior & Adultos",
      professionalTraining: "Junior & Adultos",
      viewBio: "Ver bio"
    },
    // Coach Page
    coachPage: {
      back: "Volver",
      backHome: "Inicio",
      notFound: "Entrenador no encontrado",
      bookTraining: "Reservar entrenamiento",
      aboutHeading: "Sobre",
      highlights: "Destacados",
      languages: "Idiomas",
      otherCoaches: "Otros entrenadores",
      bioComingSoon: "Bio próximamente — estamos esperando los detalles del entrenador."
    },
    coachBios: {
      "fabrizio-pavez": {
        paragraphs: [
          "Apasionado por las ciencias del deporte, la biomecánica y el movimiento funcional aplicado al pádel. Como Director de la Academia estructuro programas de entrenamiento dinámicos y basados en la metodología, orientados a optimizar el rendimiento y prevenir lesiones mediante movilidad, estabilidad y resiliencia funcional.",
          "Tengo una experiencia sólida desarrollando tanto a jugadores en progreso como a atletas de alto rendimiento — incluidos juniors seleccionados para la Selección Nacional Suiza para competir a nivel europeo. Además, soy autor de mi propio libro técnico de pádel y he impartido seminarios y workshops especializados en diferentes clubes para compartir esta metodología."
        ],
        highlights: [
          "Director de la Academia",
          "Especialista en ciencias del deporte & biomecánica",
          "Autor de un libro técnico de pádel",
          "Ha llevado a juniors a la Selección Nacional Suiza"
        ],
        languages: ["Español", "Inglés"]
      },
      "antoine-laurent": {
        paragraphs: [
          "Hola, soy Antoine, 29 años, originario de Francia. El deporte de alto nivel siempre ha estado en mi ADN. Esta búsqueda constante de la excelencia me llevó en 2023 a sacar mis certificaciones de entrenador de pádel y director deportivo, seguidas de una formación especializada en España.",
          "Tras un año llevando las operaciones deportivas y entrenando en Francia, y otro año entrenando en Suiza, he desarrollado un enfoque completo y a medida. En pista combino el rigor del alto nivel con el espíritu amable del pádel para que cada jugador progrese y se divierta al máximo. ¡Nos vemos en la pista!"
        ],
        highlights: [
          "Entrenador de pádel & director deportivo certificado (2023)",
          "Formación especializada en España",
          "Francés, con base en Suiza",
          "Combina rigor y diversión del pádel"
        ],
        languages: ["Francés", "Inglés", "Español"]
      },
      "alejandro-nieuwenhuis": {
        paragraphs: [
          "Hola, soy Alex, 25 años, de Valencia, España. Siempre me ha encantado el deporte y acabé estudiando una carrera deportiva antes de saber muy bien a dónde iba. Después de unos años de tenis me pasé al pádel y cogí el deporte muy rápido — en un año ya estaba compitiendo por Valencia.",
          "Desde 2020 doy clases en paralelo a las competiciones, primero en España y ahora en Wädenswil. ¡Nos vemos en la pista — crecemos juntos!"
        ],
        highlights: [
          "De Valencia, España",
          "Licenciado en ciencias del deporte",
          "Jugador de competición desde 2020",
          "Entrenador experimentado para juniors y adultos"
        ],
        languages: ["Español", "Inglés"]
      }
    },
    seo: {
      sportsBar: {
        title: "Sports Bar Wädenswil – 9 TVs, Champions League, Hockey y Premier Padel en directo | Padelarena",
        description: "Sports Bar en Wädenswil con 9 TVs: Champions League, Swiss Super League, Swiss National League hockey hielo, Grand Slams de tenis y Premier Padel en directo. Pizza, Flammkuchen, Chnoblibrot, cerveza de barril y vino – a 20 min de Zúrich.",
        keywords: "Sports Bar Wädenswil, bar deportivo lago Zúrich, ver Champions League Zúrich, Swiss National League directo, public viewing Wädenswil, pizza Wädenswil, lounge Wädenswil"
      },
      events: {
        title: "Eventos de empresa, planes de finde en familia y cumpleaños en Wädenswil | Padelarena",
        description: "Padelarena Wädenswil – el lugar ideal para eventos de empresa, team building, planes de fin de semana en familia con niños, torneos de pádel y cumpleaños (adultos y niños). 8 pistas indoor, sports bar con 9 TVs, catering y simulador de golf bajo un mismo techo.",
        keywords: "evento empresa Wädenswil, team building Zúrich, plan finde familia Zúrich, actividad indoor con niños Zúrich, cumpleaños niños Wädenswil, torneo pádel Suiza, cumpleaños Wädenswil, eventos lago Zúrich, pádel niños Zúrich, finde con niños Zúrich"
      },
      courts: {
        title: "8 Pistas de Pádel Indoor en Wädenswil – Reserva online | Padelarena",
        description: "8 pistas de pádel indoor totalmente equipadas en Wädenswil. Juega todo el año, iluminación LED profesional, reserva online 24/7. A 20 min de Zúrich.",
        keywords: "pádel Wädenswil, pistas de pádel Zúrich, pádel indoor Suiza, reservar pádel lago Zúrich, alquiler pistas pádel"
      },
      golf: {
        title: "Simulador de Golf Indoor en Wädenswil – todo el año | Padelarena",
        description: "Dos simuladores de golf indoor de última generación en Padelarena Wädenswil. Mejores campos del mundo, palos incluidos, reservas individuales y de empresa. A 20 min de Zúrich.",
        keywords: "simulador golf Wädenswil, golf indoor Zúrich, golf simulator lago Zúrich, golf indoor Suiza"
      },
      proShop: {
        title: "Pro Shop Pádel Wädenswil – Head, Babolat, Nox y Padlr | Padelarena",
        description: "Prueba palas de pádel Head, Babolat y Nox en pista antes de comprar. Más nuestra propia línea Padlr Clothing. Pro Shop en Padelarena Wädenswil.",
        keywords: "tienda pádel Wädenswil, comprar pala pádel Suiza, palas Head pádel, Babolat pádel, Nox pádel, Padlr clothing"
      },
      academy: {
        title: "Junior Academy de Pádel Wädenswil – Pádel para niños desde los 6 años | Padelarena",
        description: "La principal Junior Academy de pádel de Suiza. 60+ niños activos, 3 entrenadores a tiempo completo, 4 grupos de edad. Clase de prueba disponible – actividad ideal para familias con niños en fin de semana. Wädenswil, a 20 min de Zúrich.",
        keywords: "pádel para niños Zúrich, junior academy pádel Suiza, clase de prueba pádel niños, mini pádel Wädenswil, entrenamiento pádel juvenil Zúrich, deporte niños Wädenswil, escuela pádel lago Zúrich, cumpleaños pádel niños Zúrich, plan finde familia Zúrich, deporte indoor niños Wädenswil, camp pádel niños Suiza"
      }
    },
    courtsPage: {
      label: "PISTAS DE PÁDEL",
      titleStart: "8 Pistas Indoor",
      titleAccent: "de Pádel",
      subtitle: "Pistas de pádel de última generación, jugables todo el año – junto al lago de Zúrich.",
      aboutTitle: "Nuestras pistas",
      about1: "8 pistas indoor totalmente cubiertas con iluminación LED profesional, cristal panorámico y suelo de alto rendimiento. Perfectas para partidos, entrenamiento y torneos – con cualquier clima.",
      about2: "Cada pista se reserva online en franjas de 60, 90 o 120 minutos. Alquiler de pala 5 CHF por pala y pelotas in situ – trae tus zapatillas indoor limpias.",
      statCourts: "Pistas indoor",
      statIndoor: "Cubiertas",
      statHours: "Horas lun-vie",
      statRacket: "Por pala",
      statSlot: "min por franja",
      hoursTitle: "Horarios",
      hoursWeekday: "Lun – Vie",
      hoursWeekend: "Sáb – Dom",
      includedTitle: "Incluido en cada reserva",
      galleryTitle: "Por dentro del pabellón",
      included: [
        "Pista indoor totalmente equipada",
        "Iluminación LED profesional",
        "Pelotas incluidas",
        "Alquiler de pala: 5 CHF por pala",
        "Vestuarios con duchas",
        "Sports Bar tras el partido"
      ],
      bookCta: "Reservar una pista",
      viewPricing: "Ver precios",
      faqTitle: "Pádel en Wädenswil – FAQ",
      faqs: [
        { q: "¿Cómo reservo una pista de pádel en Wädenswil?", a: "Online en bookpadelarena.ch en franjas de 60, 90 o 120 minutos, 24/7 – o llámanos al +41 43 833 0834." },
        { q: "¿Cuánto cuesta una pista en Padelarena?", a: "Entre semana antes de las 17:00: 58 CHF/h. Después de las 17:00 y fines de semana: 68 CHF/h. Alquiler de pala: 5 CHF. Pelotas incluidas." },
        { q: "¿Necesito mi propio material?", a: "No. Alquiler de pala 5 CHF, pelotas incluidas. Solo zapatillas indoor limpias." },
        { q: "¿A qué distancia está Padelarena de Zúrich?", a: "Unos 20 minutos en coche o S-Bahn (S2) desde la estación de Zúrich. Ideal para Zúrich, Horgen, Thalwil, Pfäffikon y Richterswil." },
        { q: "¿Cuál es el horario?", a: "Lun–Vie 06:00–24:00, Sáb–Dom 08:00–20:00." }
      ]
    },
    golfPage: {
      label: "SIMULADOR DE GOLF",
      titleStart: "Golf todo el",
      titleAccent: "año",
      subtitle: "Juega los mejores campos del mundo – indoor en Wädenswil.",
      aboutTitle: "Nuestros simuladores",
      about1: "Nuestros dos simuladores de golf te llevan a los campos más bonitos del mundo – llueva o nieve. Feedback realista, análisis preciso del golpe y verdadera sensación de juego.",
      about2: "Perfecto para entrenamiento, diversión en familia o eventos de empresa. Reserva por horas – palos incluidos.",
      featuresTitle: "Qué incluye",
      features: [
        "2 simuladores indoor de última generación",
        "100+ campos de todo el mundo",
        "Palos incluidos",
        "Para principiantes y pros",
        "Reservable para eventos de empresa"
      ],
      bookCta: "Reservar Golf",
      callToBookTitle: "Reservar el simulador de golf",
      callToBookText: "La reserva online del simulador de golf no está disponible por ahora. Llámanos o escríbenos por WhatsApp – te reservamos un slot encantados.",
      callToBookWaCta: "Reservar por WhatsApp",
      callToBookWaText: "¡Hola! Quiero reservar el simulador de golf.",
      galleryTitle: "Por dentro del simulador",
      faqTitle: "Simulador de golf – FAQ",
      faqs: [
        { q: "¿Cómo reservo el simulador de golf?", a: "Por ahora solo por teléfono (+41 43 833 0834) o WhatsApp. La reserva online estará disponible pronto." },
        { q: "¿Cómo funciona el simulador de golf?", a: "Golpeas pelotas reales con palos reales hacia un tracker de alta velocidad que mide tu swing con precisión y lo proyecta en pantalla en campos de clase mundial." },
        { q: "¿Necesito experiencia?", a: "No. Principiantes y pros son bienvenidos. Palos incluidos – solo zapatillas indoor limpias." },
        { q: "¿Cuántas personas pueden jugar a la vez?", a: "Hasta 4 por simulador. Genial para grupos de amigos o de empresa." },
        { q: "¿Puedo reservar el simulador para un evento de empresa?", a: "Sí – combinamos simulador, pistas de pádel y Sports Bar para un evento inolvidable. Contáctanos para presupuesto." }
      ]
    },
    proShopPage: {
      label: "PRO SHOP",
      titleStart: "Pro",
      titleAccent: "Shop",
      subtitle: "Prueba y compra palas en el sitio, además de nuestra línea Padlr Clothing.",
      racketsTitle: "Probar y comprar palas",
      racketsIntro: "Prueba las marcas líderes de pádel en la pista antes de comprar. Trabajamos con los modelos más recientes de las top marcas:",
      headDesc: "Tecnología innovadora, balance perfecto – la elección de muchos pros.",
      babolatDesc: "Calidad francesa con palas potentes para cualquier nivel.",
      noxDesc: "Marca española con jugadores top como Agustín Tapia.",
      clothingTitle: "Padlr Clothing",
      clothingDesc: "Nuestra propia línea Padlr: ropa de pádel de alta calidad para entrenamiento y partidos. Disponible en tienda.",
      visitTitle: "Pásate por la tienda",
      visitDesc: "Ven a probar palas en la pista o pide consejo a nuestro equipo. Llámanos antes para atenderte personalmente.",
      contactUs: "Contactar",
      faqTitle: "Pro Shop – FAQ",
      faqs: [
        { q: "¿Qué marcas de pádel tienen?", a: "Modelos recientes de Head, Babolat y Nox – además de nuestra propia línea Padlr Clothing para entrenamiento y partidos." },
        { q: "¿Puedo probar las palas antes de comprarlas?", a: "Sí – pruébalas en partido en nuestras pistas y elige la que se adapte a tu juego." },
        { q: "¿Asesoran sobre la pala adecuada?", a: "Sí – nuestro equipo te ayuda según tu nivel y estilo de juego. Llámanos y te dedicamos tiempo." }
      ]
    },
    eventsPage: {
      label: "EVENTOS",
      titleStart: "Eventos &",
      titleAccent: "reservas privadas",
      subtitle: "Torneos, mixin nights, eventos de empresa y cumpleaños – todo bajo un mismo techo.",
      upcomingTitle: "Próximos eventos",
      pausedBadge: "Volvemos",
      pausedTitle: "¡Los mixings y eventos han vuelto!",
      pausedBody: "Padelarena reabre el 19 de septiembre. El primer mixing es ya el martes 22 de septiembre. Torneos, mixings femeninos, eventos sociales y public viewings vuelven todos.",
      pausedNote: "Pistas: desde el 19 de septiembre • Primer mixing: martes 22 de septiembre de 2026.",
      signupHook: "Las inscripciones a mixings y eventos pasan por nuestro nuevo sistema de reservas — todos deben registrarse:",
      signupCta: "Inscribirse a eventos",
      pausedCta: "Únete a la comunidad de WhatsApp",
      upcomingPlaceholder: "Los próximos eventos se anunciarán aquí muy pronto.",
      upcomingFollow: "Síguenos en Instagram o únete a nuestra comunidad de WhatsApp para no perderte nada.",
      privateTitle: "Eventos privados y de empresa",
      privateIntro: "Sea un cumple, un evento de empresa o un torneo de club – hacemos que tu evento sea inolvidable. Pistas, Sports Bar y catering completo en exclusiva para tu grupo.",
      corporateTitle: "Eventos de empresa",
      corporateDesc: "Team building, eventos de cliente o torneos de empleados con pádel, simulador de golf y catering.",
      birthdayTitle: "Cumpleaños",
      birthdayDesc: "Para niños, adolescentes y adultos. Diversión en pista con pizza y bebidas en el bar.",
      tournamentTitle: "Torneos a medida",
      tournamentDesc: "Organizamos tu torneo de club o privado – con árbitros y entrega de premios.",
      ctaTitle: "¿Listo para tu evento?",
      ctaSubtitle: "Envíanos un mensaje o llámanos – lo diseñamos a tu medida.",
      requestQuote: "Solicitar presupuesto",
      faqTitle: "Eventos – FAQ",
      faqs: [
        { q: "¿Cuántas personas caben en un evento de empresa?", a: "De 8 a 60+ personas. Con 8 pistas de pádel, 2 simuladores de golf, Sports Bar y Lounge corremos varios formatos en paralelo." },
        { q: "¿Ofrecen catering?", a: "Sí – desde snacks y pizza hasta catering a medida según ocasión y presupuesto." },
        { q: "¿Puedo organizar un torneo privado de pádel?", a: "Por supuesto. Nos encargamos de calendario, árbitros y entrega de premios. Ideal para clubes, empresas o despedidas." },
        { q: "¿Qué va bien para un cumple?", a: "Pádel o simulador de golf con pizza y bebidas en el Sports Bar – favorito de niños, adolescentes y adultos." },
        { q: "¿Cómo reservo un evento?", a: "Envía la solicitud por el formulario de contacto o llama al +41 43 833 0834. Respondemos en 1 día laborable." }
      ]
    },
    sportsBarPage: {
      label: "SPORTS BAR & LOUNGE",
      titleStart: "Sports Bar &",
      titleAccent: "Lounge",
      subtitle: "9 TVs, todos los mejores deportes en directo, las mejores vibras – el corazón de Padelarena.",
      aboutTitle: "El punto de encuentro para fans del deporte",
      about1: "Nuestro Sports Bar con 9 TVs es el lugar de reunión antes y después del partido. Champions League, hockey NHL, Grand Slam de tenis o torneo de pádel – el partido que quieras ver siempre está puesto.",
      about2: "El área lounge contigua es perfecta para relajarse, hacer networking o cerrar el día con amigos. Snacks, bebidas y buen rollo garantizados.",
      statTvs: "TVs",
      statOpen: "Abierto",
      statLive: "Deportes",
      statVibes: "Vibras",
      liveTitle: "En directo en TV",
      liveSports: ["Champions League", "Premier League", "Bundesliga", "Swiss Super League", "Swiss National League (hockey hielo)", "Hockey NHL", "Grand Slams de Tenis", "Premier Padel", "Fórmula 1", "Esquí", "Mundial / Eurocopa"],
      featuresTitle: "Qué encontrarás",
      features: [
        "9 TVs grandes con deporte en directo todo el día",
        "Pizza, Flammkuchen y Chnoblibrot (pan al ajo suizo) recién hechos",
        "Cerveza de barril, una buena carta de vinos y refrescos",
        "Área lounge para relajarse o hacer networking",
        "Perfecto antes o después de tu partido",
        "Todos bienvenidos — incluso sin reserva de pádel"
      ],
      foodTitle: "De la cocina & barra",
      featuredEventTitle: "Próximo gran evento",
      foodItems: ["Pizza", "Flammkuchen", "Chnoblibrot", "Snacks", "Cerveza de barril", "Vino", "Refrescos", "Café"],
      ctaTitle: "¿Pasarte o reservar mesa?",
      ctaSubtitle: "Contáctanos — reservaremos con gusto una mesa para ti y tu grupo.",
      privateBtn: "Eventos privados",
      faqTitle: "Sports Bar – FAQ",
      faqs: [
        { q: "¿Qué deportes emiten en directo en la Sports Bar?", a: "En nuestras 9 TVs: Champions League, Premier League, Bundesliga, Swiss Super League, Swiss National League (hockey hielo), NHL hockey, Grand Slams de tenis, Premier Padel, Fórmula 1, esquí y todos los grandes torneos internacionales." },
        { q: "¿Tengo que jugar al pádel para venir a la Sports Bar?", a: "No, todos son bienvenidos. Puedes venir a ver un partido, comer y beber – con o sin reserva de pádel." },
        { q: "¿Puedo reservar mesa?", a: "Sí – llama al +41 43 833 0834. Para partidos importantes o grupos de 6+ recomendamos reservar." },
        { q: "¿Sirven comida?", a: "Sí — pizza, Flammkuchen, Chnoblibrot (pan al ajo suizo) y snacks recién hechos. En la barra: cerveza de barril, carta de vinos seleccionada, refrescos y café." },
        { q: "¿Cuál es el horario de la Sports Bar?", a: "Lun–Vie 06:00–24:00, Sáb–Dom 08:00–20:00 – abierto durante todo el horario de Padelarena." }
      ]
    },
    // Pricing
    pricing: {
      title: "Precios",
      subtitle: "Precios transparentes y justos",
      courtRates: "Alquiler de Pista",
      weekdayBefore5: "Entre semana antes de las 17:00",
      weekdayAfter5: "Entre semana después de las 17:00",
      weekend: "Fines de semana (todo el día)",
      afterFiveOrWeekend: "Después de las 17:00 y fines de semana",
      price50: "50 CHF",
      price58: "58 CHF",
      price64: "64 CHF",
      price60: "60 CHF",
      price68: "68 CHF",
      perHour: "por hora",
      perCourt: "por pista",
      racketRental: "Alquiler de Raqueta: 5 CHF",
      juniorBadge: "Junior Academy",
      juniorTitle: "¿Quieres que tus hijos prueben el pádel?",
      juniorBody: "Tanto si son completos principiantes como si ya manejan la pala — la principal Junior Padel Academy de Suiza tiene el programa adecuado. Sesiones de prueba, clases en grupo y campamentos para niños desde los 6 años hasta adolescentes, con entrenadores profesionales y nueva temporada cada septiembre.",
      juniorPriceFrom: "Abonos de prueba desde 399 CHF · Abonos anuales desde 1'299 CHF",
      juniorCta: "Descubrir la Junior Academy",
      trainingTitle: "Tarifas Hora con Entrenador",
      trainingSubtitle: "Precio Por Persona",
      trainingIncludes: "Entrenamiento incl. Pista / Raqueta / Pelotas",
      before5: "Antes de las 17:00",
      after5Weekend: "Después de las 17:00 & Sáb/Dom",
      hour1: "1 Hora",
      hour15: "1,5 Horas",
      hour2: "2 Horas",
      players1: "1 Jugador/a",
      players2: "2 Jugadores/as",
      players3: "3 Jugadores/as",
      players4: "4 Jugadores/as",
      privateLesson: "Clase Particular",
      privateBefore5: "Antes de las 17:00 (entre semana)",
      privateAfter5: "Después de las 17:00 & fines de semana",
      price100: "100 CHF",
      price120: "120 CHF",
      price140: "140 CHF",
      groupLessons: "Entrenamiento Grupal",
      groupNote: "El precio por persona disminuye con el tamaño del grupo",
      note: "Reserva online disponible"
    },
    // Gallery
    gallery: {
      title: "Galería",
      subtitle: "Explore nuestras instalaciones de clase mundial",
      label: "GALERÍA"
    },
    // Sponsors
    sponsors: {
      title: "Nuestros Socios",
      subtitle: "Orgullosos socios de la comunidad Padelarena",
      label: "SOCIOS"
    },
    // Contact
    contact: {
      title: "Contacto",
      subtitle: "Póngase en contacto con nosotros",
      label: "CONTACTO",
      address: "Dirección",
      addressLine: "Zugerstr. 162, 8820 Wädenswil, Suiza",
      phone: "Teléfono",
      email: "Email",
      hours: "Horario de Apertura",
      hoursWeekday: "Lun-Vie: 06:00 - 00:00",
      hoursWeekend: "Sáb-Dom: 08:00 - 20:00",
      formTitle: "Envíanos un mensaje",
      name: "Nombre",
      emailLabel: "Email",
      phoneLabel: "Teléfono (opcional)",
      message: "Mensaje",
      send: "Enviar Mensaje",
      success: "¡Gracias! Nos pondremos en contacto pronto.",
      error: "Ocurrió un error. Por favor, inténtelo de nuevo."
    },
    // Newsletter
    newsletter: {
      title: "Suscribirse al Boletín",
      subtitle: "Manténgase informado sobre eventos y ofertas",
      placeholder: "Su dirección de email",
      subscribe: "Suscribirse",
      success: "¡Suscripción exitosa!",
      error: "Error al suscribirse. Por favor, inténtelo de nuevo."
    },
    // Footer
    footer: {
      description: "La arena de pádel con las mejores vibes y comunidad de Suiza. 8 pistas, 2 simuladores de golf y academia junior líder.",
      quickLinks: "Enlaces Rápidos",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados.",
      realEstate: "Inmobiliaria"
    },
    // Real Estate Page
    realEstate: {
      title: "Padelarena Inmobiliaria",
      subtitle: "Su Socio Inmobiliario en la Región",
      description: "Como parte de la comunidad Padelarena, te ofrecemos apoyo exclusivo para encontrar la propiedad de tus sueños o vender tu casa. Rellena el formulario y nuestro agente inmobiliario asociado se pondrá en contacto contigo.",
      formTitle: "Exprese Su Interés",
      name: "Nombre",
      namePlaceholder: "Su nombre completo",
      email: "Email",
      emailPlaceholder: "su.email@ejemplo.com",
      phone: "Teléfono",
      phonePlaceholder: "+41 79 123 45 67",
      interest: "Interés",
      interestBuying: "Comprar",
      interestSelling: "Vender",
      interestPlaceholder: "Selecciona tu interés",
      propertyType: "Tipo de Propiedad",
      propertyHouse: "Casa",
      propertyApartment: "Apartamento",
      propertyLand: "Terreno",
      propertyPlaceholder: "Seleccione el tipo",
      budget: "Presupuesto",
      budgetPlaceholder: "Selecciona tu presupuesto",
      budget1to2: "1 – 2 M CHF",
      budget2to3: "2 – 3 M CHF",
      budgetOver3: "Más de 3 M CHF",
      location: "Ubicación/Región",
      locationPlaceholder: "ej. Wädenswil, Zúrich",
      message: "Mensaje (opcional)",
      messagePlaceholder: "Comparta más detalles...",
      consent: "Acepto que mis datos sean compartidos con el agente inmobiliario asociado que manejará la comunicación posterior. He leído y aceptado la política de privacidad.",
      submit: "Enviar Consulta",
      success: "¡Gracias! Nuestro socio se pondrá en contacto pronto.",
      error: "Ocurrió un error. Por favor, inténtelo de nuevo.",
      privacyNotice: "Sus datos serán tratados de forma confidencial y utilizados exclusivamente para el contacto por parte de nuestro agente inmobiliario asociado. La comunicación posterior será directamente con el agente.",
      requiredFields: "Todos los campos marcados con * son obligatorios"
    },
    // Facility Showcase
    facilityShowcase: {
      label: "NUESTRA INSTALACIÓN",
      titleStart: "Infraestructura",
      titleAccent: "de Clase Mundial",
      subtitle: "Descubra instalaciones de pádel de última generación con equipamiento profesional"
    },
    // WhatsApp Community
    whatsappCommunity: {
      title: "Comunidad WhatsApp",
      subtitle: "Mantente al día sobre eventos, torneos y ofertas exclusivas",
      joinBtn: "Unirse Ahora"
    },
    // WhatsApp Bot Gate
    whatsappGate: {
      title: "Abrir WhatsApp",
      body: "Un paso rápido de confirmación — para mantener nuestra comunidad libre de bots.",
      confirm: "Soy humano — Abrir WhatsApp",
      cancel: "Cancelar"
    },
    // Academy Page
    academyPage: {
      label: "PADEL ACADEMY",
      heroTitleStart: "Academia",
      heroTitleEnd: "& Entrenamiento",
      heroSubtitle: "La academia de pádel líder en Suiza con 60+ niños activos y 3 entrenadores profesionales a tiempo completo",
      bookViaWhatsapp: "Reservar vía WhatsApp",
      packagesLabel: "PAQUETES DE ENTRENAMIENTO",
      packagesTitleStart: "Nuestros",
      packagesTitleAccent: "Entrenamientos",
      packagesSubtitle: "Entrenamiento profesional para todos los niveles – desde principiante hasta pro",
      popular: "Popular",
      bookNow: "Reservar Ahora",
      pkg1Title: "Clase Particular",
      pkg1Desc: "Clases 1 a 1 para avanzar rápido en técnica y táctica",
      pkg1Duration: "hora",
      pkg1Feat1: "Instrucciones personalizadas 1 a 1",
      pkg1Feat2: "Horarios flexibles que se adaptan a ti",
      pkg1Feat3: "Ejercicios y plan de juego a medida",
      pkg1PriceNote: "desde",
      pkg2Title: "Entrenamiento Principiantes",
      pkg2Desc: "Lunes y jueves",
      pkg2Duration: "persona",
      pkg2Feat1: "Máx. 4 jugadores en la pista",
      pkg2Feat2: "Metodología analítica y basada en el juego",
      pkg2Feat3: "Material incluido",
      pkg3Title: "Academia Junior",
      pkg3Desc: "Programa especial para niños y adolescentes",
      pkg3Duration: "3 meses",
      pkg3Feat1: "Metodología analítica y basada en el juego",
      pkg3Feat2: "Enfoque recreativo o competitivo",
      pkg3Feat3: "Mejor academia de Suiza",
      pkg3PriceNote: "desde",
      juniorAbos: {
        sectionLabel: "ABONOS JUNIOR ACADEMY",
        sectionTitleStart: "Abonos",
        sectionTitleAccent: "Junior",
        sectionSubtitle: "La temporada empieza siempre en septiembre. Elige el abono que mejor se adapte a tu hijo/a.",
        season: "La temporada empieza en septiembre",
        threeMonthLabel: "ABONO 3 MESES",
        threeMonthTitle: "3 meses de prueba",
        threeMonthDesc: "Perfecto para conocer de verdad la Junior Academy.",
        threeMonthOption1: "1× por semana",
        threeMonthPrice1: "399 CHF",
        yearlyLabel: "ABONO ANUAL",
        yearlyTitle: "Abono anual",
        yearlyDesc: "La temporada completa – el mejor precio por lección.",
        yearlyOption1: "1× por semana",
        yearlyPrice1: "1'299 CHF",
        yearlyOption2: "2× por semana",
        yearlyPrice2: "2'099 CHF",
        popular: "Popular",
        ctaTitle: "¿Listo para empezar?",
        ctaSubtitle: "Reserva tu plaza para la próxima temporada. Escríbenos por WhatsApp – te guiamos.",
        ctaButton: "Inscripción por WhatsApp"
      },
      ageGroupsLabel: "GRUPOS DE EDAD",
      ageGroupsTitleStart: "Entrenamiento para",
      ageGroupsTitleAccent: "Todos",
      age1Name: "Mini Pádel",
      age1Range: "6-8 años",
      age1Level: "Principiante",
      age2Name: "Clases Niños",
      age2Range: "9-12 años",
      age2Level: "Principiante - Avanzado",
      age3Name: "Junior Élite",
      age3Range: "13-17 años",
      age3Level: "Avanzado - Pro",
      age4Name: "Adultos",
      age4Range: "18+ años",
      age4Level: "Todos los niveles",
      coachesTitleStart: "3 Entrenadores",
      coachesTitleAccent: "a Tiempo Completo",
      ctaTitle: "¿Listo para Empezar?",
      ctaSubtitle: "Contáctanos vía WhatsApp y te ayudaremos a encontrar el entrenamiento perfecto",
      juniorTrial: {
        label: "CLASE DE PRUEBA GRATIS",
        juniorsOnly: "Solo para niños y adolescentes (4 a 17 años)",
        title: "Reserva una clase",
        titleAccent: "de prueba gratis",
        subtitle: "Antes de inscribirse en la academia, tu hijo/a puede probar una clase gratis con nuestros entrenadores. Rellena el formulario — te contactaremos en breve.",
        scrollCta: "Reservar clase de prueba",
        formTitle: "Inscripción clase de prueba",
        parentSection: "Datos del padre/madre",
        parentName: "Nombre del padre/madre",
        parentNamePh: "Nombre y apellidos",
        parentEmail: "Email",
        parentEmailPh: "tu.email@ejemplo.com",
        parentPhone: "Teléfono",
        parentPhonePh: "+41 79 123 45 67",
        childSection: "Datos del niño/a",
        childName: "Nombre del niño/a",
        childNamePh: "Nombre",
        childAge: "Edad (años)",
        childAgePh: "ej. 9",
        availabilitySection: "Disponibilidad",
        daysLabel: "¿Qué días entre semana está disponible tu hijo/a?",
        daysHint: "Selección múltiple — el entrenamiento junior es solo de lunes a viernes",
        days: { mon: "Lun", tue: "Mar", wed: "Mié", thu: "Jue", fri: "Vie" },
        timeLabel: "¿A qué hora puede llegar tu hijo/a?",
        timeHint: "El entrenamiento junior se imparte cada hora en punto, de 14:00 a 17:00 (lun–vie)",
        time1400: "14:00",
        time1500: "15:00",
        time1600: "16:00",
        time1700: "17:00",
        experienceSection: "Experiencia con deportes de raqueta",
        expNone: "Sin experiencia",
        expSome: "Algo de experiencia (tenis, squash, bádminton…)",
        expPadel: "Ya juega al pádel",
        expDetailsLabel: "Detalles de la experiencia (opcional)",
        expDetailsPh: "ej. 2 años de tenis en un club",
        notesLabel: "Mensaje / notas (opcional)",
        notesPh: "Alergias, particularidades, deseos…",
        consent: "Acepto que mis datos se utilicen para procesar esta solicitud.",
        privacyNotice: "Tus datos se tratan de forma confidencial y se usan únicamente para contactarte sobre la clase de prueba.",
        requiredFields: "Los campos con * son obligatorios",
        submit: "Solicitar clase de prueba",
        sending: "Enviando",
        successTitle: "Solicitud recibida",
        successMessage: "¡Gracias! Te contactaremos en breve.",
        errorAge: "Esta inscripción es solo para niños y adolescentes de 4 a 17 años.",
        errorDays: "Selecciona al menos un día.",
        errorConsent: "Acepta el uso de datos.",
        errorGeneric: "Algo salió mal. Inténtalo de nuevo."
      }
    },
    // Testimonials
    testimonials: {
      label: "OPINIONES",
      titleStart: "Lo que dice nuestra",
      titleAccent: "comunidad",
      basedOn: "Basado en",
      reviews: "opiniones",
      readAll: "Ver todas las opiniones en Google",
      r1Text: "El mejor club de pádel de la región. Gran ambiente, pistas top y una comunidad increíble. Voy cada semana al mixin y siempre es un planazo.",
      r2Text: "Mis hijos adoran la Junior Academy. Los entrenadores Fabrizio, Antoine y Alejandro están súper comprometidos. Nivel top para Suiza.",
      r3Text: "A solo 20 minutos de Zúrich e instalación absolutamente profesional. 8 pistas indoor, bar deportivo, alquiler de raquetas — todo lo necesario. Muy recomendable.",
      r4Text: "Como principiante me sentí bienvenida desde el primer día. Entrenadores pacientes, buen ambiente. He progresado mucho en pocas semanas.",
      r5Text: "El bar deportivo después del partido es oro. 12 TVs, buenas tapas y siempre gente simpática. No me extraña que Padelarena sea el punto de encuentro.",
      r6Text: "He jugado en muchos clubes — Padelarena es claramente el más bonito de la Suiza alemana. La reserva online funciona perfectamente."
    },
    closurePopup: {
      badge: "¡Volvemos!",
      title: "Reapertura el 19 de septiembre",
      dateRange: "Este finde — sábado 19.9.",
      body: "Ya está — ¡Padelarena reabre este finde! Reserva tu pista online. El primer mixing es ya el martes 22 de septiembre — también reservable en bookpadelarena.ch.",
      bookingHook: "Reserva online en bookpadelarena.ch",
      bookingCta: "Reservar una pista",
      communityHook: "Mantente al día — únete a nuestra comunidad de WhatsApp:",
      cta: "Unirme a la comunidad",
      dismiss: "Cerrar"
    },
    chat: {
      openLabel: "Abrir el chat con nuestro asistente IA",
      closeLabel: "Cerrar chat",
      title: "Asistente Padelarena",
      subtitle: "Pregúntame lo que quieras sobre Padelarena",
      welcome: "¡Hola! Pregúntame lo que quieras sobre Padelarena 👋",
      waLabel: "Abrir WhatsApp",
      waNumber: "+41 79 916 08 34",
      placeholder: "Escribe tu pregunta…",
      sendLabel: "Enviar",
      errorFallback: "Perdona, algo va mal. Escríbenos por WhatsApp: +41 79 916 0834.",
      disclaimer: "Las respuestas de la IA pueden no ser exactas. Para lo importante: WhatsApp +41 79 916 0834."
    }
  }
};
